var wl = Object.defineProperty;
var _l = (e, t, n) => t in e ? wl(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var Te = (e, t, n) => (_l(e, typeof t != "symbol" ? t + "" : t, n), n);
import { j as O } from "./jsx-runtime-944c88e2.js";
import * as l from "react";
import { createElement as cn } from "react";
import { i as zo, f as wn, o as El, p as Il } from "./operators.enum-58ea56cd.js";
import { p } from "./index-efd35e77.js";
import { s as kl } from "./save-as-6eb63bad.js";
import { D as Ol, I as Sl, r as Pl } from "./server.browser-2a8afecd.js";
import { l as Fr, v as ho } from "./index-64063129.js";
import { Button as lr } from "./button.js";
import { Y as Tl, W as Nr, n as Rl, S as Dl } from "./index-c07310bf.js";
import { b as Al, p as Ml, d as Fl, C as ut, A as Ce, a as Li } from "./Popup-b6c9078b.js";
import { S as ji, w as We, x as dt, C as Nl } from "./index-93802845.js";
import { b as Lr, a as jr, c as zi, w as Ll, p as Hi, R as jl, S as zl, T as Bi, U as Gi, V as Qr, W as Hl, X as Bl, s as Gl, x as Ul, m as Ho, n as Bo } from "./index.es-6889c727.js";
import { w as Kl } from "./index-1e1dfdf2.js";
import { Checkbox as Wl } from "./checkbox.js";
import { DropDownList as Vl } from "./dropDownList.js";
import { B as nt } from "./Button-4c83e316.js";
import * as po from "react-dom";
import { createPortal as Ui } from "react-dom";
import { v as Ki, c as ft, p as ql } from "./package-metadata-a152adb8.js";
import { K as je } from "./keys-029ad48d.js";
import { I as Wi } from "./utils-85710523.js";
import { d as $l } from "./dispatchEvent-96624a5c.js";
import { g as Xl } from "./guid-fc0d51fd.js";
import { R as Yl } from "./Reveal-e2f427f6.js";
import { Z as gr } from "./index-b1011fa6.js";
import { z as go, x as Zl, a as Vi, v as Go } from "./index-a0534bb4.js";
import { R as vo } from "./index-7c241c5b.js";
import { d as qi, g as zr, a as $i } from "./auto-scroll-b2de6e53.js";
import { c as Xi, P as Ql } from "./Pager-c55e62fa.js";
import "./Ripple-5a8cf54c.js";
import "./icon.js";
import "./package-metadata-9ad1330d.js";
import "./theme-b013fa81.js";
import "./form-2514c6d8.js";
import "./FormElement-65f04cfd.js";
import "./Label-079ad7bc.js";
import "./package-metadata-3dcf116a.js";
import "./FloatingLabel-922c628f.js";
import "./ButtonGroup-a9850ef0.js";
import "./surface-71c0d1c6.js";
import "./Dialog-a72b336a.js";
import "./form-field-wrapper.hoc-d784197f.js";
import "./Chip-cb37946d.js";
import "./keys-2b65407d.js";
import "./TreeView-aa1ef3e3.js";
import "./Animation-d8a017b3.js";
import "./TransitionGroup-34043d49.js";
import "./ActionSheet-b5bf2237.js";
import "./Animation-154b683d.js";
import "./noop-d627517c.js";
var _n = l.createContext(0);
_n.displayName = "KendoReactZIndexContext";
var Jl = !!// from fbjs
(typeof window < "u" && window.document && window.document.createElement), Yi = function(e) {
  if (e) {
    var t = e.activeElement, n = t == null ? void 0 : t.shadowRoot;
    return n ? n.activeElement : t;
  }
}, Uo = function(e) {
  e.style.transitionDuration = "", Array.from(e.classList).forEach(function(t) {
    t.startsWith("k-slide-") && e.classList.remove(t);
  });
}, es = typeof window < "u" && /Firefox/.test(window.navigator.userAgent), ts = function(e, t, n, r, o) {
  if (n === 0)
    return o();
  var i = "k-slide-" + t + "-" + r, a = i + "-active", s = function(d) {
    d.target === e && (e.removeEventListener("transitionend", s), Uo(e), r === "exit" ? e.style.display = "none" : e.style.display = "", o());
  };
  e.addEventListener("transitionend", s);
  var u = e.ownerDocument;
  if (u) {
    var c = u.defaultView;
    if (c) {
      var f = function() {
        Uo(e), e.classList.add(i), c.requestAnimationFrame(function() {
          e.style.transitionDuration = n + "ms", e.classList.add(a);
        });
      };
      es ? c.requestAnimationFrame(f) : f();
    }
  }
}, rs = 1e3 / 60, ns = function(e, t, n) {
  n === void 0 && (n = {});
  var r, o, i, a, s = 0;
  n = n || {};
  var u = function() {
    s = n.leading === !1 ? 0 : (/* @__PURE__ */ new Date()).getTime(), r = void 0, a = e.apply(o, i), r || (o = i = null);
  }, c = function() {
    var f = (/* @__PURE__ */ new Date()).getTime();
    !s && n.leading === !1 && (s = f);
    var d = t - (f - s);
    return o = void 0, i = arguments, d <= 0 || d > t ? (r && (clearTimeout(r), r = void 0), s = f, a = e.apply(o, i), r || (o = i = null)) : !r && n.trailing !== !1 && (r = window.setTimeout(u, d)), a;
  };
  return c;
}, os = {
  name: "@progress/kendo-react-popup",
  productName: "KendoReact",
  productCodes: ["KENDOUIREACT", "KENDOUICOMPLETE"],
  publishDate: 1686225147,
  version: "",
  licensingDocsUrl: "https://www.telerik.com/kendo-react-ui/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-warning"
}, is = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), xe = globalThis && globalThis.__assign || function() {
  return xe = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, xe.apply(this, arguments);
}, as = 100, ls = 1;
function zt(e, t) {
  if (e === t)
    return !0;
  if (!!e != !!t)
    return !1;
  var n = Object.getOwnPropertyNames(e), r = Object.getOwnPropertyNames(t);
  if (n.length !== r.length)
    return !1;
  for (var o = 0; o < n.length; o++) {
    var i = n[o];
    if (e[i] !== t[i])
      return !1;
  }
  return !0;
}
var ss = {
  left: -1e3,
  top: 0
}, q;
(function(e) {
  e.hiding = "hiding", e.hidden = "hidden", e.showing = "showing", e.shown = "shown", e.reposition = "reposition";
})(q || (q = {}));
var us = "k-animation-container", Ko = "k-animation-container-shown", cs = "k-animation-container-relative", fs = "k-child-animation-container", ds = "k-popup", hs = (
  /** @class */
  function(e) {
    is(t, e);
    function t(n) {
      var r = e.call(this, n) || this;
      return r.context = 0, r.state = { current: q.hidden, previous: q.hidden, props: {} }, r._popup = null, r.show = function(o) {
        r.setPosition(o), r.animate(o.firstChild, "enter", r.onOpened), r.setState({ current: q.shown, previous: r.state.current });
      }, r.setPosition = function(o) {
        var i = r.props, a = i.anchorAlign, s = i.popupAlign, u = i.collision, c = i.offset, f = i.anchor, d = i.margin, h = i.scale, m = i.positionMode, g = o.style, y = g.width, w = g.height;
        o.style.width = o.offsetWidth + "px", o.style.height = o.offsetHeight + "px";
        var x = Al({
          anchor: f,
          anchorAlign: a,
          element: o,
          elementAlign: s,
          offset: c,
          margin: d,
          positionMode: m,
          scale: h
        }), b = Ml({
          anchor: f,
          anchorAlign: a,
          element: o,
          elementAlign: s,
          collisions: u,
          currentLocation: x,
          margin: r.props.margin
        });
        if (o.style.top = b.offset.top + "px", o.style.left = b.offset.left + "px", o.style.width = y, o.style.height = w, r._collisions = {
          fit: b.fit,
          fitted: b.fitted,
          flip: b.flip,
          flipped: b.flipped
        }, r.props.onPosition) {
          var C = {
            target: r,
            flipped: b.flipped,
            fitted: b.fitted
          };
          r.props.onPosition.call(void 0, C);
        }
      }, r.onOpened = function() {
        var o = r._popup;
        o && (r.props.show && o.classList.add(Ko), r.attachRepositionHandlers(o), r.props.onOpen && r.props.onOpen.call(void 0, { target: r }));
      }, r.animate = function(o, i, a) {
        if (r.props.popupAlign) {
          var s, u = r.props.popupAlign, c = u.horizontal, f = u.vertical;
          c === "left" && f === "center" ? s = "right" : c === "right" && f === "center" ? s = "left" : f === "top" ? s = "down" : s = "up";
          var d = {
            down: "up",
            up: "down",
            left: "right",
            right: "left"
          };
          r._collisions && r._collisions.flipped && (s = d[s]), ts(o, s, r.animationDuration[i], i, a);
        }
      }, r.onClosing = function(o) {
        r.props.show || o.classList.remove(Ko), r.detachRepositionHandlers();
      }, r.onClosed = function() {
        r.state.current === q.hiding && r.state.previous === q.shown && r.setState({ current: q.hidden, previous: r.state.current }), r.props.onClose && r.props.onClose.call(void 0, { target: r });
      }, r.getCurrentZIndex = function() {
        return r.context ? r.context + ls : as;
      }, Ki(os), r.reposition = ns(r.reposition.bind(r), rs), r;
    }
    return Object.defineProperty(t.prototype, "element", {
      /**
       * Represents the Popup DOM element.
       */
      get: function() {
        return this._popup;
      },
      enumerable: !1,
      configurable: !0
    }), t.getDerivedStateFromProps = function(n, r) {
      var o = n.show, i = n.anchor, a = n.anchorAlign, s = n.appendTo, u = n.collision, c = n.popupAlign, f = n.className, d = n.popupClass, h = n.style, m = n.offset, g = n.contentKey, y = xe(xe({}, r), { props: {
        show: o,
        anchor: i,
        anchorAlign: a,
        appendTo: s,
        collision: u,
        popupAlign: c,
        className: f,
        popupClass: d,
        style: h,
        offset: m,
        contentKey: g
      } });
      return n.show ? r.current === q.hidden || r.current === q.hiding ? xe(xe({}, y), { current: q.showing, previous: r.current }) : r.current === q.showing ? xe(xe({}, y), { current: q.shown, previous: r.current }) : r.current === q.shown && (!zt(m, r.props.offset) || !zt(a, r.props.anchorAlign) || !zt(s, r.props.appendTo) || !zt(u, r.props.collision) || !zt(c, r.props.popupAlign) || !zt(h, r.props.style) || i !== r.props.anchor || d !== r.props.popupClass || f !== r.props.className) ? xe(xe({}, y), { current: q.reposition, previous: r.current }) : y : r.current === q.hiding || r.current === q.hidden ? xe(xe({}, y), { current: q.hidden, previous: r.current }) : xe(xe({}, y), { current: q.hiding, previous: r.current });
    }, t.prototype.componentDidUpdate = function(n) {
      this.state.current === q.showing && this._popup ? this.show(this._popup) : this.state.current === q.hiding && this._popup ? (this.onClosing(this._popup), this.animate(this._popup.firstChild, "exit", this.onClosed)) : this.state.current === q.reposition && this.state.previous === q.shown ? this.setState({ current: q.shown, previous: this.state.current }) : this.state.current === q.shown && n.contentKey !== this.props.contentKey && this._popup && this.setPosition(this._popup);
    }, t.prototype.componentDidMount = function() {
      this.state.current === q.showing && this._popup && this.show(this._popup);
    }, t.prototype.componentWillUnmount = function() {
      this.detachRepositionHandlers();
    }, t.prototype.render = function() {
      var n = this, r = this.props, o = r.children, i = r.className, a = r.popupClass, s = r.show, u = r.id, c = r.positionMode, f = this.props.appendTo ? this.props.appendTo : Jl ? this.props.anchor && this.props.anchor.ownerDocument ? this.props.anchor.ownerDocument.body : document.body : void 0;
      this.state.current === q.reposition && this.state.previous === q.shown && this._popup && this.setPosition(this._popup);
      var d = Object.assign({}, { position: c, top: 0, left: -1e4 }, this.props.style || {}), h = this.state.current === q.hiding;
      if ((s || h) && f) {
        var m = this.getCurrentZIndex(), g = l.createElement(
          _n.Provider,
          { value: m },
          l.createElement(
            "div",
            { className: ft(us, cs, i), id: u, ref: function(y) {
              return n._popup = y;
            }, style: xe({ zIndex: m }, d) },
            l.createElement("div", { role: this.props.role, className: ft(ds, a, fs), style: { transitionDelay: "0ms" } }, o)
          )
        );
        return this.props.appendTo !== null ? po.createPortal(g, f) : g;
      }
      return null;
    }, Object.defineProperty(t.prototype, "animationDuration", {
      get: function() {
        var n = this.props.animate, r = 0, o = 0;
        return n && (n === !0 ? r = o = 300 : (r = n.openDuration || 0, o = n.closeDuration || 0)), { enter: r, exit: o };
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.attachRepositionHandlers = function(n) {
      var r = this;
      this.detachRepositionHandlers(), this._scrollableParents = Fl.scrollableParents(this.props.anchor || n), this._scrollableParents && this._scrollableParents.map(function(o) {
        return o.addEventListener("scroll", r.reposition);
      }), window.addEventListener("resize", this.reposition);
    }, t.prototype.detachRepositionHandlers = function() {
      var n = this;
      this._scrollableParents && (this._scrollableParents.map(function(r) {
        return r.removeEventListener("scroll", n.reposition);
      }), this._scrollableParents = void 0), window.removeEventListener("resize", this.reposition);
    }, t.prototype.reposition = function() {
      this.setState({ current: q.reposition, previous: this.state.current });
    }, t.propTypes = {
      anchor: function(n) {
        var r = n.anchor;
        return r && typeof r.nodeType != "number" ? new Error("Invalid prop `anchor` supplied to `Kendo React Popup`. Validation failed.") : null;
      },
      appendTo: function(n) {
        var r = n.appendTo;
        return r && typeof r.nodeType != "number" ? new Error("Invalid prop `appendTo` supplied to `Kendo React Popup`. Validation failed.") : null;
      },
      className: p.oneOfType([
        p.string,
        p.arrayOf(p.string),
        p.object
      ]),
      id: p.string,
      popupClass: p.oneOfType([
        p.string,
        p.arrayOf(p.string),
        p.object
      ]),
      collision: p.shape({
        horizontal: p.oneOf([
          ut.fit,
          ut.flip,
          ut.none
        ]),
        vertical: p.oneOf([
          ut.fit,
          ut.flip,
          ut.none
        ])
      }),
      anchorAlign: p.shape({
        horizontal: p.oneOf([
          Ce.left,
          Ce.center,
          Ce.right
        ]),
        vertical: p.oneOf([
          Ce.top,
          Ce.center,
          Ce.bottom
        ])
      }),
      popupAlign: p.shape({
        horizontal: p.oneOf([
          Ce.left,
          Ce.center,
          Ce.right
        ]),
        vertical: p.oneOf([
          Ce.top,
          Ce.center,
          Ce.bottom
        ])
      }),
      offset: p.shape({
        left: p.number,
        top: p.number
      }),
      children: p.oneOfType([
        p.element,
        p.node
      ]),
      show: p.bool,
      animate: p.oneOfType([
        p.bool,
        p.shape({
          openDuration: p.number,
          closeDuration: p.number
        })
      ]),
      margin: p.shape({
        horizontal: p.number,
        vertical: p.number
      }),
      positionMode: p.oneOf([
        "fixed",
        "absolute"
      ]),
      scale: p.number,
      style: p.object,
      onClose: p.func,
      onPosition: p.func,
      onOpen: p.func
    }, t.defaultProps = {
      collision: {
        horizontal: ut.fit,
        vertical: ut.flip
      },
      anchorAlign: {
        horizontal: Ce.left,
        vertical: Ce.bottom
      },
      popupAlign: {
        horizontal: Ce.left,
        vertical: Ce.top
      },
      offset: ss,
      animate: !0,
      show: !1,
      margin: {
        horizontal: 0,
        vertical: 0
      },
      positionMode: "absolute"
    }, t.contextType = _n, t.displayName = "PopupComponent", t;
  }(l.Component)
), En = globalThis && globalThis.__assign || function() {
  return En = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, En.apply(this, arguments);
}, ps = l.createContext(function(e) {
  return e;
}), mo = l.forwardRef(function(e, t) {
  var n = l.useContext(ps), r = n.call(void 0, e);
  return l.createElement(hs, En({ ref: t }, r));
});
mo.displayName = "Popup";
var Re = "", Jr = "0", at = "_";
function sr(e, t) {
  if (ze(e))
    return t[Number(e)];
  var n = t[Number(Ut(e))];
  return n.items ? sr(gs(e), n.items) : void 0;
}
function Ut(e) {
  return Kt(e) ? e : e.split(at)[0];
}
function gs(e) {
  if (Kt(e))
    return e;
  var t = e.indexOf(at);
  return e.substring(t + 1);
}
function Wo(e) {
  return en("0", e);
}
function vs(e, t) {
  return t.indexOf(e) === 0 ? t.length === e.length || t.charAt(e.length) === at : !1;
}
function en(e, t) {
  return t ? t + at + e : e;
}
function Gt(e) {
  var t = e.lastIndexOf(at);
  return t < 0 ? Re : e.substring(0, t);
}
function Kt(e) {
  return e === Re || e.indexOf(at) < 0;
}
function ze(e) {
  return e !== Re && e.indexOf(at) < 0;
}
function ms(e) {
  return Cs(e) === 1;
}
function ys(e) {
  return In(e) === Jr;
}
function In(e) {
  var t = e.lastIndexOf(at);
  return t < 0 ? e : e.substring(t + 1);
}
function Vo(e, t, n) {
  return ze(t) ? e ? Number(t) < n - 1 ? (Number(t) + 1).toString() : "0" : Number(t) > 0 ? (Number(t) - 1).toString() : (n - 1).toString() : t;
}
function Cs(e) {
  return e.split(at).length - 1;
}
var qo = {
  vertical: "top",
  horizontal: "left"
}, $o = {
  vertical: "top",
  horizontal: "right"
}, Zi = {
  vertical: "flip",
  horizontal: "fit"
}, Qi = {
  vertical: "fit",
  horizontal: "flip"
}, Xo = {
  downward: {
    anchorAlign: {
      vertical: "bottom",
      horizontal: "right"
    },
    popupAlign: $o,
    collision: Zi
  },
  leftward: {
    anchorAlign: {
      vertical: "top",
      horizontal: "left"
    },
    popupAlign: $o,
    collision: Qi
  }
}, Yo = {
  downward: {
    anchorAlign: {
      vertical: "bottom",
      horizontal: "left"
    },
    popupAlign: qo,
    collision: Zi
  },
  rightward: {
    anchorAlign: {
      vertical: "top",
      horizontal: "right"
    },
    popupAlign: qo,
    collision: Qi
  }
};
function bs(e, t, n) {
  var r = Ji(e, t, n);
  return n ? r === "downward" ? Xo.downward : Xo.leftward : r === "downward" ? Yo.downward : Yo.rightward;
}
function Ji(e, t, n) {
  return ze(e) ? t ? n ? "leftward" : "rightward" : "downward" : n ? "leftward" : "rightward";
}
function Zo(e) {
  return e ? "rtl" : "ltr";
}
function kn(e, t) {
  return "".concat(e, "_").concat(t);
}
var xs = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), ws = (
  /** @class */
  function(e) {
    xs(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.render = function() {
      return this.props.url ? l.createElement("a", { className: this.getMenuItemClassName(), role: "presentation", href: this.props.url, tabIndex: -1 }, this.props.children) : l.createElement("span", { id: this.props.id, className: ft(this.getMenuItemClassName(), this.props.className), style: this.props.style, role: "presentation" }, this.props.children);
    }, t.prototype.getMenuItemClassName = function() {
      return ft("k-link", "k-menu-link", {
        "k-active": this.props.opened
      });
    }, t.propTypes = {
      opened: p.bool,
      url: p.string
    }, t;
  }(l.Component)
), _s = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), On = globalThis && globalThis.__assign || function() {
  return On = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, On.apply(this, arguments);
}, Es = "caret-alt-down", Is = "caret-alt-right", ks = "caret-alt-left", Os = (
  /** @class */
  function(e) {
    _s(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.render = function() {
      return l.createElement(Wi, On({ "aria-hidden": !0, className: "k-menu-expand-arrow" }, this.getIcon()));
    }, t.prototype.getIcon = function() {
      var n = Ji(this.props.itemId, this.props.verticalMenu === !0, this.props.dir === "rtl");
      switch (n) {
        case "downward":
          return { name: Es, icon: zi };
        case "rightward":
          return { name: Is, icon: jr };
        case "leftward":
          return { name: ks, icon: Lr };
        default:
          return {};
      }
    }, t.propTypes = {
      itemId: p.string,
      dir: p.string,
      verticalMenu: p.bool
    }, t;
  }(l.Component)
), Ss = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Ps = (
  /** @class */
  function(e) {
    Ss(t, e);
    function t(n) {
      var r = e.call(this, n) || this;
      return r.isFirstRender = !0, r.onMouseOver = function(o) {
        r.props.onMouseOver(r.props.item.id), o.stopPropagation();
      }, r.onMouseLeave = function(o) {
        r.props.onMouseLeave(r.props.item.id), o.stopPropagation();
      }, r.state = { opened: !1 }, r;
    }
    return t.prototype.componentDidMount = function() {
      var n = this.props.focusedItemId, r = this.props.item.id;
      n && n === r && this.itemElement.focus(), this.isFirstRender = !1;
    }, t.prototype.componentDidUpdate = function(n) {
      var r = this.props.focusedItemId, o = this.props.item.id;
      if (r) {
        var i = Yi(document);
        n.focusedItemId !== r && r === o && !this.itemElement.contains(i) && this.itemElement.focus();
      }
    }, t.prototype.render = function() {
      var n = this, r = this.props.item, o = r.id, i = kn(this.props.menuGuid, o);
      return l.createElement(
        l.Fragment,
        null,
        l.createElement("li", { id: kn(this.props.menuGuid, o), className: this.getMenuItemClassName(r), style: r.cssStyle, tabIndex: o === this.props.tabbableItemId ? 0 : -1, onMouseOver: this.onMouseOver, onMouseLeave: this.onMouseLeave, onMouseDown: function(a) {
          return n.props.onMouseDown(a);
        }, onBlur: function(a) {
          return n.props.onBlur(o, a);
        }, onFocus: function() {
          return n.props.onFocus(o);
        }, onClick: function(a) {
          return n.props.onClick(a, o);
        }, role: "menuitem", "aria-disabled": r.disabled ? !0 : void 0, "aria-haspopup": r.items.length > 0 ? !0 : void 0, "aria-expanded": r.items.length > 0 ? this.Opened : void 0, "aria-label": r.text, "aria-owns": this.Opened ? i : void 0, ref: function(a) {
          return n.itemElement = a;
        }, key: "0" }, this.contentRender ? this.renderContent() : this.renderMenuItemLink()),
        this.renderPopupIfOpened()
      );
    }, t.prototype.renderContent = function() {
      var n = this.props.item.contentParentItemId;
      return l.createElement(
        "div",
        { className: "k-content", role: "presentation" },
        l.createElement(this.contentRender, { item: this.props.onOriginalItemNeeded(n), itemId: n })
      );
    }, t.prototype.renderMenuItemLink = function() {
      var n = this.props.item;
      if (this.linkRender)
        return l.createElement(this.linkRender, { item: this.props.onOriginalItemNeeded(n.id), itemId: n.id, opened: this.Opened, dir: Zo(this.props.isDirectionRightToLeft) });
      var r = this.itemRender ? l.createElement(this.itemRender, { item: this.props.onOriginalItemNeeded(n.id), itemId: n.id, key: "1" }) : l.createElement("span", { className: "k-menu-link-text" }, n.text);
      return l.createElement(
        ws,
        { url: n.url, opened: this.Opened },
        this.renderMenuIconIfApplicable(),
        r,
        this.renderArrowIfApplicable()
      );
    }, t.prototype.renderPopupIfOpened = function() {
      if (this.Opened) {
        var n = this.props.item.id, r = bs(n, this.props.isMenuVertical, this.props.isDirectionRightToLeft), o = r.anchorAlign, i = r.popupAlign, a = r.collision;
        return l.createElement(
          mo,
          { anchor: this.itemElement, show: !0, popupClass: this.getPopupClassName(), anchorAlign: o, popupAlign: i, collision: a, animate: !1, key: "1" },
          l.createElement(ea, { parentItemId: n, items: this.props.item.items, menuGuid: this.props.menuGuid, focusedItemId: this.props.focusedItemId, lastItemIdToBeOpened: this.props.lastItemIdToBeOpened, tabbableItemId: this.props.tabbableItemId, itemRender: this.props.itemRender, linkRender: this.props.linkRender, isMenuVertical: this.props.isMenuVertical, isDirectionRightToLeft: this.props.isDirectionRightToLeft, className: "k-group k-menu-group k-reset k-menu-group-md", onMouseOver: this.props.onMouseOver, onMouseLeave: this.props.onMouseLeave, onMouseDown: this.props.onMouseDown, onBlur: this.props.onBlur, onFocus: this.props.onFocus, onClick: this.props.onClick, onOriginalItemNeeded: this.props.onOriginalItemNeeded })
        );
      } else
        return null;
    }, t.prototype.renderMenuIconIfApplicable = function() {
      var n = this.props.item, r = n.icon, o = n.svgIcon;
      return r || o ? l.createElement(Wi, { name: r, icon: o, key: "0" }) : null;
    }, t.prototype.renderArrowIfApplicable = function() {
      return this.props.item.items.length > 0 ? l.createElement(Os, { itemId: this.props.item.id, verticalMenu: this.props.isMenuVertical, dir: Zo(this.props.isDirectionRightToLeft), key: "2" }) : null;
    }, Object.defineProperty(t.prototype, "itemRender", {
      get: function() {
        return this.props.item.render || this.props.itemRender;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "linkRender", {
      get: function() {
        return this.props.item.linkRender || this.props.linkRender;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "contentRender", {
      get: function() {
        return this.props.item.contentParentItemId ? this.props.item.contentRender : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "Opened", {
      get: function() {
        var n = this.props;
        return n.item.items.length > 0 && vs(n.item.id, n.lastItemIdToBeOpened) && // HACK: Wait for the second render because otherwise the scenario of
        // popup inside popup throws an error (for example, hover of item with id '0_0').
        !this.isFirstRender;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.getPopupClassName = function() {
      return ft("k-menu-popup", { "k-rtl": this.props.isDirectionRightToLeft });
    }, t.prototype.getMenuItemClassName = function(n) {
      return ft("k-item", "k-menu-item", {
        "k-first": ys(n.id),
        "k-last": n.isLastFromSiblings,
        "k-disabled": n.disabled
      }, n.cssClass);
    }, t;
  }(l.Component)
), Ts = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), ea = (
  /** @class */
  function(e) {
    Ts(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.onMouseOver = function(r) {
        n.props.onMouseOver(n.props.parentItemId), r.stopPropagation();
      }, n.onMouseLeave = function(r) {
        n.props.onMouseLeave(n.props.parentItemId), r.stopPropagation();
      }, n;
    }
    return t.prototype.render = function() {
      var n = this.props.parentItemId;
      return l.createElement("ul", { className: this.props.className, role: this.props.role ? this.props.role : n !== void 0 ? "menu" : "menubar", id: n !== void 0 ? kn(this.props.menuGuid, n) : void 0, onMouseOver: n !== void 0 ? this.onMouseOver : void 0, onMouseLeave: n !== void 0 ? this.onMouseLeave : void 0, "aria-orientation": this.props["aria-orientation"] }, this.renderChildItems());
    }, t.prototype.renderChildItems = function() {
      var n = this;
      return this.props.items.length > 0 ? this.props.items.map(function(r, o) {
        return l.createElement(Ps, { item: r, isMenuVertical: n.props.isMenuVertical, isDirectionRightToLeft: n.props.isDirectionRightToLeft, focusedItemId: n.props.focusedItemId, lastItemIdToBeOpened: n.props.lastItemIdToBeOpened, tabbableItemId: n.props.tabbableItemId, itemRender: n.props.itemRender, linkRender: n.props.linkRender, menuGuid: n.props.menuGuid, onMouseOver: n.props.onMouseOver, onMouseLeave: n.props.onMouseLeave, onMouseDown: n.props.onMouseDown, onBlur: n.props.onBlur, onFocus: n.props.onFocus, onClick: n.props.onClick, onOriginalItemNeeded: n.props.onOriginalItemNeeded, key: o });
      }) : null;
    }, t;
  }(l.Component)
), Rs = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), ta = (
  /** @class */
  function(e) {
    Rs(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.render = function() {
      return null;
    }, t.propTypes = {
      text: p.string,
      url: p.string,
      icon: p.string,
      disabled: p.bool,
      cssClass: p.string,
      cssStyle: p.object,
      render: p.any,
      linkRender: p.any,
      contentRender: p.any,
      data: p.any
    }, t;
  }(l.Component)
);
function Ds(e, t) {
  if (e && e.length > 0)
    return {
      items: Pn(e),
      inputItems: e
    };
  if (Sn(t).length > 0) {
    var n = na(Sn(t));
    return { items: Pn(n), inputItems: n };
  } else
    return { items: [], inputItems: [] };
}
function ra(e, t) {
  var n = {}, r = e || t.props, o = r.text, i = r.url, a = r.icon, s = r.svgIcon, u = r.disabled, c = r.cssClass, f = r.cssStyle, d = r.render, h = r.linkRender, m = r.contentRender, g = r.data;
  return o !== void 0 && (n.text = o), i !== void 0 && (n.url = i), a !== void 0 && (n.icon = a), s !== void 0 && (n.svgIcon = s), u !== void 0 && (n.disabled = u), c !== void 0 && (n.cssClass = c), f !== void 0 && (n.cssStyle = f), d !== void 0 && (n.render = d), h !== void 0 && (n.linkRender = h), m !== void 0 && (n.contentRender = m), g !== void 0 && (n.data = g), n;
}
function Sn(e) {
  return l.Children.toArray(e).filter(function(t) {
    return t && t.type === ta;
  });
}
function na(e) {
  for (var t = [], n = 0; n < e.length; n++) {
    var r = e[n], o = ra(void 0, r), i = na(Sn(r.props.children));
    i.length > 0 && (o.items = i), t.push(o);
  }
  return t;
}
function Pn(e, t) {
  for (var n = [], r = 0; r < e.length; r++) {
    var o = e[r], i = ra(o);
    i.id = en(r.toString(), t), i.isLastFromSiblings = r === e.length - 1, i.items = As(o, i), n.push(i);
  }
  return n;
}
function As(e, t) {
  return e.contentRender ? [{
    contentParentItemId: t.id,
    id: en(Jr, t.id),
    isLastFromSiblings: !0,
    contentRender: e.contentRender,
    items: []
  }] : e.items ? Pn(e.items, t.id) : [];
}
var Ms = /\S/;
function Fs(e, t, n, r, o, i) {
  var a = k();
  switch (n) {
    case je.left:
      return s();
    case je.right:
      return u();
    case je.up:
      return f();
    case je.down:
      return c();
    case je.enter:
    case je.space:
      return d();
    case je.home:
      return h();
    case je.end:
      return m();
    case je.esc:
      return g();
    default:
      return _() ? y() : t;
  }
  function s() {
    return o ? i ? C() : x() : i ? b() : w();
  }
  function u() {
    return o ? i ? x() : C() : i ? w() : b();
  }
  function c() {
    return o ? B() : ze(t) ? S() : B();
  }
  function f() {
    return o ? L() : ze(t) ? T() : L();
  }
  function d() {
    return a.disabled ? t : H() ? Wo(t) : Ut(t);
  }
  function h() {
    return G()[0].id;
  }
  function m() {
    var D = G();
    return D[D.length - 1].id;
  }
  function g() {
    return ze(t) ? t : Gt(t);
  }
  function y() {
    var D = r.toLowerCase(), N = G(), E = Number(In(t)), j = N.slice(E + 1).concat(N.slice(0, E + 1)), X = j.find(function(se) {
      return (se.text || "").toLowerCase().startsWith(D);
    });
    return X ? X.id : t;
  }
  function w() {
    return ze(t) ? L() : ms(t) ? S(L(Ut(t))) : Gt(t);
  }
  function x() {
    return ze(t) ? T() : Gt(t);
  }
  function b() {
    return ze(t) ? B() : S(H() ? t : B(Ut(t)));
  }
  function C() {
    return S(ze(t) || H() ? t : B(Ut(t)));
  }
  function S(D) {
    return Z(!0, D);
  }
  function T(D) {
    return Z(!1, D);
  }
  function _() {
    return r.length === 1 && Ms.test(r);
  }
  function k(D, N) {
    return D === void 0 && (D = t), N === void 0 && (N = e), sr(D, N);
  }
  function H(D) {
    return k(D).items.length > 0;
  }
  function L(D) {
    return ee(!1, D);
  }
  function B(D) {
    return ee(!0, D);
  }
  function F(D) {
    var N = k(D).items;
    return N[N.length - 1].id;
  }
  function G() {
    return ze(t) ? e : k(Gt(t), e).items;
  }
  function Z(D, N) {
    N === void 0 && (N = t);
    var E = k(N);
    return H(N) && !E.disabled ? D ? Wo(N) : F(N) : N;
  }
  function ee(D, N) {
    if (N === void 0 && (N = t), ze(N))
      return Vo(D, N, e.length);
    var E = Gt(N), j = In(N), X = k(E).items.length;
    return en(Vo(D, j, X), E);
  }
}
function Ns(e) {
  return e.hoverOpenDelay !== void 0 ? e.hoverOpenDelay : e.openOnClick ? 0 : 100;
}
function Ls(e) {
  return e.hoverCloseDelay !== void 0 ? e.hoverCloseDelay : 100;
}
var js = (
  /** @class */
  function() {
    function e() {
      this.phase = "Initialized";
    }
    return e.prototype.getIsDirectionRightToLeft = function() {
      return this.isDirectionRightToLeft;
    }, e.prototype.setIsDirectionRightToLeft = function(t) {
      this.phase = this.phase === "NotInitialized" ? "Initialized" : "NewValueReceived", this.previousIsDirectionRightToLeft = this.isDirectionRightToLeft, this.isDirectionRightToLeft = t;
    }, e.prototype.hasDirectionChanged = function() {
      return this.phase === "NewValueReceived" ? this.previousIsDirectionRightToLeft !== this.isDirectionRightToLeft : !1;
    }, e;
  }()
), zs = (
  /** @class */
  function() {
    function e(t, n, r) {
      this.openOnClick = t, this.resetMenu = n, this.openItem = r, this.mouseDown = !1, this.openOnClick = t, this.isMouseOverEnabled = !t;
    }
    return Object.defineProperty(e.prototype, "OpenOnClick", {
      set: function(t) {
        !!t != !!this.openOnClick && (this.mouseDown = !1, this.isMouseOverEnabled = !t), this.openOnClick = t;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.handleItemSelectedViaKeyboard = function() {
      this.openOnClick && (this.isMouseOverEnabled = !1, this.resetMenu());
    }, Object.defineProperty(e.prototype, "IsMouseOverEnabled", {
      get: function() {
        return this.isMouseOverEnabled;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.handleItemMouseDown = function() {
      this.mouseDown = !0;
    }, e.prototype.handleItemFocus = function() {
      this.openOnClick && !this.mouseDown && (this.isMouseOverEnabled = !0), this.mouseDown = !1;
    }, e.prototype.handleItemClick = function(t, n) {
      this.openOnClick && (this.isMouseOverEnabled ? n && (this.isMouseOverEnabled = !1, this.resetMenu()) : (this.isMouseOverEnabled = !0, this.openItem(t)));
    }, e;
  }()
), Hs = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Qo = {
  focusedItemId: Re,
  hoveredItemId: Re,
  tabbableItemId: Jr
}, Bs = (
  /** @class */
  function(e) {
    Hs(t, e);
    function t(n) {
      var r = e.call(this, n) || this;
      return r.menuWrapperEl = null, r.guid = Xl(), r.directionHolder = new js(), r.inputItems = [], r.items = [], r.reset = function() {
        r.clearItemHoverAndLeaveRequestsIfApplicable(), r.setState(Qo);
      }, r.onKeyDown = function(o) {
        if (r.state.focusedItemId !== Re) {
          var i = sr(r.state.focusedItemId, r.items), a = Fs(r.items, i.id, o.keyCode, o.key, r.props.vertical, r.directionHolder.getIsDirectionRightToLeft());
          i.id !== a && (o.preventDefault(), r.setFocusedItemId(a)), (o.keyCode === je.enter || o.keyCode === je.space) && !i.disabled && (r.mouseOverHandler.handleItemSelectedViaKeyboard(), r.dispatchSelectEventIfWired(o, i.id), !o.isDefaultPrevented() && i.items.length === 0 && i.url && window.location.assign(i.url));
        }
        o.keyCode === je.esc && r.props.onClose && r.props.onClose.call(void 0, o);
      }, r.onItemMouseOver = function(o) {
        r.mouseOverHandler.IsMouseOverEnabled && (r.clearItemHoverAndLeaveRequestsIfApplicable(), r.itemHoverRequest = window.setTimeout(function() {
          r.setHoveredItemId(o), r.itemHoverRequest = null;
        }, Ns(r.props)));
      }, r.onItemMouseLeave = function(o) {
        r.mouseOverHandler.IsMouseOverEnabled && r.isItemWithDefaultClose(o) && (r.clearItemHoverAndLeaveRequestsIfApplicable(), r.itemLeaveRequest = window.setTimeout(function() {
          r.setHoveredItemId(Re), r.itemLeaveRequest = null;
        }, Ls(r.props)));
      }, r.onItemMouseDown = function() {
        r.mouseOverHandler.handleItemMouseDown();
      }, r.onItemFocus = function(o) {
        r.setFocusedItemId(o), r.mouseOverHandler.handleItemFocus();
      }, r.onItemClick = function(o, i) {
        var a = sr(i, r.items);
        a.disabled || (r.setFocusedItemId(i), r.mouseOverHandler.handleItemClick(i, r.isItemWithDefaultClose(i)), r.dispatchSelectEventIfWired(o, i), !o.isDefaultPrevented() && a.url && window.location.assign(a.url));
      }, r.onItemBlur = function(o, i) {
        if (r.isItemWithDefaultClose(o) && r.setFocusedItemId(Re), i.relatedTarget && i.relatedTarget.nodeName === "LI") {
          var a = i.relatedTarget.getAttribute("id");
          if (a && a.includes(r.guid))
            return;
        }
        r.props.onClose && r.props.onClose.call(void 0, i);
      }, r.getInputItem = function(o) {
        return sr(o, r.inputItems);
      }, Ki(ql), r.mouseOverHandler = new zs(r.props.openOnClick, r.reset, r.onItemMouseOver), r.state = Object.assign({}, Qo, { isFirstRender: !0 }), r;
    }
    return Object.defineProperty(t.prototype, "element", {
      get: function() {
        return this.menuWrapperEl;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.render = function() {
      var n = this;
      this.prepareItems(), this.state.isFirstRender || this.directionHolder.setIsDirectionRightToLeft(this.checkIsDirectionRightToLeft());
      var r = this.state.hoveredItemId ? this.state.hoveredItemId : this.state.focusedItemId ? Gt(this.state.focusedItemId) : Re;
      return l.createElement(
        "div",
        { onKeyDown: this.onKeyDown, style: this.props.style, className: this.directionHolder.getIsDirectionRightToLeft() ? "k-rtl" : void 0, ref: function(o) {
          return n.menuWrapperEl = o;
        } },
        l.createElement(ea, { className: this.getMenuClassName(), "aria-orientation": this.props.vertical ? "vertical" : void 0, items: this.items, isMenuVertical: this.props.vertical, isDirectionRightToLeft: this.directionHolder.getIsDirectionRightToLeft(), focusedItemId: this.state.focusedItemId, lastItemIdToBeOpened: r, tabbableItemId: this.state.tabbableItemId, itemRender: this.props.itemRender, linkRender: this.props.linkRender, menuGuid: this.guid, onMouseLeave: this.onItemMouseLeave, onMouseOver: this.onItemMouseOver, onMouseDown: this.onItemMouseDown, onFocus: this.onItemFocus, onClick: this.onItemClick, onBlur: this.onItemBlur, onOriginalItemNeeded: this.getInputItem, role: this.props.role })
      );
    }, t.prototype.componentDidMount = function() {
      this.setState({ isFirstRender: !1 });
    }, t.prototype.componentDidUpdate = function(n) {
      (!!n.vertical != !!this.props.vertical || this.directionHolder.hasDirectionChanged()) && this.reset(), this.mouseOverHandler.OpenOnClick = this.props.openOnClick;
    }, t.prototype.componentWillUnmount = function() {
      this.clearItemHoverAndLeaveRequestsIfApplicable();
    }, t.prototype.setFocusedItemId = function(n) {
      this.setState(function(r) {
        var o = n === Re ? r.tabbableItemId : Ut(n), i = n === Re || Kt(r.hoveredItemId) && Kt(n) ? r.hoveredItemId : Re;
        return { hoveredItemId: i, focusedItemId: n, tabbableItemId: o };
      });
    }, t.prototype.setHoveredItemId = function(n) {
      this.setState(function(r) {
        return Kt(n) && Kt(r.focusedItemId) ? {
          hoveredItemId: n,
          focusedItemId: r.focusedItemId,
          tabbableItemId: r.tabbableItemId
        } : { hoveredItemId: n, focusedItemId: Re, tabbableItemId: Jr };
      });
    }, t.prototype.getMenuClassName = function() {
      return ft("k-reset", "k-header", "k-menu", { "k-menu-horizontal": !this.props.vertical }, { "k-menu-vertical": this.props.vertical }, this.props.className);
    }, t.prototype.clearItemHoverAndLeaveRequestsIfApplicable = function() {
      this.itemHoverRequest && (clearTimeout(this.itemHoverRequest), this.itemHoverRequest = null), this.itemLeaveRequest && (clearTimeout(this.itemLeaveRequest), this.itemLeaveRequest = null);
    }, t.prototype.isItemWithDefaultClose = function(n) {
      return !this.props.customCloseItemIds || this.props.customCloseItemIds.indexOf(n) === -1;
    }, t.prototype.checkIsDirectionRightToLeft = function() {
      return !!(this.props.dir !== void 0 ? this.props.dir === "rtl" : this.menuWrapperEl && getComputedStyle(this.menuWrapperEl).direction === "rtl");
    }, t.prototype.prepareItems = function() {
      var n = Ds(this.props.items, this.props.children), r = n.items, o = n.inputItems;
      this.items = r, this.inputItems = o;
    }, t.prototype.dispatchSelectEventIfWired = function(n, r) {
      $l(this.props.onSelect, n, this, { item: this.getInputItem(r), itemId: r });
    }, t.propTypes = {
      vertical: p.bool,
      items: p.arrayOf(p.object),
      style: p.object,
      dir: p.string,
      hoverOpenDelay: p.number,
      hoverCloseDelay: p.number,
      openOnClick: p.bool,
      itemRender: p.any,
      linkRender: p.any,
      customCloseItemIds: p.arrayOf(p.string),
      onSelect: p.func,
      role: p.string
    }, t.defaultProps = { vertical: !1 }, t;
  }(l.Component)
), Tn = globalThis && globalThis.__assign || function() {
  return Tn = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, Tn.apply(this, arguments);
}, oa = function(e) {
  var t = l.useRef(null);
  return l.useEffect(function() {
    e.show && setTimeout(function() {
      var n = t.current && t.current.element, r = n && n.querySelector(".k-menu-item"), o = Yi(r && r.ownerDocument);
      r && r !== o && r.focus();
    });
  }, [e.show]), l.createElement(
    mo,
    { show: e.show, offset: e.offset, popupClass: "k-menu-popup", animate: !1 },
    l.createElement(Bs, Tn({ vertical: !0 }, e, { ref: t, className: ft("k-context-menu", e.className), onClose: e.onClose, role: "menu" }), e.children)
  );
};
oa.displayName = "KendoReactContextMenu";
var Gs = function() {
  return typeof document < "u" ? document : {};
}, ia = (
  /** @class */
  function() {
    function e() {
      this.scrollbar = 0;
    }
    return Object.defineProperty(e.prototype, "scrollbarWidth", {
      get: function() {
        var t = Gs();
        if (!this.scrollbar && t && t.createElement) {
          var n = t.createElement("div");
          n.style.cssText = "overflow:scroll;overflow-x:hidden;zoom:1;clear:both;display:block", n.innerHTML = "&nbsp;", t.body.appendChild(n), this.scrollbar = n.offsetWidth - n.scrollWidth, t.body.removeChild(n);
        }
        return this.scrollbar;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }()
), Hr = !!// from fbjs
(typeof window < "u" && window.document && window.document.createElement), le = function() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var n = {}, r = function(i) {
    return typeof i == "object" ? Object.keys(i).forEach(function(a) {
      n[a] = i[a];
    }) : n[i] = !0;
  }, o = function(i) {
    return i.filter(function(a) {
      return a !== !0 && !!a;
    }).map(function(a) {
      return Array.isArray(a) ? o(a) : r(a);
    });
  };
  return o(e), Object.keys(n).map(function(i) {
    return n[i] && i || null;
  }).filter(function(i) {
    return i !== null;
  }).join(" ");
}, Us = function(e) {
  return e ? new Date(e.getTime()) : null;
};
function Ks(e) {
  var t = {};
  return aa(e, t), t;
}
function aa(e, t) {
  for (var n in e)
    if (e.hasOwnProperty(n)) {
      var r = e[n];
      t[n] = la(r, t[n]);
    }
}
function la(e, t) {
  if (Array.isArray(e))
    return Ws(e);
  if (e instanceof Date)
    return Us(e);
  if (l.isValidElement(e))
    return l.cloneElement(e, e.props);
  if (e && typeof e == "object") {
    var n = t || {};
    return aa(e, n), n;
  } else
    return e;
}
function Ws(e) {
  return e.map(function(t) {
    return la(t, void 0);
  });
}
var Vs = /\[(?:(\d+)|['"](.*?)['"])\]|((?:(?!\[.*?\]|\.).)+)/g;
function qs(e) {
  var t = [];
  return e.replace(Vs, function(n, r, o, i) {
    t.push(r !== void 0 ? r : o || i);
  }), t;
}
var rr = {};
rr.undefined = function() {
};
function $s(e) {
  if (rr[e])
    return rr[e];
  var t = qs(e);
  return rr[e] = function(n) {
    for (var r = n, o = 0; o < t.length && r; o++)
      r = r[t[o]];
    return r;
  }, rr[e];
}
var tn = function() {
  var e = "", t, n;
  for (t = 0; t < 32; t++)
    n = Math.random() * 16 | 0, (t === 8 || t === 12 || t === 16 || t === 20) && (e += "-"), e += (t === 12 ? 4 : t === 16 ? n & 3 | 8 : n).toString(16);
  return e;
}, yo = {
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  esc: 27,
  space: 32,
  pageUp: 33,
  pageDown: 34,
  end: 35,
  home: 36,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  delete: 46
}, De = function() {
}, sa = function() {
  if (!Hr || !document.body)
    return !1;
  var e = new ia().scrollbarWidth;
  return e;
}, Jo = function() {
  if (!Hr || !document.body)
    return !1;
  var e = new ia().scrollbarWidth;
  document.body.style.setProperty("--kendo-scrollbar-width", "".concat(e, "px"));
}, Xs = ["telerik.com", "progress.com", "stackblitz.io", "csb.app"];
function Ys(e) {
  if (typeof Fr < "u")
    ho(e);
  else {
    var t = "License activation failed for ".concat(e.name, `
`);
    t += `The @progress/kendo-licensing script is not loaded.
`, t += "See ".concat(e.licensingDocsUrl, ` for more information.
`), console.warn(t);
  }
}
function Zs(e) {
  var t = Xs.some(function(n) {
    var r;
    return (r = globalThis.document) === null || r === void 0 ? void 0 : r.location.hostname.endsWith(n);
  });
  return !t && !(!(Fr === null || Fr === void 0) && ho(e));
}
var Qs = "https://www.telerik.com/kendo-react-ui/components/my-license/", ei = !1, Js = function() {
  var e = l.useState(!0), t = e[0], n = e[1], r = l.useState(!1), o = r[0], i = r[1];
  l.useEffect(function() {
    ei || (i(!0), ei = !0);
  }, []);
  var a = function() {
    n(!1);
  }, s = l.createElement(l.Fragment, null, t && l.createElement(
    "div",
    { style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "fixed",
      top: "16px",
      right: "16px",
      padding: "12px",
      borderRadius: "4px",
      boxShadow: "0px 4px 5px 0px rgba(0, 0, 0, 0.04), 0px 2px 4px 0px rgba(0, 0, 0, 0.03)",
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
      backgroundColor: "#FFC000",
      color: "#1E1E1E",
      zIndex: 999
    } },
    l.createElement(
      "span",
      { style: { display: "flex", alignSelf: "center", marginRight: "8px" } },
      l.createElement(
        "svg",
        { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" },
        l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 1L0 15H16L8 1ZM7 6V11H9V6H7ZM7 14V12H9V14H7Z", fill: "#1E1E1E" })
      )
    ),
    l.createElement("span", null, "No license found for KendoReact. Learn how to activate your license."),
    l.createElement(
      "div",
      { style: { display: "flex", alignItems: "center", marginLeft: "24px" } },
      l.createElement(
        "a",
        { href: Qs, style: { marginRight: "8px", display: "flex" } },
        l.createElement(
          "button",
          { title: "Learn More", style: {
            display: "inline-flex",
            position: "relative",
            border: "none",
            borderRadius: "4px",
            padding: "5px",
            backgroundColor: "transparent",
            transition: "color 0.2s ease-in-out",
            outline: "none",
            cursor: "pointer"
          } },
          l.createElement(
            "svg",
            { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" },
            l.createElement("path", { d: "M15 8C15 11.8656 11.8656 15 8 15C4.13437 15 1 11.8656 1 8C1 4.13437 4.13437 1 8 1C11.8656 1 15 4.13437 15 8ZM14 8C14 4.6875 11.3125 2 8 2C4.6875 2 2 4.6875 2 8C2 11.3125 4.6875 14 8 14C11.3125 14 14 11.3125 14 8ZM11 6C11 7.4125 10.2687 8.05937 9.73125 8.53125C9.25937 8.94688 9 9.17813 9 10H7C7 8.275 7.84688 7.525 8.40938 7.03125C8.84062 6.65312 9 6.50938 9 6C9 5.45 8.55 5 8 5C7.45 5 7 5.45 7 6H5C5 4.34375 6.34375 3 8 3C9.65625 3 11 4.34375 11 6ZM9 13V11H7V13H9Z", fill: "#1E1E1E" })
          )
        )
      ),
      l.createElement(
        "button",
        { title: "Close", style: {
          display: "inline-flex",
          position: "relative",
          border: "none",
          borderRadius: "4px",
          padding: "5px",
          backgroundColor: "transparent",
          transition: "color 0.2s ease-in-out",
          outline: "none",
          cursor: "pointer"
        }, onClick: a },
        l.createElement(
          "svg",
          { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" },
          l.createElement("path", { d: "M13 4.41562L9.41563 8L13 11.5844L11.5844 13L8 9.41563L4.41562 13L3 11.5844L6.58437 8L3 4.41562L4.41562 3L8 6.58437L11.5844 3L13 4.41562Z", fill: "#1E1E1E" })
        )
      )
    )
  ));
  return l.createElement(
    l.Fragment,
    null,
    l.createElement("div", { style: {
      position: "absolute",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      opacity: 0.2,
      zIndex: 101,
      pointerEvents: "none",
      backgroundImage: "url('data:image/png;base64,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')"
    } }),
    o && po.createPortal(s, document.body)
  );
};
function eu(e, t, n, r) {
  if (e) {
    var o = {
      syntheticEvent: t,
      nativeEvent: t.nativeEvent,
      target: n
    };
    e.call(void 0, Object.assign(o, r));
  }
}
var tu = function(e, t, n) {
  n === void 0 && (n = {});
  var r = l.useCallback(function(h) {
    n.onMouseDown && n.onMouseDown.call(void 0, h), e.onMouseDown && e.onMouseDown.call(void 0, {
      target: t.current,
      syntheticEvent: h
    });
  }, [n.onMouseDown, e.onMouseDown, t]), o = l.useCallback(function(h) {
    n.onMouseUp && n.onMouseUp.call(void 0, h), e.onMouseUp && e.onMouseUp.call(void 0, {
      target: t.current,
      syntheticEvent: h
    });
  }, [n.onMouseUp, e.onMouseUp, t]), i = l.useCallback(function(h) {
    n.onClick && n.onClick.call(void 0, h), e.onClick && e.onClick.call(void 0, {
      target: t.current,
      syntheticEvent: h
    });
  }, [n.onClick, e.onClick, t]), a = l.useCallback(function(h) {
    n.onDoubleClick && n.onDoubleClick.call(void 0, h), e.onDoubleClick && e.onDoubleClick.call(void 0, {
      target: t.current,
      syntheticEvent: h
    });
  }, [n.onDoubleClick, e.onDoubleClick, t]), s = l.useCallback(function(h) {
    n.onMouseEnter && n.onMouseEnter.call(void 0, h), e.onMouseEnter && e.onMouseEnter.call(void 0, {
      target: t.current,
      syntheticEvent: h
    });
  }, [n.onMouseEnter, e.onMouseEnter, t]), u = l.useCallback(function(h) {
    n.onMouseLeave && n.onMouseLeave.call(void 0, h), e.onMouseLeave && e.onMouseLeave.call(void 0, {
      target: t.current,
      syntheticEvent: h
    });
  }, [n.onMouseLeave, e.onMouseLeave, t]), c = l.useCallback(function(h) {
    n.onMouseMove && n.onMouseMove.call(void 0, h), e.onMouseMove && e.onMouseMove.call(void 0, {
      target: t.current,
      syntheticEvent: h
    });
  }, [n.onMouseMove, e.onMouseMove, t]), f = l.useCallback(function(h) {
    n.onMouseOut && n.onMouseOut.call(void 0, h), e.onMouseOut && e.onMouseOut.call(void 0, {
      target: t.current,
      syntheticEvent: h
    });
  }, [n.onMouseOut, e.onMouseOut, t]), d = l.useCallback(function(h) {
    n.onMouseOver && n.onMouseOver.call(void 0, h), e.onMouseOver && e.onMouseOver.call(void 0, {
      target: t.current,
      syntheticEvent: h
    });
  }, [n.onMouseOver, e.onMouseOver, t]);
  return {
    onClick: i,
    onMouseUp: o,
    onMouseDown: r,
    onDoubleClick: a,
    onMouseEnter: s,
    onMouseLeave: u,
    onMouseMove: c,
    onMouseOut: f,
    onMouseOver: d
  };
}, ua = {
  default: "",
  xsmall: "k-icon-xs",
  small: "k-icon-sm",
  medium: "k-icon-md",
  large: "k-icon-lg",
  xlarge: "k-icon-xl",
  xxlarge: "k-icon-xxl",
  xxxlarge: "k-icon-xxxl"
}, Rn = globalThis && globalThis.__assign || function() {
  return Rn = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, Rn.apply(this, arguments);
}, ru = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}, Co = l.forwardRef(function(e, t) {
  var n = e.className, r = e.name, o = e.themeColor, i = e.size, a = e.flip, s = e.style, u = e.id, c = e.tabIndex, f = ru(e, ["className", "name", "themeColor", "size", "flip", "style", "id", "tabIndex"]), d = l.useRef(null), h = l.useRef(null);
  l.useImperativeHandle(d, function() {
    return {
      element: h.current
    };
  }), l.useImperativeHandle(t, function() {
    return d.current;
  });
  var m = l.useMemo(function() {
    return i || ti.size;
  }, [i]), g = l.useMemo(function() {
    return a || ti.flip;
  }, [a]), y = l.useMemo(function() {
    var x;
    return le("k-icon", r && au(r), (x = {}, x["k-color-".concat(o)] = o, x["k-flip-h"] = g === "horizontal" || g === "both", x["k-flip-v"] = g === "vertical" || g === "both", x), ua[m], n);
  }, [r, o, m, g, n]), w = tu(e, d);
  return l.createElement("span", Rn({ ref: h }, f, w, { className: y, id: u, tabIndex: c, style: s, role: "presentation" }));
});
Co.propTypes = {
  style: p.object,
  classNames: p.string,
  name: p.string,
  themeColor: p.oneOf([
    "inherit",
    "primary",
    "secondary",
    "tertiary",
    "info",
    "success",
    "error",
    "warning",
    "dark",
    "light",
    "inverse"
  ]),
  size: p.oneOf(["default", "xsmall", "small", "medium", "large", "xlarge", "xxlarge", "xxxlarge"]),
  flip: p.oneOf(["default", "horizontal", "vertical", "both"])
};
var ti = {
  size: "default",
  flip: "default"
};
Co.displayName = "KendoIcon";
var St = globalThis && globalThis.__assign || function() {
  return St = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, St.apply(this, arguments);
}, nu = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}, bo = l.forwardRef(function(e, t) {
  var n = e.children, r = e.className, o = e.svgClassName, i = e.icon, a = e.flip, s = e.id, u = e.tabIndex, c = e.size, f = e.style, d = e.svgStyle, h = e.themeColor, m = e.viewBox;
  e.name;
  var g = nu(e, ["children", "className", "svgClassName", "icon", "flip", "id", "tabIndex", "size", "style", "svgStyle", "themeColor", "viewBox", "name"]), y = l.useRef(null);
  l.useImperativeHandle(t, function() {
    return {
      element: y.current
    };
  });
  var w = l.useMemo(function() {
    return i ? i.name : Er.icon;
  }, [i]), x = l.useMemo(function() {
    return c || Er.size;
  }, [c]), b = l.useMemo(function() {
    return a || Er.flip;
  }, [a]), C = l.useMemo(function() {
    return m || Er.viewBox;
  }, [m]), S = l.useMemo(function() {
    var _;
    return le("k-svg-icon", "k-svg-i-" + w, (_ = {}, _["k-color-".concat(h)] = h, _["k-flip-h"] = b === "horizontal" || b === "both", _["k-flip-v"] = b === "vertical" || b === "both", _), ua[x], r);
  }, [w, h, x, b, r]), T = l.useMemo(function() {
    return e.width && e.height ? St({ width: e.width, height: e.height }, f) : e.width ? St({ width: e.width, height: e.width }, f) : e.height ? St({ width: e.height, height: e.height }, f) : St({}, f);
  }, [e.width, e.height, f]);
  return l.createElement(
    "span",
    { className: S, style: T, ref: y },
    l.createElement("svg", St({ id: s, className: o, style: d, "aria-hidden": !0, tabIndex: u, focusable: !1, xmlns: "http://www.w3.org/2000/svg", viewBox: i ? i.viewBox : C, dangerouslySetInnerHTML: i ? { __html: i.content } : void 0 }, g), i ? void 0 : n)
  );
});
bo.propTypes = {
  style: p.object,
  classNames: p.string,
  children: p.any,
  icon: p.object,
  themeColor: p.oneOf([
    "inherit",
    "primary",
    "secondary",
    "tertiary",
    "info",
    "success",
    "error",
    "warning",
    "dark",
    "light",
    "inverse"
  ]),
  size: p.oneOf(["default", "xsmall", "small", "medium", "large", "xlarge", "xxlarge", "xxxlarge"]),
  flip: p.oneOf(["default", "horizontal", "vertical", "both"])
};
var Er = {
  size: "default",
  flip: "default",
  icon: "",
  viewBox: "0 0 24 24"
};
bo.displayName = "KendoSvgIcon";
var ca = l.createContext({ type: "svg" });
ca.displayName = "KendoReactIconsContext";
var Br = globalThis && globalThis.__assign || function() {
  return Br = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, Br.apply(this, arguments);
}, ou = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}, ot = l.forwardRef(function(e, t) {
  var n, r = l.useContext(ca), o = r.type, i = r.icons, a = e.icon, s = ou(e, ["icon"]), u = ((n = e.icon) === null || n === void 0 ? void 0 : n.name) || e.name, c = u && i && i[u] && typeof i[u] != "string" ? i[u] : a;
  return u = u && i && i[u] && typeof i[u] == "string" ? i[u] : u, o === "svg" && c ? l.createElement(bo, Br({}, e, { icon: c, ref: t })) : l.createElement(Co, Br({}, s, { name: u, ref: t }));
});
ot.displayName = "KendoIconWrap";
var iu = function(e) {
  return e.replace(/^k-i-/, "");
}, au = function(e) {
  return "k-i-" + e;
};
p.shape({
  name: p.string.isRequired,
  content: p.string.isRequired,
  viewBox: p.string.isRequired
});
var ri = function(e, t) {
  var n = l.useContext(e), r = n[0], o = n[1], i = l.useState(t), a = i[0], s = i[1], u = r !== void 0 ? r : a, c = function() {
    for (var f = [], d = 0; d < arguments.length; d++)
      f[d] = arguments[d];
    r !== void 0 ? o.apply(void 0, f) : s(f[0]);
  };
  return [
    u,
    c
  ];
}, lu = l.createContext([
  void 0,
  De
]), su = l.createContext([
  void 0,
  De
]), uu = l.createContext([[], De, De]), cu = l.createContext([[], De, De]), fu = 2e3;
function du(e, t, n) {
  n === void 0 && (n = {});
  var r = t.onPress, o = r === void 0 ? De : r, i = t.onRelease, a = i === void 0 ? De : i, s = t.onDragStart, u = s === void 0 ? De : s, c = t.onDrag, f = c === void 0 ? De : c, d = t.onDragEnd, h = d === void 0 ? De : d, m = n.hint, g = m === void 0 ? null : m, y = n.mouseOnly, w = y === void 0 ? !1 : y, x = n.autoScroll, b = x === void 0 ? !0 : x, C = n.scrollContainer, S = C === void 0 ? null : C, T = l.useState(!1), _ = T[0], k = T[1], H = l.useState(!1), L = H[0], B = H[1], F = ri(su)[0], G = ri(lu), Z = G[0], ee = G[1], D = l.useContext(cu)[0], N = l.useContext(uu), E = N[0], j = N[1], X = N[2], se = l.useRef({ x: 0, y: 0 }), ie = l.useRef(), ce = l.useRef(!1), pe = l.useRef(), ae = l.useRef(null), ye = l.useRef(!1), Se = l.useRef({ x: 0, y: 0 }), P = l.useRef({ x: 0, y: 0 }), M = l.useRef({ x: 0, y: 0 }), U = l.useRef({ x: 0, y: 0 }), W = l.useRef({ x: 0, y: 0 }), ge = l.useRef({ x: 0, y: 0 }), Ne = !!(typeof window < "u" && window.PointerEvent), He = !w && Ne, fe = l.useCallback(function() {
    return e.current && e.current.element ? e.current.element : e.current;
  }, [e]), jt = l.useCallback(function() {
    return g && g.current && g.current.element ? g.current.element : g ? g.current : null;
  }, [g]), lt = l.useCallback(function() {
    return S && S.current && S.current.element ? S.current.element : S ? S.current : null;
  }, [S]), st = l.useCallback(function() {
    return typeof b == "object" && b.boundaryElementRef && b.boundaryElementRef.current && b.boundaryElementRef.current.element ? b.boundaryElementRef.current.element : typeof b == "object" && b.boundaryElementRef && b.boundaryElementRef.current ? b.boundaryElementRef.current : null;
  }, [b]), we = l.useRef(null);
  l.useImperativeHandle(we, function() {
    return {
      element: fe(),
      hint: jt(),
      onPress: Xe,
      onDragStart: pt,
      onDrag: ln,
      onDragEnd: sn,
      onRelease: Ge,
      data: e.current
    };
  });
  var _e = l.useCallback(function() {
    var v = fe();
    return v && v.ownerDocument || document;
  }, [fe]), I = l.useCallback(function() {
    var v = _e();
    return v && v.defaultView || window;
  }, [_e]), de = l.useCallback(function() {
    return {
      drag: Z ? Z.current : null,
      drop: F ? F.current : null,
      drags: E.map(function(v) {
        return v.current;
      }),
      drops: D.map(function(v) {
        return v.current;
      }),
      pressed: _,
      ignoreMouse: ce.current,
      scrollOffset: W.current,
      offset: Se.current,
      pageOffset: P.current,
      initialScrollOffset: ge.current,
      clientOffset: M.current,
      initialClientOffset: U.current,
      velocity: se.current,
      autoScroll: !!(typeof b == "object" ? b.enabled !== !1 : b),
      scrollableParent: st(),
      autoScrollDirection: typeof b == "object" ? b.direction : { horizontal: !0, vertical: !0 },
      isScrolling: L
    };
  }, [Z, F, E, D, _, b, st, L]), $e = l.useCallback(function(v) {
    k(v);
  }, []), Be = l.useCallback(function(v) {
    B(v);
  }, []), be = l.useCallback(function(v) {
    se.current = v;
  }, []), Y = l.useCallback(function(v) {
    Se.current = v;
  }, []), ve = l.useCallback(function(v) {
    M.current = v;
  }, []), Ee = l.useCallback(function(v) {
    P.current = v;
  }, []), et = l.useCallback(function(v) {
    U.current = v;
  }, []), Pe = l.useCallback(function(v) {
    W.current = v;
  }, []), Le = l.useCallback(function(v) {
    ge.current = v;
  }, []), Xe = l.useCallback(function(v) {
    o(v);
  }, [o]), Ge = l.useCallback(function(v) {
    a(v);
  }, [a]), pt = l.useCallback(function(v) {
    ee(we, { target: e.current, event: v }), u(v);
  }, [ee, e, u]), ln = l.useCallback(function(v) {
    f(v);
  }, [f]), sn = l.useCallback(function(v) {
    ye.current || (ee(null, { target: e.current, event: v }), h(v));
  }, [h, ee, e]), A = l.useCallback(function(v) {
    qi(de(), { event: v, payload: we.current }, {
      onVelocityChange: be,
      onOffsetChange: Y,
      onClientOffsetChange: ve,
      onPageOffsetChange: Ee,
      onInitialClientOffsetChange: et,
      onScrollOffsetChange: Pe,
      onInitialScrollOffsetChange: Le,
      onIsPressedChange: $e,
      onIsScrollingChange: Be
    });
  }, [
    de,
    be,
    Y,
    Ee,
    ve,
    et,
    Le,
    $e,
    Pe,
    Be
  ]), gt = l.useCallback(function(v) {
    A(v);
  }, [A]), vt = l.useCallback(function(v) {
    A(v);
  }, [A]), mt = l.useCallback(function(v) {
    A(v);
  }, [A]), yt = l.useCallback(function(v) {
    A(v);
  }, [A]), Ct = l.useCallback(function(v) {
    A(v);
  }, [A]), bt = l.useCallback(function(v) {
    A(v);
  }, [A]), xt = l.useCallback(function(v) {
    A(v);
  }, [A]), wt = l.useCallback(function(v) {
    v.preventDefault(), A(v);
  }, [A]), _t = l.useCallback(function(v) {
    v.preventDefault(), A(v);
  }, [A]), Et = l.useCallback(function(v) {
    v.preventDefault(), A(v);
  }, [A]), It = l.useCallback(function(v) {
    if (v.touches.length === 0 && v.changedTouches.length === 1) {
      var z = I();
      ce.current = !0, pe.current = z.setTimeout(function() {
        ce.current = !1;
      }, fu);
    }
    A(v);
  }, [A, I]), kt = l.useCallback(function(v) {
    A(v);
  }, [A]), Qt = l.useCallback(function() {
    var v = fe();
    if (v) {
      var z = v.style.touchAction;
      return v.style.touchAction = "none", function() {
        v.style.touchAction = z;
      };
    }
  }, [fe]), Jt = l.useCallback(function() {
    return j(we), function() {
      X(we);
    };
  }, [X, j]), un = function() {
    var v = I(), z = fe(), oe = _e();
    return He ? (z && (ae.current = zr(z), ae.current && ae.current.addEventListener("scroll", kt, { passive: !0 }), z.addEventListener("pointerdown", gt, { passive: !0 })), _ && (oe.addEventListener("pointermove", vt), oe.addEventListener("pointerup", yt, !0), oe.addEventListener("contextmenu", wt), oe.addEventListener("pointercancel", mt, { passive: !0 }))) : (v.addEventListener("touchmove", De, { capture: !1, passive: !1 }), z && (z.addEventListener("mousedown", Ct, { passive: !0 }), w || (z.addEventListener("touchstart", _t, { passive: !0 }), _ && (z.addEventListener("touchmove", Et, { passive: !0 }), z.addEventListener("touchend", It, { passive: !0 })))), _ && (oe.addEventListener("mousemove", bt, { passive: !0 }), oe.addEventListener("mouseup", xt, { passive: !0 }))), function() {
      ae.current && ae.current.removeEventListener("scroll", kt), z && (z.removeEventListener("pointerdown", gt), z.removeEventListener("mousedown", Ct), z.removeEventListener("touchstart", _t), z.removeEventListener("touchmove", Et), z.removeEventListener("touchend", It)), oe.removeEventListener("pointermove", vt), oe.removeEventListener("pointerup", yt, !0), oe.removeEventListener("contextmenu", wt), oe.removeEventListener("pointercancel", mt), oe.removeEventListener("mousemove", bt), oe.removeEventListener("mouseup", xt), v.removeEventListener("touchmove", De), v.clearTimeout(pe.current);
    };
  };
  l.useEffect(function() {
    var v = I();
    if (L) {
      var z = lt() || zr(document.elementFromPoint(M.current.x, M.current.y));
      v.clearInterval(ie.current), ie.current = v.setInterval(function() {
        $i(z, { x: se.current.x, y: se.current.y });
      }, 50);
    }
    return function() {
      v.clearInterval(ie.current);
    };
  }, [fe, lt, I, L]), l.useEffect(Qt, [Qt]), l.useEffect(un, [
    _,
    I,
    fe,
    _e,
    w,
    He,
    wt,
    Ct,
    bt,
    xt,
    mt,
    gt,
    vt,
    yt,
    It,
    Et,
    _t,
    kt
  ]), l.useEffect(function() {
    return ye.current = !1, function() {
      ye.current = !0;
    };
  }, []), l.useLayoutEffect(Jt, [Jt]);
}
var rn = l.forwardRef(function(e, t) {
  var n = l.useRef(null), r = l.useRef(null), o = l.useCallback(function() {
    return n.current && n.current.element ? n.current.element : n.current;
  }, [n]);
  l.useImperativeHandle(r, function() {
    return { element: o() || null };
  }), l.useImperativeHandle(t, function() {
    return r.current;
  }), l.useImperativeHandle(e.childRef, function() {
    return n.current;
  });
  var i = l.useCallback(function(f) {
    e.onPress && e.onPress({
      element: o(),
      target: r.current,
      event: f
    });
  }, [o, e.onPress]), a = l.useCallback(function(f) {
    e.onRelease && e.onRelease({
      element: o(),
      target: r.current,
      event: f
    });
  }, [o, e.onRelease]), s = l.useCallback(function(f) {
    e.onDragStart && e.onDragStart({
      element: o(),
      target: r.current,
      event: f
    });
  }, [e, o]), u = l.useCallback(function(f) {
    e.onDrag && e.onDrag({
      element: o(),
      target: r.current,
      event: f
    });
  }, [o, e.onDrag]), c = l.useCallback(function(f) {
    e.onDragEnd && e.onDragEnd({
      element: o(),
      target: r.current,
      event: f
    });
  }, [o, e.onDragEnd]);
  return du(n, {
    onPress: i,
    onRelease: a,
    onDragStart: s,
    onDrag: u,
    onDragEnd: c
  }, {
    mouseOnly: e.mouseOnly,
    autoScroll: e.autoScroll,
    hint: e.hint,
    scrollContainer: e.scrollContainer
  }), e.children ? l.cloneElement(l.Children.only(e.children), { ref: n }) : null;
});
rn.displayName = "KendoReactDraggable";
var Dt = {
  sizeMap: {
    small: "sm",
    medium: "md",
    large: "lg"
  },
  roundedMap: {
    small: "sm",
    medium: "md",
    large: "lg"
  }
};
function hu(e, t) {
  return e === t || Number.isNaN(e) && Number.isNaN(t);
}
function pu(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (!hu(e[n], t[n]))
      return !1;
  return !0;
}
function ct(e, t) {
  t === void 0 && (t = pu);
  var n = null;
  function r() {
    for (var o = [], i = 0; i < arguments.length; i++)
      o[i] = arguments[i];
    if (n && n.lastThis === this && t(o, n.lastArgs))
      return n.lastResult;
    var a = e.apply(this, o);
    return n = {
      lastResult: a,
      lastArgs: o,
      lastThis: this
    }, a;
  }
  return r.clear = function() {
    n = null;
  }, r;
}
var xo = !!// from fbjs
(typeof window < "u" && window.document && window.document.createElement), gu = /\[(?:(\d+)|['"](.*?)['"])\]|((?:(?!\[.*?\]|\.).)+)/g;
function vu(e) {
  var t = [];
  return e.replace(gu, function(n, r, o, i) {
    t.push(r !== void 0 ? r : o || i);
  }), t;
}
var nr = {};
nr.undefined = function() {
};
function mu(e) {
  if (nr[e])
    return nr[e];
  var t = vu(e);
  return nr[e] = function(n) {
    for (var r = n, o = 0; o < t.length && r; o++)
      r = r[t[o]];
    return r;
  }, nr[e];
}
var yu = function() {
  var e = "", t, n;
  for (t = 0; t < 32; t++)
    n = Math.random() * 16 | 0, (t === 8 || t === 12 || t === 16 || t === 20) && (e += "-"), e += (t === 12 ? 4 : t === 16 ? n & 3 | 8 : n).toString(16);
  return e;
}, Ye = {
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  esc: 27,
  space: 32,
  pageUp: 33,
  pageDown: 34,
  end: 35,
  home: 36,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  delete: 46
}, Ae = function() {
}, Gr = globalThis && globalThis.__assign || function() {
  return Gr = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, Gr.apply(this, arguments);
}, Dn = globalThis && globalThis.__spreadArray || function(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, i; r < o; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
};
function ni(e, t, n) {
  var r;
  return n ? Gr(Gr({}, e), (r = {}, r[t] = n.length ? Dn([], n, !0) : void 0, r)) : e && e[t] ? Dn([], e[t], !0) : [];
}
function fa(e, t, n) {
  if (e[t]) {
    var r = ni(e, t).map(function(o) {
      return fa(o, t, n);
    });
    return n(ni(e, t, r));
  }
  return n(e);
}
var Cu = function(e, t, n) {
  return Dn([], e.map(function(r) {
    return fa(r, t, n);
  }), !0);
}, bu = function(e, t, n) {
  var r;
  return Object.assign({}, e, e[t] ? (r = {}, r[t] = e[t].slice(), r) : {}, n || {});
}, xu = function(e) {
  if (!xo)
    return !1;
  var t = e ? e.ownerDocument : document;
  if (!t || !t.body)
    return !1;
  var n = 10, r = t.createElement("div");
  r.style.transform = "matrix(10, 0, 0, 10, 0, 0)";
  var o = t.createElement("div");
  o.appendChild(t.createTextNode("child")), o.style.position = "fixed", o.style.top = n + "px", r.appendChild(o), t.body.appendChild(r);
  var i = o.getBoundingClientRect().top !== n;
  return t.body.removeChild(r), i;
}, wu = function(e, t, n) {
  n === void 0 && (n = {});
  var r = l.useCallback(function(h) {
    n.onMouseDown && n.onMouseDown.call(void 0, h), e.onMouseDown && e.onMouseDown.call(void 0, {
      target: t.current,
      syntheticEvent: h
    });
  }, [n.onMouseDown, e.onMouseDown, t]), o = l.useCallback(function(h) {
    n.onMouseUp && n.onMouseUp.call(void 0, h), e.onMouseUp && e.onMouseUp.call(void 0, {
      target: t.current,
      syntheticEvent: h
    });
  }, [n.onMouseUp, e.onMouseUp, t]), i = l.useCallback(function(h) {
    n.onClick && n.onClick.call(void 0, h), e.onClick && e.onClick.call(void 0, {
      target: t.current,
      syntheticEvent: h
    });
  }, [n.onClick, e.onClick, t]), a = l.useCallback(function(h) {
    n.onDoubleClick && n.onDoubleClick.call(void 0, h), e.onDoubleClick && e.onDoubleClick.call(void 0, {
      target: t.current,
      syntheticEvent: h
    });
  }, [n.onDoubleClick, e.onDoubleClick, t]), s = l.useCallback(function(h) {
    n.onMouseEnter && n.onMouseEnter.call(void 0, h), e.onMouseEnter && e.onMouseEnter.call(void 0, {
      target: t.current,
      syntheticEvent: h
    });
  }, [n.onMouseEnter, e.onMouseEnter, t]), u = l.useCallback(function(h) {
    n.onMouseLeave && n.onMouseLeave.call(void 0, h), e.onMouseLeave && e.onMouseLeave.call(void 0, {
      target: t.current,
      syntheticEvent: h
    });
  }, [n.onMouseLeave, e.onMouseLeave, t]), c = l.useCallback(function(h) {
    n.onMouseMove && n.onMouseMove.call(void 0, h), e.onMouseMove && e.onMouseMove.call(void 0, {
      target: t.current,
      syntheticEvent: h
    });
  }, [n.onMouseMove, e.onMouseMove, t]), f = l.useCallback(function(h) {
    n.onMouseOut && n.onMouseOut.call(void 0, h), e.onMouseOut && e.onMouseOut.call(void 0, {
      target: t.current,
      syntheticEvent: h
    });
  }, [n.onMouseOut, e.onMouseOut, t]), d = l.useCallback(function(h) {
    n.onMouseOver && n.onMouseOver.call(void 0, h), e.onMouseOver && e.onMouseOver.call(void 0, {
      target: t.current,
      syntheticEvent: h
    });
  }, [n.onMouseOver, e.onMouseOver, t]);
  return {
    onClick: i,
    onMouseUp: o,
    onMouseDown: r,
    onDoubleClick: a,
    onMouseEnter: s,
    onMouseLeave: u,
    onMouseMove: c,
    onMouseOut: f,
    onMouseOver: d
  };
}, _u = function(e) {
  var t = l.useCallback(function() {
    return e.current && e.current.element ? e.current.element : e.current;
  }, [e]), n = l.useCallback(function() {
    var r = t();
    return r && r.ownerDocument || document;
  }, [t]);
  return n;
}, da = {
  default: "",
  xsmall: "k-icon-xs",
  small: "k-icon-sm",
  medium: "k-icon-md",
  large: "k-icon-lg",
  xlarge: "k-icon-xl",
  xxlarge: "k-icon-xxl",
  xxxlarge: "k-icon-xxxl"
}, An = globalThis && globalThis.__assign || function() {
  return An = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, An.apply(this, arguments);
}, Eu = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}, wo = l.forwardRef(function(e, t) {
  var n = e.className, r = e.name, o = e.themeColor, i = e.size, a = e.flip, s = e.style, u = e.id, c = e.tabIndex, f = Eu(e, ["className", "name", "themeColor", "size", "flip", "style", "id", "tabIndex"]), d = l.useRef(null), h = l.useRef(null);
  l.useImperativeHandle(d, function() {
    return {
      element: h.current
    };
  }), l.useImperativeHandle(t, function() {
    return d.current;
  });
  var m = l.useMemo(function() {
    return i || oi.size;
  }, [i]), g = l.useMemo(function() {
    return a || oi.flip;
  }, [a]), y = l.useMemo(function() {
    var x;
    return Xi("k-icon", "k-font-icon", r && Ou(r), (x = {}, x["k-color-".concat(o)] = o, x["k-flip-h"] = g === "horizontal" || g === "both", x["k-flip-v"] = g === "vertical" || g === "both", x), da[m], n);
  }, [r, o, m, g, n]), w = wu(e, d);
  return l.createElement("span", An({ ref: h }, f, w, { className: y, id: u, tabIndex: c, style: s, role: "presentation" }));
});
wo.propTypes = {
  style: p.object,
  classNames: p.string,
  name: p.string,
  themeColor: p.oneOf([
    "inherit",
    "primary",
    "secondary",
    "tertiary",
    "info",
    "success",
    "error",
    "warning",
    "dark",
    "light",
    "inverse"
  ]),
  size: p.oneOf(["default", "xsmall", "small", "medium", "large", "xlarge", "xxlarge", "xxxlarge"]),
  flip: p.oneOf(["default", "horizontal", "vertical", "both"])
};
var oi = {
  size: "default",
  flip: "default"
};
wo.displayName = "KendoIcon";
var Pt = globalThis && globalThis.__assign || function() {
  return Pt = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, Pt.apply(this, arguments);
}, Iu = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}, _o = l.forwardRef(function(e, t) {
  var n = e.children, r = e.className, o = e.svgClassName, i = e.icon, a = e.flip, s = e.id, u = e.tabIndex, c = e.size, f = e.style, d = e.svgStyle, h = e.themeColor, m = e.viewBox;
  e.name;
  var g = e.onClick, y = Iu(e, ["children", "className", "svgClassName", "icon", "flip", "id", "tabIndex", "size", "style", "svgStyle", "themeColor", "viewBox", "name", "onClick"]), w = l.useRef(null);
  l.useImperativeHandle(t, function() {
    return {
      element: w.current
    };
  });
  var x = l.useMemo(function() {
    return i ? i.name : Ir.icon;
  }, [i]), b = l.useMemo(function() {
    return c || Ir.size;
  }, [c]), C = l.useMemo(function() {
    return a || Ir.flip;
  }, [a]), S = l.useMemo(function() {
    return m || Ir.viewBox;
  }, [m]), T = l.useMemo(function() {
    var k;
    return Xi("k-icon", "k-svg-icon", "k-svg-i-" + x, (k = {}, k["k-color-".concat(h)] = h, k["k-flip-h"] = C === "horizontal" || C === "both", k["k-flip-v"] = C === "vertical" || C === "both", k), da[b], r);
  }, [x, h, b, C, r]), _ = l.useMemo(function() {
    return e.width && e.height ? Pt({ width: e.width, height: e.height }, f) : e.width ? Pt({ width: e.width, height: e.width }, f) : e.height ? Pt({ width: e.height, height: e.height }, f) : Pt({}, f);
  }, [e.width, e.height, f]);
  return l.createElement(
    "span",
    { className: T, style: _, ref: w, onClick: g },
    l.createElement("svg", Pt({ id: s, className: o, style: d, "aria-hidden": !0, tabIndex: u, focusable: !1, xmlns: "http://www.w3.org/2000/svg", viewBox: i ? i.viewBox : S, dangerouslySetInnerHTML: i ? { __html: i.content } : void 0 }, y), i ? void 0 : n)
  );
});
_o.propTypes = {
  style: p.object,
  classNames: p.string,
  children: p.any,
  icon: p.object,
  themeColor: p.oneOf([
    "inherit",
    "primary",
    "secondary",
    "tertiary",
    "info",
    "success",
    "error",
    "warning",
    "dark",
    "light",
    "inverse"
  ]),
  size: p.oneOf(["default", "xsmall", "small", "medium", "large", "xlarge", "xxlarge", "xxxlarge"]),
  flip: p.oneOf(["default", "horizontal", "vertical", "both"])
};
var Ir = {
  size: "default",
  flip: "default",
  icon: "",
  viewBox: "0 0 24 24"
};
_o.displayName = "KendoSvgIcon";
var ha = l.createContext({ type: "svg" });
ha.displayName = "KendoReactIconsContext";
var Ur = globalThis && globalThis.__assign || function() {
  return Ur = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, Ur.apply(this, arguments);
}, ku = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}, pa = l.forwardRef(function(e, t) {
  var n, r, o = l.useContext(ha), i = o.type, a = o.icons, s = e.icon, u = ku(e, ["icon"]), c = i === "svg" ? ((n = e.icon) === null || n === void 0 ? void 0 : n.name) || e.name : e.name || ((r = e.icon) === null || r === void 0 ? void 0 : r.name);
  c = c && a && a[c] && typeof a[c] == "string" ? a[c] : c;
  var f = c && a && a[c] && typeof a[c] != "string" ? a[c] : s;
  return i === "svg" && f ? l.createElement(_o, Ur({}, e, { icon: f, ref: t })) : l.createElement(wo, Ur({}, u, { name: c, ref: t }));
});
pa.displayName = "KendoIconWrap";
var Ou = function(e) {
  return "k-i-" + e;
};
p.shape({
  name: p.string.isRequired,
  content: p.string.isRequired,
  viewBox: p.string.isRequired
});
var ii = function(e, t) {
  var n = l.useContext(e), r = n[0], o = n[1], i = l.useState(t), a = i[0], s = i[1], u = r !== void 0 ? r : a, c = function() {
    for (var f = [], d = 0; d < arguments.length; d++)
      f[d] = arguments[d];
    r !== void 0 ? o.apply(void 0, f) : s(f[0]);
  };
  return [
    u,
    c
  ];
}, Su = l.createContext([
  void 0,
  Ae
]), Pu = l.createContext([
  void 0,
  Ae
]), Tu = l.createContext([[], Ae, Ae]), Ru = l.createContext([[], Ae, Ae]), Du = 2e3;
function Au(e, t, n) {
  n === void 0 && (n = {});
  var r = t.onPress, o = r === void 0 ? Ae : r, i = t.onRelease, a = i === void 0 ? Ae : i, s = t.onDragStart, u = s === void 0 ? Ae : s, c = t.onDrag, f = c === void 0 ? Ae : c, d = t.onDragEnd, h = d === void 0 ? Ae : d, m = n.hint, g = m === void 0 ? null : m, y = n.mouseOnly, w = y === void 0 ? !1 : y, x = n.autoScroll, b = x === void 0 ? !0 : x, C = n.scrollContainer, S = C === void 0 ? null : C, T = l.useState(!1), _ = T[0], k = T[1], H = l.useState(!1), L = H[0], B = H[1], F = ii(Pu)[0], G = ii(Su), Z = G[0], ee = G[1], D = l.useContext(Ru)[0], N = l.useContext(Tu), E = N[0], j = N[1], X = N[2], se = l.useRef({ x: 0, y: 0 }), ie = l.useRef(), ce = l.useRef(!1), pe = l.useRef(), ae = l.useRef(null), ye = l.useRef(!1), Se = l.useRef({ x: 0, y: 0 }), P = l.useRef({ x: 0, y: 0 }), M = l.useRef({ x: 0, y: 0 }), U = l.useRef({ x: 0, y: 0 }), W = l.useRef({ x: 0, y: 0 }), ge = l.useRef({ x: 0, y: 0 }), Ne = !!(typeof window < "u" && window.PointerEvent), He = !w && Ne, fe = l.useCallback(function() {
    return e.current && e.current.element ? e.current.element : e.current;
  }, [e]), jt = l.useCallback(function() {
    return g && g.current && g.current.element ? g.current.element : g ? g.current : null;
  }, [g]), lt = l.useCallback(function() {
    return S && S.current && S.current.element ? S.current.element : S ? S.current : null;
  }, [S]), st = l.useCallback(function() {
    return typeof b == "object" && b.boundaryElementRef && b.boundaryElementRef.current && b.boundaryElementRef.current.element ? b.boundaryElementRef.current.element : typeof b == "object" && b.boundaryElementRef && b.boundaryElementRef.current ? b.boundaryElementRef.current : null;
  }, [b]), we = l.useRef(null);
  l.useImperativeHandle(we, function() {
    return {
      element: fe(),
      hint: jt(),
      onPress: Xe,
      onDragStart: pt,
      onDrag: ln,
      onDragEnd: sn,
      onRelease: Ge,
      data: e.current
    };
  });
  var _e = l.useCallback(function() {
    var v = fe();
    return v && v.ownerDocument || document;
  }, [fe]), I = l.useCallback(function() {
    var v = _e();
    return v && v.defaultView || window;
  }, [_e]), de = l.useCallback(function() {
    return {
      drag: Z ? Z.current : null,
      drop: F ? F.current : null,
      drags: E.map(function(v) {
        return v.current;
      }),
      drops: D.map(function(v) {
        return v.current;
      }),
      pressed: _,
      ignoreMouse: ce.current,
      scrollOffset: W.current,
      offset: Se.current,
      pageOffset: P.current,
      initialScrollOffset: ge.current,
      clientOffset: M.current,
      initialClientOffset: U.current,
      velocity: se.current,
      autoScroll: !!(typeof b == "object" ? b.enabled !== !1 : b),
      scrollableParent: st(),
      autoScrollDirection: typeof b == "object" ? b.direction : { horizontal: !0, vertical: !0 },
      isScrolling: L
    };
  }, [Z, F, E, D, _, b, st, L]), $e = l.useCallback(function(v) {
    k(v);
  }, []), Be = l.useCallback(function(v) {
    B(v);
  }, []), be = l.useCallback(function(v) {
    se.current = v;
  }, []), Y = l.useCallback(function(v) {
    Se.current = v;
  }, []), ve = l.useCallback(function(v) {
    M.current = v;
  }, []), Ee = l.useCallback(function(v) {
    P.current = v;
  }, []), et = l.useCallback(function(v) {
    U.current = v;
  }, []), Pe = l.useCallback(function(v) {
    W.current = v;
  }, []), Le = l.useCallback(function(v) {
    ge.current = v;
  }, []), Xe = l.useCallback(function(v) {
    o(v);
  }, [o]), Ge = l.useCallback(function(v) {
    a(v);
  }, [a]), pt = l.useCallback(function(v) {
    ee(we, { target: e.current, event: v }), u(v);
  }, [ee, e, u]), ln = l.useCallback(function(v) {
    f(v);
  }, [f]), sn = l.useCallback(function(v) {
    ye.current || (ee(null, { target: e.current, event: v }), h(v));
  }, [h, ee, e]), A = l.useCallback(function(v) {
    qi(de(), { event: v, payload: we.current }, {
      onVelocityChange: be,
      onOffsetChange: Y,
      onClientOffsetChange: ve,
      onPageOffsetChange: Ee,
      onInitialClientOffsetChange: et,
      onScrollOffsetChange: Pe,
      onInitialScrollOffsetChange: Le,
      onIsPressedChange: $e,
      onIsScrollingChange: Be
    });
  }, [
    de,
    be,
    Y,
    Ee,
    ve,
    et,
    Le,
    $e,
    Pe,
    Be
  ]), gt = l.useCallback(function(v) {
    A(v);
  }, [A]), vt = l.useCallback(function(v) {
    A(v);
  }, [A]), mt = l.useCallback(function(v) {
    A(v);
  }, [A]), yt = l.useCallback(function(v) {
    A(v);
  }, [A]), Ct = l.useCallback(function(v) {
    A(v);
  }, [A]), bt = l.useCallback(function(v) {
    A(v);
  }, [A]), xt = l.useCallback(function(v) {
    A(v);
  }, [A]), wt = l.useCallback(function(v) {
    v.preventDefault(), A(v);
  }, [A]), _t = l.useCallback(function(v) {
    v.preventDefault(), A(v);
  }, [A]), Et = l.useCallback(function(v) {
    v.preventDefault(), A(v);
  }, [A]), It = l.useCallback(function(v) {
    if (v.touches.length === 0 && v.changedTouches.length === 1) {
      var z = I();
      ce.current = !0, pe.current = z.setTimeout(function() {
        ce.current = !1;
      }, Du);
    }
    A(v);
  }, [A, I]), kt = l.useCallback(function(v) {
    A(v);
  }, [A]), Qt = l.useCallback(function() {
    var v = fe();
    if (v) {
      var z = v.style.touchAction;
      return v.style.touchAction = "none", function() {
        v.style.touchAction = z;
      };
    }
  }, [fe]), Jt = l.useCallback(function() {
    return j(we), function() {
      X(we);
    };
  }, [X, j]), un = function() {
    var v = I(), z = fe(), oe = _e();
    return He ? (z && (ae.current = zr(z), ae.current && ae.current.addEventListener("scroll", kt, { passive: !0 }), z.addEventListener("pointerdown", gt, { passive: !0 })), _ && (oe.addEventListener("pointermove", vt), oe.addEventListener("pointerup", yt, !0), oe.addEventListener("contextmenu", wt), oe.addEventListener("pointercancel", mt, { passive: !0 }))) : (v.addEventListener("touchmove", Ae, { capture: !1, passive: !1 }), z && (z.addEventListener("mousedown", Ct, { passive: !0 }), w || (z.addEventListener("touchstart", _t, { passive: !0 }), _ && (z.addEventListener("touchmove", Et, { passive: !0 }), z.addEventListener("touchend", It, { passive: !0 })))), _ && (oe.addEventListener("mousemove", bt, { passive: !0 }), oe.addEventListener("mouseup", xt, { passive: !0 }))), function() {
      ae.current && ae.current.removeEventListener("scroll", kt), z && (z.removeEventListener("pointerdown", gt), z.removeEventListener("mousedown", Ct), z.removeEventListener("touchstart", _t), z.removeEventListener("touchmove", Et), z.removeEventListener("touchend", It)), oe.removeEventListener("pointermove", vt), oe.removeEventListener("pointerup", yt, !0), oe.removeEventListener("contextmenu", wt), oe.removeEventListener("pointercancel", mt), oe.removeEventListener("mousemove", bt), oe.removeEventListener("mouseup", xt), v.removeEventListener("touchmove", Ae), v.clearTimeout(pe.current);
    };
  };
  l.useEffect(function() {
    var v = I();
    if (L) {
      var z = lt() || zr(document.elementFromPoint(M.current.x, M.current.y));
      v.clearInterval(ie.current), ie.current = v.setInterval(function() {
        $i(z, { x: se.current.x, y: se.current.y });
      }, 50);
    }
    return function() {
      v.clearInterval(ie.current);
    };
  }, [fe, lt, I, L]), l.useEffect(Qt, [Qt]), l.useEffect(un, [
    _,
    I,
    fe,
    _e,
    w,
    He,
    wt,
    Ct,
    bt,
    xt,
    mt,
    gt,
    vt,
    yt,
    It,
    Et,
    _t,
    kt
  ]), l.useEffect(function() {
    return ye.current = !1, function() {
      ye.current = !0;
    };
  }, []), l.useLayoutEffect(Jt, [Jt]);
}
var ga = l.forwardRef(function(e, t) {
  var n = l.useRef(null), r = l.useRef(null), o = l.useCallback(function() {
    return n.current && n.current.element ? n.current.element : n.current;
  }, [n]);
  l.useImperativeHandle(r, function() {
    return { element: o() || null };
  }), l.useImperativeHandle(t, function() {
    return r.current;
  }), l.useImperativeHandle(e.childRef, function() {
    return n.current;
  });
  var i = l.useCallback(function(f) {
    e.onPress && e.onPress({
      element: o(),
      target: r.current,
      event: f
    });
  }, [o, e.onPress]), a = l.useCallback(function(f) {
    e.onRelease && e.onRelease({
      element: o(),
      target: r.current,
      event: f
    });
  }, [o, e.onRelease]), s = l.useCallback(function(f) {
    e.onDragStart && e.onDragStart({
      element: o(),
      target: r.current,
      event: f
    });
  }, [e, o]), u = l.useCallback(function(f) {
    e.onDrag && e.onDrag({
      element: o(),
      target: r.current,
      event: f
    });
  }, [o, e.onDrag]), c = l.useCallback(function(f) {
    e.onDragEnd && e.onDragEnd({
      element: o(),
      target: r.current,
      event: f
    });
  }, [o, e.onDragEnd]);
  return Au(n, {
    onPress: i,
    onRelease: a,
    onDragStart: s,
    onDrag: u,
    onDragEnd: c
  }, {
    mouseOnly: e.mouseOnly,
    autoScroll: e.autoScroll,
    hint: e.hint,
    scrollContainer: e.scrollContainer
  }), e.children ? l.cloneElement(l.Children.only(e.children), { ref: n }) : null;
});
ga.displayName = "KendoReactDraggable";
var Mn = function(e) {
  var t = e.shadowRoot, n = e.contentDocument;
  return t && t.activeElement ? Mn(t.activeElement) : n && n.activeElement ? Mn(n.activeElement) : e;
}, Mu = function(e) {
  if (!(!e || !e.activeElement))
    return Mn(e.activeElement);
}, Kr = globalThis && globalThis.__spreadArray || function(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, i; r < o; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}, fn, dn, hn, Yt = "data-keyboardnavlevel", va = "data-keyboardnavscope", ma = "data-keyboardnavheader", ya = "data-keyboardnavbody", nn = "data-keyboardnavid", Fu = "_filter", Ca = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[contenteditable]"
], Eo = Kr(Kr([], Ca, !0), ["[tabindex]"], !1), Nu = Kr(Kr([], Ca, !0), ["[tabindex]"], !1).map(function(e) {
  return e + ':not([tabindex="-1"])';
}), ai = (fn = {}, fn[va] = !0, fn), li = (dn = {}, dn[ma] = !0, dn), si = (hn = {}, hn[ya] = !0, hn), ur = l.createContext(void 0);
ur.displayName = "KendoReactTableKeyboardNavigationContext";
var ht = function(e, t) {
  var n, r = l.useContext(ur);
  return !r || !e || t === !1 ? {} : (n = {
    tabIndex: r && r.activeId && r.activeId === e ? 0 : -1
  }, n[Yt] = r.level, n[nn] = e, n);
}, Fn = globalThis && globalThis.__assign || function() {
  return Fn = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, Fn.apply(this, arguments);
}, Io = function(e) {
  var t = e.ariaSort, n = e.colSpan, r = e.rowSpan, o = e.className, i = e.style, a = e.columnId, s = e.onKeyDown, u = e.navigatable, c = e.ariaColumnIndex, f = e.ariaLabel, d = e.role, h = e.ariaSelected, m = ht(a, u);
  return l.createElement("th", Fn({
    "aria-sort": t,
    "aria-label": f,
    "aria-colindex": c,
    "aria-selected": h,
    // TODO: Enable this with React 18. Currently throws warnings
    // aria-description={ariaDescription}
    colSpan: n,
    rowSpan: r,
    className: o,
    style: i,
    onKeyDown: s,
    role: d
  }, m), e.children);
};
Io.displayName = "KendoReactHeaderThElement";
var Lu = function(e, t, n) {
  return n === void 0 && (n = "cell"), "".concat(t, "_").concat(e, "_").concat(n);
}, ju = function(e) {
  if (e)
    return parseInt(e.getAttribute(Yt) || "", 10);
}, ko = function(e) {
  if (e) {
    var t = e.getAttribute(nn);
    return t || void 0;
  }
}, Nn = function(e) {
  if (!e)
    return !1;
  var t = e.getAttribute(nn);
  return !!t;
}, zu = function(e, t) {
  return t === void 0 && (t = { level: 0 }), e.querySelector("[".concat(Yt, "='").concat(t.level, "']"));
}, Hu = function(e) {
  return e.parentElement && e.parentElement.closest("[".concat(Yt, "]"));
}, Bu = function(e, t) {
  return e.querySelector("[".concat(nn, "='").concat(t, "']"));
}, Gu = function(e) {
  return e.parentElement && e.parentElement.closest("[".concat(va, "]"));
}, ba = function(e) {
  return e.querySelector("[".concat(ma, "]"));
}, xa = function(e) {
  return e.querySelector("[".concat(ya, "]"));
}, Uu = function(e, t) {
  t === void 0 && (t = { focusable: !1 });
  var n = t.focusable ? Eo : Nu;
  return Array.from(e.querySelectorAll(n.join(",")));
}, Ku = function(e, t) {
  if (t === void 0 && (t = { level: 0 }), !e)
    return [];
  var n = Eo.map(function(r) {
    return r + "[".concat(Yt, "='").concat(t.level, "']");
  }).join(",");
  return Array.from(e.querySelectorAll(n));
}, Wu = function(e) {
  e === void 0 && (e = { level: 0 });
  var t = Eo.map(function(n) {
    return n + "[".concat(Yt, "='").concat(e.level, "']");
  }).join(",");
  return function(n) {
    return n.matches(t);
  };
}, Vu = function(e) {
  var t = e.elementForFocus, n = e.event, r = e.contextStateRef, o = e.prevElement;
  r.current && t && t.focus && (n.preventDefault(), t.focus(), Nn(t) && (t.setAttribute("tabIndex", "0"), r.current.activeId = ko(t)), o && Nn(o) && o.setAttribute("tabIndex", "-1"));
}, qu = function(e) {
  return e.current ? e.current.idPrefix : "";
}, wa = function(e, t, n, r, o) {
  if (!n)
    return [];
  for (var i = e + (o ? -1 : 1); i >= 0 && i < r.length; ) {
    var a = r[i][t];
    if (a !== n)
      return [a, [i, t]];
    i = i + (o ? -1 : 1);
  }
  return [];
}, _a = function(e, t, n, r, o) {
  if (!n)
    return [];
  for (var i = t + (o ? -1 : 1); i >= 0 && i < r[e].length; ) {
    var a = r[e][i];
    if (a !== n)
      return [a, [e, i]];
    i = i + (o ? -1 : 1);
  }
  return [];
}, Ln = function(e, t) {
  if (t) {
    for (var n = 0; n < e.length; n++)
      for (var r = 0; r < e[n].length; r++)
        if (e[n][r] === t)
          return [n, r];
  }
}, $u = function(e) {
  return e.current ? e.current.navigationMatrix.length : 0;
}, Xu = function(e) {
  return e ? "".concat(e).concat(Fu) : "";
}, J = {
  generateNavigatableId: Lu,
  getNavigatableId: ko,
  getNavigatableLevel: ju,
  getNavigatableElement: zu,
  getClosestNavigatableElement: Hu,
  getActiveElement: Bu,
  getClosestScope: Gu,
  getHeaderElement: ba,
  getBodyElement: xa,
  getFocusableElements: Uu,
  getNavigatableElements: Ku,
  filterNavigatableElements: Wu,
  focusElement: Vu,
  getIdPrefix: qu,
  isNavigatable: Nn,
  findNextIdByRowIndex: wa,
  findNextIdByCellIndex: _a,
  findId: Ln,
  getNextNavigationIndex: $u,
  getFilterColumnId: Xu
};
function Yu(e, t) {
  for (var n = e[t].depth, r = null, o = t + 1; o < e.length; o++)
    if (e[o].depth === n) {
      r = e[o];
      break;
    }
  return r;
}
var Oo = function(e) {
  var t = e.width ? parseFloat(e.width.toString()) : 0;
  return !t && e.children && e.children.length && (t = e.children.reduce(function(n, r) {
    return Oo(r) + n;
  }, 0)), t;
};
function Zu(e) {
  for (var t = [[]], n = 0, r = e.length - 1; r >= 0; r--)
    n = Math.max(n, e[r].depth), e[r].colSpan = e[r].colSpan || 1, e[r].parentIndex !== -1 && (e[e[r].parentIndex].colSpan = (e[e[r].parentIndex].colSpan || 0) + e[r].colSpan);
  var o = [], i = 1;
  return e.forEach(function(a, s) {
    t[a.depth] = t[a.depth] || [];
    var u = !1;
    t[a.depth].length === 0 && (i <= 1 ? i = 1 + (a.children.length > 0 ? 0 : n - a.depth) : (i--, u = !0)), a.rowSpan = 1 + (a.children.length > 0 ? 0 : n - a.depth), a.kFirst = u, a.index = t[a.depth].length, t[a.depth].push(s), a.ariaColumnIndex = o[a.depth] ? o[a.depth] + 1 : 1;
    for (var c = a.depth; c < a.depth + a.rowSpan; c++)
      o[c] = (o[c] || 0) + a.colSpan;
  }), Qu(t, e), Ju(t, e), t;
}
function Qu(e, t, n) {
  var r = new Array(e.length).fill(0), o = 0;
  t.forEach(function(i) {
    if (i.locked && (!i.left || n))
      if (i.left = r[i.depth], o = Oo(i), i.children.length === 0)
        for (var a = i.depth; a < r.length; a++)
          r[a] += o;
      else
        r[i.depth] += o;
  });
}
function Ju(e, t, n) {
  for (var r = 0, o = new Array(e.length).fill(0), i = t.length - 1; i >= 0; i--) {
    var a = t[i];
    if (a.locked && (!a.right || n)) {
      if (a.right = o[a.depth], r = Oo(a), a.children.length === 0)
        for (var s = a.depth; s < o.length; s++)
          o[s] += r;
      else
        o[a.depth] += r;
      var u = Yu(t, i);
      a.rightBorder = !(u && u.locked);
    }
  }
}
function Ea(e) {
  return !!(e && getComputedStyle(e).direction === "rtl");
}
function ui(e, t) {
  if (!t || !e || !e.originalEvent)
    return -1;
  for (var n = { x: e.clientX, y: e.originalEvent.clientY }, r = t.ownerDocument ? t.ownerDocument.elementFromPoint(n.x, n.y) : null; r && r.parentElement !== t; )
    r = r.parentElement;
  if (!r && t.matches("tr")) {
    var o = function(s) {
      var u = s.getBoundingClientRect();
      return n.x > u.left && n.x < u.left + u.width && n.y > u.top && n.y < u.top + u.height;
    };
    r = Array.from(t.children).find(o) || null;
  }
  for (var i = t.children, a = 0; a < i.length; a++)
    if (i[a] === r)
      return a;
  return -1;
}
var ec = globalThis && globalThis.__spreadArray || function(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, i; r < o; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
};
function tc(e) {
  var t = e.enabled, n = e.columns, r = n === void 0 ? [] : n, o = e.tableViewPortWidth, i = e.scrollLeft, a = r.map(function() {
    return 1;
  }), s = r.map(function() {
    return !1;
  });
  if (!t)
    return { colSpans: a, hiddenColumns: s };
  for (var u = r.map(function(S) {
    return parseFloat((S.width || "").toString()) || 10;
  }), c = 0, f = 0; f < r.length; f++)
    if (!r[f].locked) {
      var d = f < u.length - 1 ? u[f + 1] : 0;
      if (c + u[f] + d < i)
        s[f] = !0, c += u[f];
      else
        break;
    }
  var h = u.reduce(function(S, T) {
    return S + T;
  }, 0);
  c = 0;
  for (var f = r.length - 1; f >= 0; f--)
    if (!r[f].locked)
      if (c + 2 * u[f] < h - o - i)
        s[f] = !0, c += u[f];
      else
        break;
  for (var m = ec([], s, !0), g = function(S) {
    return S;
  }, y = m.lastIndexOf(!1), w = m.some(g), x = m.every(g), b, C; w && m.length && (y !== -1 || x); ) {
    for (y < m.length - 1 && (b = x ? m.length : m.length - y - 1, C = m.length - b, C === 0 && (C = b - 1), s[C] = !1, a[C] = b, m.splice(y + 1, b)); m.length && !m[m.length - 1]; )
      m.pop();
    y = m.lastIndexOf(!1), w = m.some(g), x = m.every(g);
  }
  return { colSpans: a, hiddenColumns: s };
}
var rc = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), ci = (
  /** @class */
  function(e) {
    rc(t, e);
    function t(n) {
      var r = e.call(this, n) || this;
      return r.elementRef = l.createRef(), r.state = {
        visible: !1,
        top: 0,
        left: 0,
        innerText: "",
        status: "k-i-cancel"
      }, r.hiddenElementRef = l.createRef(), r;
    }
    return Object.defineProperty(t.prototype, "element", {
      get: function() {
        return this.elementRef.current;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.render = function() {
      var n = this.hiddenElementRef.current, r = this.state.status, o = this.state.visible && xo && Ui(l.createElement(
        "div",
        { ref: this.elementRef, className: "k-header k-drag-clue", style: {
          display: "block",
          position: "absolute",
          zIndex: 2e4,
          padding: "8px 12px",
          top: this.state.top + "px",
          left: this.state.left + "px"
        } },
        l.createElement(pa, { className: "k-drag-status", name: r, icon: r === "k-i-cancel" ? Ll : Hi }),
        this.state.innerText
      ), n && n.ownerDocument ? n.ownerDocument.body : document.body);
      return l.createElement(
        l.Fragment,
        null,
        o,
        l.createElement("div", { ref: this.hiddenElementRef, style: { display: "none" } })
      );
    }, t;
  }(l.PureComponent)
), nc = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), fi = (
  /** @class */
  function(e) {
    nc(t, e);
    function t(n) {
      var r = e.call(this, n) || this;
      return r.state = {
        height: 0,
        visible: !1,
        left: 0,
        top: 0
      }, r.hiddenElementRef = l.createRef(), r;
    }
    return t.prototype.render = function() {
      var n = this.hiddenElementRef.current, r = this.state.visible && xo && Ui(l.createElement("div", { className: "k-grouping-dropclue", style: {
        zIndex: 1e4,
        display: "block",
        top: this.state.top + "px",
        left: this.state.left + "px",
        height: this.state.height + "px"
      } }), n && n.ownerDocument ? n.ownerDocument.body : document.body);
      return l.createElement(
        l.Fragment,
        null,
        r,
        l.createElement("div", { ref: this.hiddenElementRef, style: { display: "none" } })
      );
    }, t;
  }(l.PureComponent)
), jn = "groupId", di = "items", Ia = function(e, t, n) {
  e.items && (e[jn] = "".concat(n).concat(n && "_").concat(e.value).concat(e.field), t > 1 && e.items.forEach(function(r) {
    return Ia(r, t - 1, e[jn]);
  }));
}, oc = function(e) {
  var t = e.group;
  if (t && t.length && e.data)
    return e.data.forEach(function(n) {
      return Ia(n, t.length, "");
    });
}, ic = function(e) {
  return Cu(e.data, di, function(t) {
    return bu(t, di, {
      expanded: !e.collapsedIds.some(function(n) {
        return n === t[jn];
      })
    });
  });
}, hi = globalThis && globalThis.__spreadArray || function(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, i; r < o; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}, ac = function(e) {
  var t = e.navigatable, n = e.contextStateRef, r = e.navigationStateRef, o = e.idPrefix;
  t && (n.current = {
    activeId: "",
    level: 0
  }, r.current = {
    activeElementIsFocused: !1,
    prevNavigationIndexes: void 0,
    idPrefix: o || yu(),
    navigationMatrix: [],
    lastHeaderIndex: -1
  });
}, lc = function(e) {
  var t = e.scope, n = e.contextStateRef, r = e.navigationStateRef;
  if (n.current && r.current && t) {
    So(e);
    var o = r.current.navigationMatrix[0][0], i = J.getActiveElement(t, o);
    o && i && (n.current.activeId = o, i.setAttribute("tabIndex", "0"));
  }
}, sc = function(e) {
  var t = e.contextStateRef, n = e.navigationStateRef, r = e.document;
  if (t.current && n.current && r) {
    var o = Mu(r), i = J.getNavigatableId(o);
    i && i === t.current.activeId && (n.current.activeElementIsFocused = !0);
  }
}, uc = function(e) {
  var t = e.scope, n = e.contextStateRef, r = e.navigationStateRef;
  if (So(e), n.current && r.current && t) {
    var o = J.getActiveElement(t, n.current.activeId);
    if (!o) {
      var i = r.current.navigationMatrix[0][0], a = J.getActiveElement(t, i);
      i && a && (n.current.activeId = i, a.setAttribute("tabIndex", "0"), r.current.activeElementIsFocused && a.focus());
    }
    r.current.activeElementIsFocused = !1;
  }
}, cc = function(e, t) {
  var n = t.contextStateRef;
  if (!e.isDefaultPrevented() && n.current) {
    var r = e.target, o = J.getNavigatableId(r);
    if (o && o !== n.current.activeId) {
      var i = J.getClosestScope(r);
      if (!i)
        return;
      var a = J.getActiveElement(i, n.current.activeId);
      a && a.setAttribute("tabIndex", "-1"), r.setAttribute("tabIndex", "0"), n.current.activeId = o;
    }
  }
}, fc = function(e, t) {
  var n = t.contextStateRef, r = t.navigationStateRef, o = t.onNavigationAction;
  if (!e.isDefaultPrevented() && !(!n.current || !r.current)) {
    if (e.keyCode === Ye.esc) {
      var i = J.getClosestNavigatableElement(e.target);
      J.focusElement({ elementForFocus: i, event: e, contextStateRef: n });
      return;
    }
    var a = e.target, s = J.getNavigatableId(a), u = J.getNavigatableLevel(a), c = J.getClosestScope(a), f = r.current.navigationMatrix;
    if (u !== void 0 && c) {
      if (e.keyCode === Ye.enter) {
        var d = J.getNavigatableElement(a, { level: u + 1 });
        if (d) {
          J.focusElement({
            elementForFocus: d,
            event: e,
            contextStateRef: n,
            prevElement: a
          });
          return;
        } else {
          var i = J.getFocusableElements(a)[0];
          J.focusElement({ elementForFocus: i, event: e, contextStateRef: n, prevElement: a });
          return;
        }
      }
      if (e.keyCode === Ye.up || e.keyCode === Ye.down || e.keyCode === Ye.left || e.keyCode === Ye.right) {
        var h = e.keyCode === Ye.up || e.keyCode === Ye.left, m = e.keyCode === Ye.up || e.keyCode === Ye.down, g = void 0;
        if (r.current && r.current.prevNavigationIndexes) {
          var y = r.current.prevNavigationIndexes, w = y[0], x = y[1];
          f[w][x] === s ? g = r.current.prevNavigationIndexes : g = Ln(f, s);
        } else
          g = Ln(f, s);
        if (g) {
          var w = g[0], x = g[1], b = m ? wa(w, x, s, f, h) : _a(w, x, s, f, h), C = b[0], S = b[1];
          if (C) {
            var i = J.getActiveElement(c, C);
            J.focusElement({ elementForFocus: i, event: e, contextStateRef: n, prevElement: a }), r.current.prevNavigationIndexes = S, o && o({ focusElement: i, event: e });
          }
        }
      }
    }
  }
}, So = function(e) {
  var t = e.navigationStateRef, n = e.scope;
  if (!(!t.current || !n)) {
    var r = [], o = ba(n), i = xa(n);
    if (!(!o || !i)) {
      var a = Array.from(o.children), s = Array.from(i.children);
      hi(hi([], a, !0), s, !0).forEach(function(u, c) {
        Array.from(u.children).forEach(function(f) {
          var d = ko(f);
          if (d) {
            for (var h = f.rowSpan || 1, m = f.colSpan || 1, g, y = c, w = c + h; y < w; y++) {
              if (r[y] || (r[y] = []), g === void 0) {
                var x = r[y].findIndex(function(b) {
                  return !b;
                });
                g = x > -1 ? x : r[y].length;
              }
              r[y][g] = d || "";
            }
            for (var y = g + 1, w = g + m; y < w; y++)
              r[c][y] = d || "";
          }
        });
      }), t.current.navigationMatrix = r.filter(function(u) {
        return !!u;
      }), t.current.lastHeaderIndex = a.length - 1;
    }
  }
}, Ht = {
  onConstructor: ac,
  onComponentDidMount: lc,
  onGetSnapshotBeforeUpdate: sc,
  onComponentDidUpdate: uc,
  onFocus: cc,
  onKeyDown: fc,
  generateMatrix: So
}, ka = "data-grid-row-index", Oa = "data-grid-col-index", dc = "data-prevent-selection", zn = globalThis && globalThis.__assign || function() {
  return zn = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, zn.apply(this, arguments);
}, Wr = globalThis && globalThis.__spreadArray || function(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, i; r < o; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}, Ot = {}, hc = function(e, t) {
  if (!e || Array.isArray(e) && e.length === 0)
    return [t];
  var n = e.findIndex(function(r) {
    return r === t;
  });
  return n > -1 ? e.filter(function(r) {
    return r !== t;
  }) : Wr(Wr([], e, !0), [t], !1);
}, Bt = function(e, t) {
  for (var n = e; n; ) {
    if (n.tagName === t)
      return n;
    if (n.tagName === "TABLE")
      return null;
    n = n.parentElement;
  }
  return null;
}, pn = function(e) {
  if (e) {
    var t = e.getAttribute(ka);
    return t ? parseInt(t, 10) : void 0;
  }
}, gn = function(e) {
  if (e) {
    var t = e.getAttribute(Oa);
    return t ? parseInt(t, 10) : void 0;
  }
}, pc = function(e) {
  var t = e.event, n = e.dataItemKey, r = e.selectedState, o = t.dataItems, i = t.startRowIndex, a = t.endRowIndex, s = t.startColIndex, u = t.endColIndex, c = t.cell, f = t.isDrag, d = t.ctrlKey, h = t.shiftKey, m = t.metaKey, g = t.componentId, y = t.mode, w = t.dataItem, x = mu(n), b = {}, C = w !== null;
  if (y === "single") {
    var S = o.slice(i, i + 1)[0], T = x(S);
    Ot[g] = {
      rowIndex: i,
      colIndex: s
    }, b[T] = c ? [s] : !0;
  } else if (f || !h && !d && !m && !C) {
    f || (Ot[g] = {
      rowIndex: i,
      colIndex: s
    });
    for (var _ = [], k = s; k <= u; k++)
      _.push(k);
    var H = o.slice(i, a + 1);
    H.forEach(function(N) {
      var E = x(N);
      b[E] = c ? Wr([], _, !0) : !0;
    });
  } else if (d || m || C) {
    Ot[g] = {
      rowIndex: i,
      colIndex: s
    };
    var H = o.slice(i, a + 1), S = H[0], T = x(S);
    b = zn({}, r), b[T] = c && !C ? hc(b[T], s) : !b[T];
  } else if (h) {
    for (var L = Ot[g] && Ot[g].rowIndex || 0, B = Ot[g] && Ot[g].colIndex || 0, F = Math.min(L, i, a), G = Math.max(L, i, a), Z = Math.min(B, s, u), ee = Math.max(B, s, u), D = [], k = Z; k <= ee; k++)
      D.push(k);
    var H = o.slice(F, G + 1);
    H.forEach(function(E) {
      var j = x(E);
      b[j] = c ? Wr([], D, !0) : !0;
    });
  }
  return b;
}, gc = xu(), vc = function(e) {
  if (!e || !gc)
    return null;
  for (var t = e.parentElement; t; ) {
    if (window.getComputedStyle(t).transform !== "none")
      return t;
    t = t.parentElement;
  }
}, mc = function(e) {
  if (e && e.ownerDocument && e !== e.ownerDocument.body) {
    var t = e.getBoundingClientRect();
    return {
      left: t.left - e.scrollLeft,
      top: t.top - e.scrollTop
    };
  }
  return { left: 0, top: 0 };
}, Hn = function(e) {
  var t = e ? typeof e.enabled == "boolean" ? e.enabled : !0 : !1, n = e ? !!e.drag : !1, r = e && e.mode ? e.mode : "multiple", o = !!(e && e.cell);
  return { enabled: t, drag: n, mode: r, cell: o };
}, Vr = globalThis && globalThis.__assign || function() {
  return Vr = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, Vr.apply(this, arguments);
}, pi = function(e) {
  var t, n = e.onRelease, r = e.childRef, o = Hn(e.selectable), i = o.enabled, a = o.drag, s = o.mode, u = o.cell, c = l.useRef(null), f = l.useRef(null), d = l.useRef({ clientX: 0, clientY: 0 }), h = l.useState(null), m = h[0], g = h[1], y = l.useRef(), w = l.useRef(!1), x = l.useRef(!1), b = l.useCallback(function(_) {
    var k = _.event;
    x.current = k.originalEvent.target.hasAttribute(dc), !(x.current || !c.current) && (y.current = vc(c.current.element), d.current = {
      clientY: k.clientY,
      clientX: k.clientX
    });
  }, []), C = l.useCallback(function(_) {
    var k = _.event, H = d.current, L = H.clientX, B = H.clientY;
    if (!x.current && !(!a || s === "single") && ((Math.abs(B - k.clientY) > 5 || Math.abs(L - k.clientX) > 5) && (w.current = !0), w.current)) {
      var F = mc(y.current);
      g({
        top: Math.min(B, k.clientY) - F.top,
        left: Math.min(L, k.clientX) - F.left,
        width: Math.abs(k.clientX - L),
        height: Math.abs(k.clientY - B)
      });
    }
  }, [g, a, s]), S = l.useCallback(function(_) {
    var k = _.event, H = d.current, L = H.clientX, B = H.clientY;
    if (!(x.current || !c.current)) {
      var F = c.current.element && c.current.element.ownerDocument;
      if (F) {
        if (w.current) {
          var E = Math.min(B, k.clientY), j = Math.min(L, k.clientX), X = Math.max(B, k.clientY), se = Math.max(L, k.clientX), ie = f.current;
          if (!ie)
            return;
          ie.style.visibility = "hidden";
          var G = F.elementFromPoint(j, E), ce = F.elementFromPoint(se, X);
          if (ie.style.visibility = "", !G || !ce)
            return;
          var pe = Bt(G, "TD"), ae = Bt(pe, "TR"), ye = Bt(ce, "TD"), Se = Bt(ye, "TR"), P = gn(pe), M = pn(ae), U = gn(ye), W = pn(Se);
          P !== void 0 && M !== void 0 && U !== void 0 && W !== void 0 && n({
            nativeEvent: k.originalEvent,
            startRowIndex: M,
            startColIndex: P,
            endRowIndex: W,
            endColIndex: U,
            altKey: k.altKey,
            shiftKey: k.shiftKey,
            ctrlKey: k.ctrlKey,
            metaKey: k.metaKey,
            mode: s,
            cell: u,
            isDrag: !0
          });
        } else {
          var G = F.elementFromPoint(L, B);
          if (!G)
            return;
          var Z = Bt(G, "TD"), ee = Bt(G, "TR"), D = gn(Z), N = pn(ee);
          Z && ee && N !== void 0 && D !== void 0 && n({
            nativeEvent: k.originalEvent,
            startRowIndex: N,
            startColIndex: D,
            endRowIndex: N,
            endColIndex: D,
            altKey: k.altKey,
            shiftKey: k.shiftKey,
            ctrlKey: k.ctrlKey,
            metaKey: k.metaKey,
            mode: s,
            cell: u,
            isDrag: !1
          });
        }
        g(null), w.current = !1, d.current = { clientX: 0, clientY: 0 };
      }
    }
  }, [g, s, u, n]), T = _u(f);
  return i ? l.createElement(
    l.Fragment,
    null,
    l.createElement(ga, { onPress: b, onDrag: C, onRelease: S, ref: c, childRef: r }, e.children),
    m && po.createPortal(l.createElement("div", { ref: f, style: Vr(Vr({}, m), { position: "fixed" }), className: "k-marquee k-marquee-color" }), (t = T()) === null || t === void 0 ? void 0 : t.body)
  ) : l.cloneElement(l.Children.only(e.children), { ref: r });
}, At = function(e) {
  return null;
};
At.displayName = "KendoReactGridColumn";
At.defaultProps = {
  filterable: !0,
  editable: !0,
  sortable: !0,
  resizable: !0,
  reorderable: !0,
  groupable: !0
};
At.propTypes = {
  field: p.string,
  title: p.string,
  editable: p.bool,
  sortable: p.oneOfType([
    p.bool,
    p.shape({
      allowUnsort: p.bool.isRequired
    })
  ]),
  cell: p.any,
  filterCell: p.any,
  filterTitle: p.string,
  filterable: p.bool,
  filter: p.oneOf(["text", "numeric", "boolean", "date"]),
  editor: p.oneOf(["text", "numeric", "boolean", "date"]),
  width: p.oneOfType([p.string, p.number]),
  minResizableWidth: p.number,
  headerCell: p.any,
  footerCell: p.any,
  headerSelectionValue: p.bool,
  format: p.string,
  headerClassName: p.string,
  className: p.string,
  reorderable: p.bool,
  resizable: p.bool,
  orderIndex: p.number,
  groupable: p.bool,
  columnMenu: p.any,
  locked: p.bool
};
var Ie = globalThis && globalThis.__assign || function() {
  return Ie = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, Ie.apply(this, arguments);
}, yc = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function Ke(e, t) {
  var n = (e || "").split("."), r = t;
  return n.forEach(function(o) {
    r = r ? r[o] : void 0;
  }), r;
}
function Sa(e, t, n, r, o, i, a) {
  a === void 0 && (a = 0);
  for (var s = a, u = 0; u < t.length; u++) {
    if (!o || t[u].value === void 0 || t[u].items === void 0) {
      e[e.length] = {
        dataIndex: r.index,
        dataItem: t[u],
        rowType: "data",
        level: a,
        expanded: i === void 0 || Ke(i, t[u])
      }, r.index++;
      continue;
    }
    s = Math.max(s, a + 1);
    var c = i === void 0 || Ke(i, t[u]) === void 0 || Ke(i, t[u]);
    e[e.length] = {
      dataIndex: -1,
      dataItem: t[u],
      level: a,
      rowType: "groupHeader",
      expanded: c
    }, c && (s = Math.max(Sa(e, t[u].items, n, r, o, i, a + 1), s)), (n === "always" || c && n === "visible") && (e[e.length] = {
      dataIndex: -1,
      dataItem: t[u],
      rowType: "groupFooter",
      level: a,
      expanded: c
    });
  }
  return s;
}
function Pa(e, t, n, r) {
  r === void 0 && (r = 0);
  var o = [];
  if (!e)
    return [];
  e && e.length === void 0 && (e = [e]), e.forEach(function(u, c) {
    u = u.props ? u.props : u;
    var f = t[c] || null, d = Pa(u.children, f && f.children || [], n, r + 1);
    o.push(Object.assign({ depth: r }, At.defaultProps, d.length ? { cell: function() {
      return null;
    }, filterCell: function() {
      return null;
    } } : {}, f ? { width: f.width, orderIndex: f.orderIndex } : {}, u, {
      id: u.id ? u.id : J.generateNavigatableId("".concat(n.prevId++), n.idPrefix, "column"),
      declarationIndex: o.length,
      children: d,
      rowSpan: 0,
      colSpan: 0,
      isAccessible: !0
    }));
  });
  var i = function(u, c) {
    return u.orderIndex === c.orderIndex ? u.declarationIndex - c.declarationIndex : (u.orderIndex || 0) - (c.orderIndex || 0);
  };
  if (o.sort(i), r === 0) {
    var a = [], s = function(u, c) {
      return u.forEach(function(f) {
        f.parentIndex = c, s(f.children, a.push(f) - 1);
      });
    };
    return s(o, -1), a;
  }
  return o;
}
function Cc(e, t, n, r) {
  var o = [];
  Array.isArray(e) ? o = e : e && (o = e.data);
  var i = [];
  if (o.length > 0) {
    var a = o[0];
    if (t)
      for (var s = 0; s < t.length; s++)
        a = a.items && a.items[0];
    var u = Object.getOwnPropertyNames(a);
    u.forEach(function(c) {
      c !== n && i.push(Object.assign({
        id: J.generateNavigatableId("".concat(r.prevId++), r.idPrefix, "column"),
        declarationIndex: -1,
        parentIndex: -1,
        depth: 0,
        colSpan: 0,
        rowSpan: 0,
        index: 0,
        left: 0,
        right: 0,
        rightBorder: !1,
        children: [],
        ariaColumnIndex: 0,
        isAccessible: !0
      }, At.defaultProps, { field: c }));
    });
  }
  return i;
}
var bc = function(e, t) {
  for (var n = e[t.parentIndex]; n; ) {
    if (n.footerCell)
      return !0;
    n = e[n.parentIndex];
  }
  return !1;
}, xc = function(e) {
  return e.filter(function(t) {
    return bc(e, t) ? !1 : !!t.footerCell || !(t.children && t.children.length > 0);
  });
}, Ta = function(e) {
  return e.sort(function(t, n) {
    return t.declarationIndex - n.declarationIndex;
  }), e.map(function(t) {
    t.declarationIndex, t.parentIndex, t.depth, t.colSpan, t.rowSpan, t.index, t.kFirst;
    var n = t.children, r = yc(t, ["declarationIndex", "parentIndex", "depth", "colSpan", "rowSpan", "index", "kFirst", "children"]);
    return n.length ? Ie({ children: Ta(n) }, r) : r;
  });
}, gi = typeof window < "u" && /Firefox/.test(window.navigator.userAgent), vi = 17895697, on = function(e, t) {
  if (!(!e && !t))
    return t ? e ? Ie(Ie(Ie({}, e), t), { select: Ie(Ie({}, e.select || {}), t.select || {}), hierarchy: Ie(Ie({}, e.hierarchy || {}), t.hierarchy || {}), group: Ie(Ie({}, e.group || {}), t.group || {}), edit: Ie(Ie({}, e.edit || {}), t.edit || {}) }) : t : e;
}, cr = globalThis && globalThis.__assign || function() {
  return cr = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, cr.apply(this, arguments);
}, wc = function(e) {
  var t, n = l.useCallback(function(h) {
    e.selectionChange && e.selectionChange({ syntheticEvent: h });
  }, [e.selectionChange]), r = l.useMemo(function() {
    return tn();
  }, []), o = Ke(e.field, e.dataItem), i = ht(e.id), a = cr((t = { colSpan: e.colSpan, style: e.style, className: e.className }, t["aria-colindex"] = e.ariaColumnIndex, t.role = "gridcell", t), i), s = [
    l.createElement("input", { key: "1", checked: typeof o == "boolean" && o, id: r, type: "checkbox", className: "k-checkbox k-checkbox-md k-rounded-md", onChange: n }),
    l.createElement("label", { className: "k-checkbox-label", htmlFor: r, key: "2" })
  ], u = e.rowType !== "groupHeader" ? l.createElement("td", cr({}, a), s) : null, c = e.rowType || "data", f = e.cells;
  if (f && f.select && f.select[c]) {
    var d = f.select[c];
    return l.createElement(d, cr({}, e, { tdProps: a }), s);
  }
  return e.render ? e.render.call(void 0, u, e) : u;
}, R, Bn = "grid.noRecords", _c = "grid.pagerInfo", Ec = "grid.pagerFirstPage", Ic = "grid.pagerPreviousPage", kc = "grid.pagerNextPage", Oc = "grid.pagerLastPage", Sc = "grid.pagerItemsPerPage", Pc = "grid.pagerPage", Tc = "grid.pagerOf", Rc = "grid.pagerTotalPages", Gn = "grid.groupPanelEmpty", Dc = "grid.groupColumn", Un = "grid.ungroupColumn", Kn = "grid.columnMenu", Mt = "grid.filterClearButton", vr = "grid.filterSubmitButton", mr = "grid.filterTitle", Ac = "grid.sortAscending", Mc = "grid.sortDescending", Wn = "grid.searchPlaceholder", Vn = "grid.filterCheckAll", qn = "grid.filterChooseOperator", $n = "grid.filterSelectedItems", Xn = "grid.sortAriaLabel", Yn = "grid.filterAriaLabel", Zn = "grid.groupPanelAriaLabel", Ra = "grid.groupExpand", Da = "grid.groupCollapse", Aa = "grid.detailExpand", Ma = "grid.detailCollapse", ue = (R = {}, R[Aa] = "Expand detail row", R[Ma] = "Collapse detail row", R[Ra] = "Expand group", R[Da] = "Collapse Group", R[Bn] = "No records available", R[Gn] = "Drag a column header and drop it here to group by that column", R[Mt] = "Clear", R[vr] = "Filter", R[mr] = "Filter", R[Ac] = "Sort Ascending", R[Mc] = "Sort Descending", R[Xn] = "Sortable", R[Dc] = "Group Column", R[Un] = "Ungroup Column", R[Kn] = "Column menu", R[Sc] = "items per page", R[_c] = "{0} - {1} of {2} items", R[Ec] = "Go to the first page", R[Ic] = "Go to the previous page", R[kc] = "Go to the next page", R[Oc] = "Go to the last page", R[Pc] = "Page", R[Tc] = "of", R[Rc] = "{0}", R[Wn] = "Search", R[Vn] = "Check All", R[qn] = "Choose Operator", R[$n] = "selected items", R[Yn] = "Filter", R[Zn] = "Group panel", R["grid.filterEqOperator"] = "Is equal to", R["grid.filterNotEqOperator"] = "Is not equal to", R["grid.filterIsNullOperator"] = "Is null", R["grid.filterIsNotNullOperator"] = "Is not null", R["grid.filterIsEmptyOperator"] = "Is empty", R["grid.filterIsNotEmptyOperator"] = "Is not empty", R["grid.filterStartsWithOperator"] = "Starts with", R["grid.filterContainsOperator"] = "Contains", R["grid.filterNotContainsOperator"] = "Does not contain", R["grid.filterEndsWithOperator"] = "Ends with", R["grid.filterGteOperator"] = "Is greater than or equal to", R["grid.filterGtOperator"] = "Is greater than", R["grid.filterLteOperator"] = "Is less than or equal to", R["grid.filterLtOperator"] = "Is less than", R["grid.filterIsTrue"] = "Is true", R["grid.filterIsFalse"] = "Is false", R["grid.filterBooleanAll"] = "(All)", R["grid.filterAfterOrEqualOperator"] = "Is after or equal to", R["grid.filterAfterOperator"] = "Is after", R["grid.filterBeforeOperator"] = "Is before", R["grid.filterBeforeOrEqualOperator"] = "Is before or equal to", R["grid.filterAndLogic"] = "And", R["grid.filterOrLogic"] = "Or", R);
function Fc(e) {
  var t = e.replace(/^pager\.([a-z])/, function(n, r) {
    return "grid.pager" + r.toUpperCase();
  });
  return { messageKey: t, defaultMessage: ue[t] };
}
var Tt = globalThis && globalThis.__assign || function() {
  return Tt = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, Tt.apply(this, arguments);
}, Nc = function(e) {
  var t = null, n = null, r = null, o = Ke(e.field, e.dataItem), i = ht(e.id), a = ji(), s = l.useCallback(function(m) {
    m.isDefaultPrevented() || m.keyCode === yo.enter && e.onChange && (m.preventDefault(), e.onChange({
      dataItem: e.dataItem,
      dataIndex: e.dataIndex,
      syntheticEvent: m,
      field: e.field,
      value: !o
    }));
  }, [e.dataItem, e.dataIndex, e.field, e.onChange, o]);
  if (e.rowType === "groupFooter")
    n = Tt({ className: "k-table-td k-hierarchy-cell", role: "gridcell" }, i), t = l.createElement("td", Tt({}, n));
  else if (e.rowType !== "groupHeader") {
    var u = o ? Ma : Aa, c = a.toLanguageString(u, ue[u]);
    n = Tt({ className: "k-table-td k-hierarchy-cell", onKeyDown: s, "aria-expanded": !!o, role: "gridcell", "aria-colindex": e.ariaColumnIndex }, i), r = l.createElement(
      "a",
      { onClick: function(m) {
        m.preventDefault(), e.onChange && e.onChange({
          dataItem: e.dataItem,
          dataIndex: e.dataIndex,
          syntheticEvent: m,
          field: e.field,
          value: !o
        });
      }, "aria-label": c, href: "#", tabIndex: -1 },
      l.createElement(ot, { name: o ? "minus" : "plus", icon: o ? jl : Hi })
    ), t = l.createElement("td", Tt({}, n), r);
  }
  var f = e.rowType || "data", d = e.cells;
  if (d && d.hierarchy && d.hierarchy[f]) {
    var h = d.hierarchy[f];
    return l.createElement(h, Tt({}, e, { tdProps: n }), r);
  }
  return e.render ? e.render.call(void 0, t, e) : t;
}, Lc = ka, or = Oa, Ue = globalThis && globalThis.__assign || function() {
  return Ue = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, Ue.apply(this, arguments);
}, jc = function(e) {
  var t, n, r, o, i, a = Ke(e.field, e.dataItem), s = null, u = le("k-table-td", "k-grid-edit-cell", (t = {}, t["k-selected"] = e.isSelected, t), e.className), c = l.useMemo(function() {
    return tn();
  }, []), f = ht(e.id), d = null, h = null, m = l.useCallback(function(C) {
    if (e.onChange) {
      var S = C.target.type === "checkbox" ? C.target.checked : C.target.value;
      e.onChange({
        dataItem: e.dataItem,
        dataIndex: e.dataIndex,
        field: e.field,
        syntheticEvent: C,
        value: S
      });
    }
  }, [e.onChange, e.dataItem, e.dataIndex, e.field]), g = l.useCallback(function(C) {
    e.onContextMenu && e.onContextMenu.call(void 0, C, e.dataItem, e.field);
  }, [e.onContextMenu, e.dataItem, e.field]), y = l.useCallback(function(C) {
    e.onChange && e.onChange({
      dataItem: e.dataItem,
      dataIndex: e.dataIndex,
      field: e.field,
      syntheticEvent: C.syntheticEvent,
      value: C.value
    });
  }, [e.onChange, e.dataItem, e.dataIndex, e.field]);
  switch (e.editor) {
    case "numeric":
      d = Ue((n = { onContextMenu: g, colSpan: e.colSpan, style: e.style, className: u }, n["aria-colindex"] = e.ariaColumnIndex, n["aria-selected"] = e.isSelected, n[or] = e.columnIndex, n.role = "gridcell", n), f), h = l.createElement(go, { width: "100%", value: a === void 0 ? null : a, onChange: y }), s = l.createElement("td", Ue({}, d), h);
      break;
    case "date":
      d = Ue((r = { onContextMenu: g, colSpan: e.colSpan, style: e.style, className: u }, r["aria-colindex"] = e.ariaColumnIndex, r["aria-selected"] = e.isSelected, r[or] = e.columnIndex, r.role = "gridcell", r), f), h = l.createElement(vo, { width: "100%", value: a, onChange: y }), s = l.createElement("td", Ue({}, d), h);
      break;
    case "boolean":
      d = Ue((o = { onContextMenu: g, colSpan: e.colSpan, style: e.style, className: u }, o["aria-colindex"] = e.ariaColumnIndex, o["aria-selected"] = e.isSelected, o[or] = e.columnIndex, o.role = "gridcell", o), f), h = [
        l.createElement("input", { checked: a || !1, id: c, type: "checkbox", className: "k-checkbox k-checkbox-md k-rounded-md", onChange: m, key: 1 }),
        l.createElement("label", { className: "k-checkbox-label", htmlFor: c, key: 2 })
      ], s = l.createElement("td", Ue({}, d), h);
      break;
    default:
      d = Ue((i = { onContextMenu: g, colSpan: e.colSpan, style: e.style, className: u }, i["aria-colindex"] = e.ariaColumnIndex, i["aria-selected"] = e.isSelected, i[or] = e.columnIndex, i.role = "gridcell", i), f), h = l.createElement("input", { style: { width: "100%" }, className: "k-input", value: a || "", onChange: m }), s = l.createElement("td", Ue({}, d), h);
  }
  var w = e.editor || "text", x = e.cells;
  if (x && x.edit && x.edit[w]) {
    var b = x.edit[w];
    return l.createElement(b, Ue({}, e, { tdProps: d }), h);
  }
  return e.render ? e.render.call(void 0, s, e) : s;
}, zc = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), qr = globalThis && globalThis.__assign || function() {
  return qr = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, qr.apply(this, arguments);
}, Hc = (
  /** @class */
  function(e) {
    zc(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.headerWrap = null, n.table = null, n.syncScroll = !1, n.scrollbarWidth = sa(), n.onScroll = function(r) {
        if (n.syncScroll) {
          n.syncScroll = !1;
          return;
        }
        if (n.headerWrap) {
          var o = n.headerWrap.scrollLeft, i = n.props.scrollableDataElement();
          i && i.scrollLeft !== o && (i.scrollLeft = o);
        }
      }, n;
    }
    return Object.defineProperty(t.prototype, "element", {
      get: function() {
        return this.props.elemRef.current;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.componentDidMount = function() {
      var n = Ea(this.element);
      this.props.columnResize && this.props.columnResize.setIsRtl(n), this.forceUpdate();
    }, t.prototype.setScrollLeft = function(n) {
      this.headerWrap && this.headerWrap.scrollLeft !== n && (this.syncScroll = !0, this.headerWrap.scrollLeft = n);
    }, t.prototype.setWidth = function(n) {
      this.table && (this.table.style.width = n + "px");
    }, t.prototype.render = function() {
      var n, r = this;
      return this.props.staticHeaders ? l.createElement(
        "div",
        { ref: this.props.elemRef, className: le("k-grid-header", { "k-grid-draggable-header": this.props.draggable }), role: "presentation" },
        l.createElement(
          "div",
          { ref: function(o) {
            r.headerWrap = o;
          }, className: "k-grid-header-wrap", style: this.scrollbarWidth ? {} : { borderWidth: 0 }, onScroll: this.onScroll, role: "presentation" },
          l.createElement(
            "table",
            { ref: function(o) {
              r.table = o;
            }, className: le("k-table k-grid-header-table", (n = {
              "k-table-md": !this.props.size
            }, n["k-table-".concat(Dt.sizeMap[this.props.size] || this.props.size)] = this.props.size, n), this.props.className), role: "presentation" },
            l.createElement("colgroup", { ref: function(o) {
              r.props.columnResize.colGroupHeader = o;
            } }, this.props.cols),
            l.createElement(
              "thead",
              qr({ className: "k-table-thead", role: "rowgroup" }, li),
              this.props.headerRow,
              this.props.filterRow
            )
          )
        )
      ) : l.createElement(
        "thead",
        qr({ role: "presentation", className: le("k-table-thead", { "k-grid-draggable-header": this.props.draggable }) }, li),
        this.props.headerRow,
        this.props.filterRow
      );
    }, t;
  }(l.Component)
), Bc = globalThis && globalThis.__spreadArray || function(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, i; r < o; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}, Gc = function() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return Object.assign.apply(Object, Bc([{ allowUnsort: !0, mode: "single" }], e, !1));
}, Uc = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Kc = (
  /** @class */
  function(e) {
    Uc(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.draggable = null, n.isDragged = !1, n.onDrag = function(r) {
        n.isDragged = !0;
        var o = n.draggable && n.draggable.element;
        o && n.props.resize(r.event, o, !1);
      }, n.onRelease = function(r) {
        if (n.isDragged) {
          var o = n.draggable && n.draggable.element;
          o && n.props.resize(r.event, o, !0), n.isDragged = !1;
        }
      }, n.onDoubleClick = function(r) {
        if (!n.isDragged) {
          var o = n.draggable && n.draggable.element;
          o && n.props.autofit(r, o);
        }
      }, n;
    }
    return t.prototype.render = function() {
      var n = this;
      return l.createElement(
        rn,
        { onPress: function(r) {
          r.event.originalEvent.stopPropagation();
        }, onDrag: this.onDrag, onRelease: this.onRelease, ref: function(r) {
          n.draggable = r;
        } },
        l.createElement("span", { className: "k-column-resizer", style: { touchAction: "none" }, draggable: !1, onDoubleClick: this.onDoubleClick })
      );
    }, t;
  }(l.Component)
), Wc = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Vc = (
  /** @class */
  function(e) {
    Wc(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.draggable = null, n.onPress = function(r) {
        var o = n.draggable && n.draggable.element;
        o && n.props.pressHandler && n.props.pressHandler(r.event, o);
      }, n.onDrag = function(r) {
        var o = n.draggable && n.draggable.element;
        o && n.props.dragHandler && n.props.dragHandler(r.event, o);
      }, n.onRelease = function(r) {
        var o = n.draggable && n.draggable.element;
        o && n.props.releaseHandler && n.props.releaseHandler(r.event);
      }, n;
    }
    return t.prototype.render = function() {
      var n = this;
      return l.createElement(
        rn,
        { onPress: this.onPress, onDrag: this.onDrag, onRelease: this.onRelease, hint: this.props.dragClue, autoScroll: { boundaryElementRef: this.props.headerRef, direction: { horizontal: !0, vertical: !1 } }, scrollContainer: this.props.containerRef || void 0, ref: function(r) {
          n.draggable = r;
        } },
        l.createElement("tr", { className: "k-table-row", style: { touchAction: "none" }, role: "row", "aria-rowindex": this.props.ariaRowIndex }, this.props.children)
      );
    }, t;
  }(l.PureComponent)
), qc = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Qn = globalThis && globalThis.__assign || function() {
  return Qn = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, Qn.apply(this, arguments);
}, $c = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}, Fa = (
  /** @class */
  function(e) {
    qc(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.state = {
        show: !1
      }, n._anchor = null, n._content = null, n.blurTimeout = void 0, n.willBlur = !1, n.blur = function() {
        if (n.willBlur) {
          n.willBlur = !1;
          return;
        }
        clearTimeout(n.blurTimeout), n.blurTimeout = window.setTimeout(function() {
          n.closeMenu();
        });
      }, n.focus = function() {
        clearTimeout(n.blurTimeout);
      }, n.anchorClick = function(r) {
        r.preventDefault(), n.setState({
          show: !n.state.show
        }, function() {
          return n.state.show && n._content && n._content.focus();
        });
      }, n.closeMenu = function() {
        n.setState({ show: !1 });
      }, n.onAnchorMouseDown = function(r) {
        n.willBlur = n.state.show && r.currentTarget === n._anchor;
      }, n;
    }
    return t.prototype.render = function() {
      var n = this, r = this.props, o = r.columnMenu, i = $c(r, ["columnMenu"]), a = this.props.column, s = We(this), u = a.field ? "".concat(a.field, " ") : "";
      return l.createElement(
        l.Fragment,
        null,
        l.createElement(
          "a",
          { className: "k-grid-header-menu k-grid-column-menu", ref: function(c) {
            return n._anchor = c;
          }, onClick: this.anchorClick, onMouseDown: this.onAnchorMouseDown, href: "#", title: "".concat(u).concat(s.toLanguageString(Kn, ue[Kn])) },
          l.createElement(ot, { name: "more-vertical", icon: zl })
        ),
        l.createElement(
          Li,
          { anchor: this._anchor, show: this.state.show },
          l.createElement("div", { ref: function(c) {
            return n._content = c;
          }, className: "k-grid-columnmenu-popup", tabIndex: 0, onBlur: this.blur, onFocus: this.focus, style: { outline: "none" } }, o && l.createElement(o, Qn({}, i, { onCloseMenu: this.closeMenu })))
        )
      );
    }, t;
  }(l.Component)
), Xc = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), $r = globalThis && globalThis.__assign || function() {
  return $r = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, $r.apply(this, arguments);
}, Yc = (
  /** @class */
  function(e) {
    Xc(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.render = function() {
      var n = this.props.columnMenuWrapperProps, r = this.props.onClick ? {
        onClick: this.props.onClick
      } : {}, o = l.createElement(
        "span",
        { className: "k-cell-inner" },
        l.createElement(
          "span",
          $r({ className: le("k-link", {
            "!k-cursor-default": !this.props.columnMenuWrapperProps.sortable
          }) }, r),
          l.createElement("span", { className: "k-column-title" }, this.props.title || this.props.field || " "),
          this.props.children
        ),
        n.columnMenu && l.createElement(Fa, $r({}, n))
      );
      return this.props.render ? this.props.render.call(void 0, o, this.props) : o;
    }, t;
  }(l.Component)
), Zc = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), fr = globalThis && globalThis.__assign || function() {
  return fr = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, fr.apply(this, arguments);
}, Qc = {
  true: { asc: "desc", desc: "", "": "asc" },
  false: { asc: "desc", desc: "asc", "": "asc" }
}, Jc = {
  none: "none",
  asc: "ascending",
  desc: "descending"
}, Na = (
  /** @class */
  function(e) {
    Zc(t, e);
    function t(n) {
      var r = e.call(this, n) || this;
      return r.serviceIndex = 0, r.index = -1, r.cellKeyDown = function(o, i) {
        o.isDefaultPrevented() || o.keyCode === yo.enter && r.cellClick(o, i);
      }, r.cells = function(o) {
        return o.map(function(i) {
          var a = r.props.columns[i], s = r.props.sortable && a.sortable, u = r.props.sort ? r.props.sort.findIndex(function(_) {
            return _.field === a.field;
          }) : -1, c = u >= 0 && r.props.sort[u].dir || "none", f = a.columnMenu === null ? null : a.columnMenu || r.props.columnMenu, d = le({
            "k-first": a.kFirst,
            "k-filterable": !!f,
            "k-table-th": !0,
            "k-header": !0,
            "k-grid-header-sticky": a.locked,
            "k-sorted": r.props.sort && r.props.sort.some(function(_) {
              return _.field === a.field;
            })
          }, a.headerClassName), h = a.left !== void 0 ? r.props.isRtl ? { left: a.right, right: a.left } : { left: a.left, right: a.right } : {}, m = We(r).toLanguageString(Xn, ue[Xn]), g = a.isAccessible ? {
            ariaSort: Jc[c],
            role: "columnheader",
            ariaColumnIndex: a.ariaColumnIndex,
            ariaSelected: !1,
            ariaDescription: s ? m : ""
          } : {
            role: "presentation"
          }, y = a.declarationIndex >= 0 ? ++r.index : --r.serviceIndex, w = a.headerCell ? a.headerCell : Yc, x = l.createElement(w, { key: 1, field: a.field, onClick: s && function(_) {
            return r.cellClick(_, a);
          } || void 0, selectionChange: r.props.selectionChange, title: a.title, selectionValue: a.headerSelectionValue, render: r.props.cellRender, children: r.sortIcon(u), columnMenuWrapperProps: {
            column: {
              field: a.field,
              filter: a.filter
            },
            sortable: s && r.props.sortable,
            sort: r.props.sort,
            onSortChange: r.props.sortChange,
            filter: r.props.filter,
            filterable: r.props.filterable && a.filterable,
            filterOperators: r.props.filterOperators,
            onFilterChange: r.props.filterChange,
            group: r.props.group,
            groupable: r.props.groupable,
            onGroupChange: r.props.groupChange,
            columnMenu: f
          } }), b = fr(fr({}, g), { key: y, colSpan: a.colSpan, rowSpan: a.rowSpan, className: d, style: h, columnId: a.id, navigatable: a.navigatable, onKeyDown: s && function(_) {
            return r.cellKeyDown(_, a);
          } || void 0, role: "columnheader" }), C = [
            x,
            r.props.columnResize && r.props.columnResize.resizable && a.resizable && l.createElement(Kc, { key: 2, resize: function(_, k, H) {
              return r.props.columnResize && r.props.columnResize.dragHandler(_, a, k, H);
            }, autofit: function(_) {
              return r.props.columnResize && r.props.columnResize.dblClickHandler(_, [a.id]);
            } })
          ], S = on(r.props.cells, a.cells);
          if (S && S.headerCell) {
            var T = S.headerCell;
            return l.createElement(T, { key: y, thProps: b, index: i }, C);
          }
          return l.createElement(Io, fr({}, b, { key: y }), C);
        });
      }, r.cellClick = r.cellClick.bind(r), r;
    }
    return t.prototype.cellClick = function(n, r) {
      if (n.preventDefault(), !!this.props.sortChange) {
        var o = Gc(this.props.sortable || !1, r.sortable || !1), i = o.allowUnsort, a = o.mode, s = (this.props.sort || []).filter(function(f) {
          return f.field === r.field;
        })[0], u = Qc[i][s && s.dir || ""], c = a === "single" ? [] : (this.props.sort || []).filter(function(f) {
          return f.field !== r.field;
        });
        u !== "" && r.field && c.push({ field: r.field, dir: u }), this.props.sortChange(c, n);
      }
    }, t.prototype.sortIcon = function(n) {
      return this.props.sort ? n >= 0 && [
        l.createElement(
          "span",
          { key: 1, className: "k-sort-icon" },
          l.createElement(ot, { name: "sort-" + this.props.sort[n].dir + "-small", icon: this.props.sort[n].dir === "asc" ? Bi : Gi })
        ),
        this.props.sort.length > 1 && l.createElement(
          "span",
          { key: 2, className: "k-sort-icon" },
          l.createElement("span", { className: "k-sort-order" }, n + 1)
        )
      ] : null;
    }, t.prototype.render = function() {
      var n = this;
      return this.serviceIndex = 0, this.index = -1, this.props.columnsMap.map(function(r, o) {
        return n.props.pressHandler && l.createElement(Vc, { key: o, pressHandler: n.props.pressHandler, dragHandler: n.props.dragHandler, releaseHandler: n.props.releaseHandler, ariaRowIndex: o + 1, dragClue: n.props.dragClue, headerRef: n.props.headerRef, containerRef: n.props.containerRef }, n.cells(r)) || l.createElement("tr", { className: "k-table-row", role: "row", "aria-rowindex": o + 1 }, n.cells(r));
      });
    }, t;
  }(l.Component)
);
dt(Na);
var ef = [
  { text: "grid.filterAndLogic", operator: "and" },
  { text: "grid.filterOrLogic", operator: "or" }
], mi = {
  text: [
    { text: "grid.filterContainsOperator", operator: "contains" },
    { text: "grid.filterNotContainsOperator", operator: "doesnotcontain" },
    { text: "grid.filterEqOperator", operator: "eq" },
    { text: "grid.filterNotEqOperator", operator: "neq" },
    { text: "grid.filterStartsWithOperator", operator: "startswith" },
    { text: "grid.filterEndsWithOperator", operator: "endswith" },
    { text: "grid.filterIsNullOperator", operator: "isnull" },
    { text: "grid.filterIsNotNullOperator", operator: "isnotnull" },
    { text: "grid.filterIsEmptyOperator", operator: "isempty" },
    { text: "grid.filterIsNotEmptyOperator", operator: "isnotempty" }
  ],
  numeric: [
    { text: "grid.filterEqOperator", operator: "eq" },
    { text: "grid.filterNotEqOperator", operator: "neq" },
    { text: "grid.filterGteOperator", operator: "gte" },
    { text: "grid.filterGtOperator", operator: "gt" },
    { text: "grid.filterLteOperator", operator: "lte" },
    { text: "grid.filterLtOperator", operator: "lt" },
    { text: "grid.filterIsNullOperator", operator: "isnull" },
    { text: "grid.filterIsNotNullOperator", operator: "isnotnull" }
  ],
  date: [
    { text: "grid.filterEqOperator", operator: "eq" },
    { text: "grid.filterNotEqOperator", operator: "neq" },
    { text: "grid.filterAfterOrEqualOperator", operator: "gte" },
    { text: "grid.filterAfterOperator", operator: "gt" },
    { text: "grid.filterBeforeOperator", operator: "lt" },
    { text: "grid.filterBeforeOrEqualOperator", operator: "lte" },
    { text: "grid.filterIsNullOperator", operator: "isnull" },
    { text: "grid.filterIsNotNullOperator", operator: "isnotnull" }
  ],
  boolean: [
    { text: "grid.filterEqOperator", operator: "eq" }
  ]
}, rt = function(e) {
  return e === "isnull" || e === "isnotnull" || e === "isempty" || e === "isnotempty";
}, dr = function(e, t) {
  return e.map(function(n) {
    return {
      text: t.toLanguageString(n.text, ue[n.text]),
      operator: n.operator
    };
  });
}, tf = "eq", La = [
  { text: "grid.filterBooleanAll", operator: "" },
  { text: "grid.filterIsTrue", operator: !0 },
  { text: "grid.filterIsFalse", operator: !1 }
], rf = {
  text: !1,
  numeric: !1,
  date: !1,
  boolean: !0
}, ja = function(e, t, n) {
  var r = za(n.operators), o = n.operator;
  switch (n.filterType) {
    case "numeric":
      (!o || rt(o)) && (o = r), e === null && o === r && (o = "");
      break;
    case "date":
      (!o || rt(o)) && (o = r), e === null && o === r && (o = "");
      break;
    case "text":
      (!o || rt(o)) && (o = r), !e && o === r && (o = "");
      break;
    default:
      return;
  }
  n.onChange({ value: e, operator: o, syntheticEvent: t });
}, za = function(e, t) {
  return t ? e[t][0].operator : e[0].operator;
}, Jn = function(e) {
  return e || "text";
}, Ha = function(e, t) {
  var n = e.target.value;
  t({
    value: n.operator,
    operator: n.operator === "" ? "" : tf,
    syntheticEvent: e.syntheticEvent
  });
}, Ba = function(e, t, n) {
  var r = t, o = e.target.value;
  e.target.state.opened && (rt(o.operator) && (r = null), t === null && !rt(o.operator) && (r = void 0), n({ value: r, operator: o.operator, syntheticEvent: e.syntheticEvent }));
}, nf = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Ga = (
  /** @class */
  function(e) {
    nf(t, e);
    function t(n) {
      var r = e.call(this, n) || this;
      return r.renderOperatorEditor = function(o) {
        if (r.props.filterType !== "boolean") {
          var i = r.props.operators.find(function(a) {
            return a.operator === r.props.operator;
          }) || null;
          return l.createElement(gr, { size: r.props.size, value: i, onChange: r.operatorChange, className: "k-dropdown-operator", iconClassName: "k-i-filter k-icon", svgIcon: Qr, data: r.props.operators, textField: "text", title: o.toLanguageString(qn, ue[qn]), popupSettings: {
            width: ""
          } });
        }
      }, r.inputChange = r.inputChange.bind(r), r.clear = r.clear.bind(r), r.operatorChange = r.operatorChange.bind(r), r.boolDropdownChange = r.boolDropdownChange.bind(r), r;
    }
    return t.prototype.render = function() {
      var n, r = We(this), o = l.createElement(
        "div",
        { className: "k-filtercell" },
        l.createElement(
          "div",
          { className: "k-filtercell-wrapper" },
          this.filterComponent(this.props.filterType, this.props.value, this.props.booleanValues),
          l.createElement(
            "div",
            { className: "k-filtercell-operator" },
            this.renderOperatorEditor(r),
            " ",
            l.createElement(nt, { size: this.props.size, icon: "filter-clear", svgIcon: Hl, className: le((n = {}, n["k-clear-button-visible"] = !!(!(this.props.value === null || this.props.value === "") || this.props.operator), n)), title: r.toLanguageString(Mt, ue[Mt]), type: "button", onClick: this.clear, disabled: !(!(this.props.value === null || this.props.value === "") || this.props.operator) })
          )
        )
      );
      return this.props.render ? this.props.render.call(void 0, o, this.props) : o;
    }, t.prototype.inputChange = function(n, r) {
      ja(n, r, this.props);
    }, t.prototype.operatorChange = function(n) {
      Ba(n, this.props.value, this.props.onChange);
    }, t.prototype.boolDropdownChange = function(n) {
      Ha(n, this.props.onChange);
    }, t.prototype.clear = function(n) {
      n.preventDefault(), this.props.onChange({ value: "", operator: "", syntheticEvent: n });
    }, t.prototype.filterComponent = function(n, r, o) {
      var i = this;
      switch (n) {
        case "numeric":
          return l.createElement(go, { size: this.props.size, value: r, onChange: function(s) {
            i.inputChange(s.value, s.syntheticEvent);
          }, title: this.props.title, ariaLabel: this.props.ariaLabel });
        case "date":
          return l.createElement(vo, { size: this.props.size, value: r, onChange: function(s) {
            i.inputChange(s.value, s.syntheticEvent);
          }, title: this.props.title, ariaLabel: this.props.ariaLabel });
        case "boolean":
          var a = function(s) {
            return s == null;
          };
          return l.createElement(gr, { size: this.props.size, onChange: this.boolDropdownChange, value: o.find(function(s) {
            return s.operator === (a(r) ? "" : r);
          }), data: o, textField: "text", title: this.props.title, ariaLabel: this.props.ariaLabel });
        default:
          return l.createElement(Zl, { size: this.props.size, value: r || "", onChange: function(s) {
            i.inputChange(s.target.value, s.syntheticEvent);
          }, title: this.props.title, "aria-label": this.props.ariaLabel });
      }
    }, t;
  }(l.Component)
);
dt(Ga);
var of = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Rt = globalThis && globalThis.__assign || function() {
  return Rt = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, Rt.apply(this, arguments);
}, af = "k-table-row k-filter-row", Ua = (
  /** @class */
  function(e) {
    of(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.headerCellClassName = function(n, r) {
      var o = "".concat(r ? "k-grid-header-sticky" : "");
      return this.props.sort && this.props.sort.filter(function(i) {
        return i.field === n;
      }).length > 0 && (o += " k-sorted"), o;
    }, t.prototype.setFilter = function(n, r, o, i) {
      if (this.props.filterChange) {
        var a = [];
        if ((n !== "" && n !== null || r !== "") && a.push({
          field: o,
          operator: r,
          value: n
        }), this.props.filter && this.props.filter.filters) {
          var s = this.props.filter.filters || [];
          s.forEach(function(c) {
            var f = c;
            f && f.field !== o && a.push(f);
          });
        }
        var u = this.props.filter && this.props.filter.logic ? this.props.filter.logic : "and";
        this.props.filterChange(a.length > 0 ? { logic: u, filters: a } : null, i);
      }
    }, t.prototype.render = function() {
      var n = this, r = We(this), o = this.props.filter && this.props.filter.filters || [], i = function(c) {
        if (c !== void 0) {
          var f = o.filter(function(d) {
            return d.field === c;
          });
          return f.length ? f[0] : void 0;
        }
      }, a = 0, s = -1, u = this.props.columns.filter(function(c) {
        return c.children.length === 0;
      }).map(function(c) {
        var f = Jn(c.filter), d = i(c.field), h = c.filterable ? r.toLanguageString(Yn, ue[Yn]) : void 0, m = d && d.value;
        m === void 0 && (m = f === "text" ? "" : null);
        var g = c.filterable && {
          render: n.props.cellRender,
          field: c.field,
          title: c.filterTitle,
          value: m,
          operator: d && d.operator,
          operators: dr(n.props.filterOperators[f] || [], r),
          booleanValues: dr(La, r),
          filterType: f,
          ariaLabel: h,
          onChange: function(_) {
            n.setFilter(_.value, _.operator, c.field, _.syntheticEvent);
          }
        }, y = c.declarationIndex >= 0 ? ++s : --a, w = {
          ariaLabel: h,
          ariaColumnIndex: c.ariaColumnIndex
        }, x = c.left !== void 0 ? n.props.isRtl ? { left: c.right, right: c.left } : { left: c.left, right: c.right } : {}, b = Rt({ columnId: J.getFilterColumnId(c.id), navigatable: c.navigatable, style: x, className: le("k-table-th", n.headerCellClassName(c.field, c.locked) || void 0), role: "columnheader" }, w), C = g && (c.filterCell ? l.createElement(c.filterCell, Rt({}, g)) : l.createElement(Ga, Rt({ size: n.props.size }, g))), S = on(n.props.cells, c.cells);
        if (S && S.filterCell) {
          var T = S.filterCell;
          return l.createElement(T, Rt({ key: y }, g, { thProps: b, index: s }), C);
        }
        return l.createElement(Io, Rt({ key: y }, b), C);
      });
      return l.createElement("tr", { className: af, "aria-rowindex": this.props.ariaRowIndex, role: "row" }, u);
    }, t;
  }(l.Component)
);
dt(Ua);
var lf = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Ka = (
  /** @class */
  function(e) {
    lf(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.draggable = null, n.onPress = function(r) {
        var o = n.draggable && n.draggable.element;
        o && n.props.onPress && n.props.onPress(r.event, o);
      }, n.onDrag = function(r) {
        var o = n.draggable && n.draggable.element;
        o && n.props.onDrag && n.props.onDrag(r.event, o);
      }, n.onRelease = function(r) {
        var o = n.draggable && n.draggable.element;
        o && n.props.onRelease && n.props.onRelease(r.event);
      }, n.sortChange = function(r) {
        if (r.preventDefault(), n.props.onSortChange) {
          var o = n.props.dir === "asc" ? "desc" : "asc";
          n.props.onSortChange(r, o);
        }
      }, n.groupRemove = function(r) {
        r.preventDefault(), n.props.onRemove && n.props.onRemove(r);
      }, n;
    }
    return t.prototype.render = function() {
      var n = this, r = We(this), o = this.props.dir;
      return l.createElement(
        rn,
        { onPress: this.onPress, onDrag: this.onDrag, onRelease: this.onRelease, ref: function(i) {
          n.draggable = i;
        } },
        l.createElement(
          "div",
          { className: "k-chip k-chip-md k-chip-solid k-chip-solid-base k-rounded-md", role: "button", style: { touchAction: "none" } },
          l.createElement(
            "span",
            { onClick: this.sortChange },
            l.createElement(ot, { name: "sort-" + o + "-small", icon: o === "asc" ? Bi : Gi, size: "small" })
          ),
          l.createElement("span", { className: "k-chip-content" }, this.props.title),
          l.createElement(
            "span",
            { className: "k-chip-actions" },
            l.createElement(
              "span",
              { className: "k-chip-action k-chip-remove-action", onClick: this.groupRemove, "aria-label": r.toLanguageString(Un, ue[Un]) },
              l.createElement(ot, { name: "x-circle", icon: Bl })
            )
          )
        )
      );
    }, t;
  }(l.Component)
);
dt(Ka);
var sf = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Wa = (
  /** @class */
  function(e) {
    sf(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.onGroupRemove = function(r, o) {
        var i = n.props.group.slice();
        i.splice(o, 1), n.props.groupChange(i, r);
      }, n.onGroupSortChange = function(r, o, i, a) {
        var s = Object.assign({}, i, { dir: a }), u = n.props.group.slice();
        u.splice(o, 1, s), n.props.groupChange(u, r);
      }, n;
    }
    return t.prototype.render = function() {
      var n = this, r = this.props.group || [], o = r.map(function(i, a) {
        return l.createElement(Ka, { key: a, dir: i.dir || "asc", title: n.props.resolveTitle(i.field), onRemove: function(s) {
          n.onGroupRemove(s, a);
        }, onSortChange: function(s, u) {
          n.onGroupSortChange(s, a, i, u);
        }, onPress: n.props.pressHandler, onDrag: n.props.dragHandler, onRelease: n.props.releaseHandler });
      });
      return l.createElement(
        "div",
        { ref: this.props.refCallback, className: "k-grouping-header", role: "toolbar", "aria-label": We(this).toLanguageString(Zn, ue[Zn]) },
        l.createElement("div", { className: "k-chip-list k-chip-list-md", role: "none" }, o),
        l.createElement(
          "div",
          { className: "k-grouping-drop-container" },
          !o.length && We(this).toLanguageString(Gn, ue[Gn]),
          " "
        )
      );
    }, t;
  }(l.Component)
);
dt(Wa);
var uf = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), cf = (
  /** @class */
  function(e) {
    uf(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.footerWrap = null, n.table = null, n.scrollbarWidth = sa(), n;
    }
    return t.prototype.componentDidMount = function() {
      this.setState({});
    }, t.prototype.setScrollLeft = function(n) {
      this.footerWrap && (this.footerWrap.scrollLeft = n);
    }, t.prototype.setWidth = function(n) {
      this.table && (this.table.style.width = n + "px");
    }, t.prototype.render = function() {
      var n, r = this;
      return this.props.staticHeaders ? l.createElement(
        "div",
        { className: "k-grid-footer", role: "presentation" },
        l.createElement(
          "div",
          { ref: function(o) {
            r.footerWrap = o;
          }, className: "k-grid-footer-wrap", style: this.scrollbarWidth ? {} : { borderWidth: 0 }, role: "presentation" },
          l.createElement(
            "table",
            { ref: function(o) {
              r.table = o;
            }, className: le("k-table k-grid-footer-table", (n = {
              "k-table-md": !this.props.size
            }, n["k-table-".concat(Dt.sizeMap[this.props.size] || this.props.size)] = this.props.size, n), this.props.className), role: "presentation" },
            l.createElement("colgroup", { ref: function(o) {
              r.props.columnResize.colGroupFooter = o;
            }, role: "presentation" }, this.props.cols),
            l.createElement("tfoot", { className: "k-table-tfoot", role: "presentation" }, this.props.row)
          )
        )
      ) : l.createElement("tfoot", { className: "k-table-tfoot" }, this.props.row);
    }, t;
  }(l.Component)
), ff = (
  /** @class */
  function() {
    function e(t) {
      var n = this;
      this.table = null, this.containerHeight = 0, this.topCacheCount = 0, this.attendedSkip = 0, this.propsSkip = 0, this.total = 0, this.scrollableVirtual = !1, this.realSkip = 0, this.pageSize = 0, this.PageChange = null, this.tableBodyRef = l.createRef(), this.fixedScroll = !1, this.askedSkip = void 0, this.containerRef = l.createRef(), this.tableTransform = "", this.prevScrollPos = 0, this.tableTranslate = 0, this.scrollSyncing = !1, this.reactVersion = Number.parseFloat(l.version), this.topItems = function(r, o) {
        if (!n.container || o)
          return { topItemsCount: 0, topItemsHeight: 0 };
        for (var i = n.container.clientHeight, a = Math.ceil(i / r[0].line), s = Math.ceil((r.length - a) / 2), u = 0, c = 0; c < s; c++)
          u += r[c].line + r[c].acc;
        return {
          topItemsCount: s,
          topItemsHeight: u,
          itemsNeededOnScreen: a + a / 2
        };
      }, this.horizontalScrollbarHeight = function() {
        return n.container ? n.container.offsetHeight - n.container.clientHeight : 0;
      }, t && (this.topCacheCount = 4, this.attendedSkip = -this.topCacheCount), this.scrollHandler = this.scrollHandler.bind(this);
    }
    return Object.defineProperty(e.prototype, "container", {
      get: function() {
        return this.containerRef.current;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "rowHeights", {
      /**
       * @return - The row heights in an array.
       */
      get: function() {
        for (var t = [], n = this.tableBodyRef.current && this.tableBodyRef.current.children || [], r = 0, o = 0; o < n.length; o++) {
          if (n[o].className.indexOf("k-grouping-row") > -1) {
            r += n[o].scrollHeight;
            continue;
          }
          n[o].className.indexOf("k-detail-row") > -1 ? t[t.length - 1].line += n[o].scrollHeight : (t.push({
            line: n[o].scrollHeight,
            acc: r
          }), r = 0);
        }
        return t;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.changePage = function(t, n) {
      this.attendedSkip = t - this.topCacheCount, this.PageChange && this.PageChange({
        skip: Math.max(0, t - this.topCacheCount),
        take: this.pageSize
      }, n);
    }, e.prototype.translate = function(t, n) {
      this.tableTranslate = t, this.scrollableVirtual && this.table && (this.reactVersion <= 17 || n ? this.table.style.transform = "translateY(" + t + "px)" : this.tableTransform = "translateY(" + t + "px)");
    }, e.prototype.reset = function() {
      this.scrollSyncing = !0, !this.fixedScroll && (this.container && (this.container.scrollTop = 0), this.translate(0, !0));
    }, e.prototype.localScrollUp = function(t) {
      if (this.container) {
        var n = this.rowHeights, r = this.container.scrollTop, o = this.tableTranslate, i = 0, a = this.topItems(n, !!this.topCacheCount), s = a.topItemsCount, u = a.topItemsHeight, c = a.itemsNeededOnScreen, f = r - o;
        if (!(f > u || n.length <= c)) {
          for (; i < this.topCacheCount + this.attendedSkip - this.realSkip + s && this.propsSkip - i > 0 && !(o + (n[n.length - 1 - i].line + n[n.length - 1 - i].acc) + f <= r); )
            o -= n[n.length - 1 - i].line + n[n.length - 1 - i].acc, i++;
          if (i === 0 && this.topCacheCount === 0 && this.attendedSkip > 0 && (o = Math.max(o - n[0].line, 0), i = 1), this.propsSkip - i <= 0 && o > r) {
            this.translate(0), this.changePage(0, t), this.container.scrollTop = 0;
            return;
          }
          if (o > r && (o = r), o !== this.tableTranslate) {
            this.translate(Math.max(0, o - u));
            var d = Math.max(0, this.propsSkip - i - s);
            this.changePage(d, t);
          }
        }
      }
    }, e.prototype.localScrollDown = function(t) {
      if (this.container) {
        for (var n = this.rowHeights, r = this.container.scrollTop, o = this.tableTranslate, i = 0, a = this.topItems(n, !!this.topCacheCount), s = a.topItemsCount, u = a.topItemsHeight, c = a.itemsNeededOnScreen; i < n.length - this.topCacheCount && !(o + n[i].line + n[i].acc > r); )
          o += n[i].line + n[i].acc, i++;
        s > this.propsSkip + i || n.length <= c || (i >= n.length - this.topCacheCount && this.propsSkip + i >= this.total ? (this.translate(o - u), this.changePage(this.total - 1 - s, t)) : o !== this.tableTranslate && this.propsSkip + i - s !== this.propsSkip && (this.translate(o - u), this.changePage(this.propsSkip + i - s, t)));
      }
    }, e.prototype.scrollNonStrict = function(t) {
      var n = this.total * this.prevScrollPos / this.containerHeight, r = Math.floor(n);
      r >= this.total && (r = this.total - 1);
      var o = Math.min(n - r, 1), i = 0, a = r - this.propsSkip, s = this.rowHeights;
      a >= 0 && a <= 1 ? i = -((s[0].line + s[0].acc) * o) : a === -1 && (i = -((s[s.length - 1].line + s[s.length - 1].acc) * o));
      var u = this.topItems(s, !!this.topCacheCount), c = u.topItemsCount, f = u.topItemsHeight;
      this.translate(Math.max(0, i - f - this.horizontalScrollbarHeight() + this.containerHeight * n / this.total)), this.changePage(r - c, t);
    }, e.prototype.scrollHandler = function(t) {
      if (this.scrollableVirtual) {
        if (this.scrollSyncing || !this.container || !this.table) {
          this.scrollSyncing = !1;
          return;
        }
        var n = this.container.scrollTop, r = this.prevScrollPos;
        if (this.prevScrollPos = n, this.askedSkip !== void 0) {
          this.translate(this.containerHeight * this.askedSkip / this.total), this.changePage(this.askedSkip, t), this.prevScrollPos = n, this.askedSkip = void 0;
          return;
        }
        n - r < 0 && n > this.tableTranslate - this.table.scrollHeight / 10 ? this.localScrollUp(t) : n - r > 0 && n < this.tableTranslate + this.table.scrollHeight * 2 / 3 ? this.localScrollDown(t) : this.scrollNonStrict(t), this.prevScrollPos = n;
      }
    }, e;
  }()
), yi = (
  /** @class */
  function() {
    function e(t, n, r, o) {
      t === void 0 && (t = 0), this.total = t, this.offsets = [], this.heights = [];
      for (var i = 0, a = 0; a < t; a++) {
        this.offsets.push(i);
        var s = o && o[a].expanded && o[a].rowType === "data" ? r : n;
        i += s, this.heights.push(s);
      }
    }
    return e.prototype.height = function(t) {
      return this.heights[t];
    }, e.prototype.index = function(t) {
      if (!(t < 0)) {
        var n = this.offsets.reduce(function(r, o, i) {
          if (r !== void 0)
            return r;
          if (o === t)
            return i;
          if (o > t)
            return i - 1;
        }, void 0);
        return n === void 0 ? this.total - 1 : n;
      }
    }, e.prototype.offset = function(t) {
      return this.offsets[t];
    }, e.prototype.totalHeight = function() {
      var t = this.offsets[this.offsets.length - 1], n = this.heights[this.heights.length - 1];
      return t + n;
    }, e;
  }()
), Ci = (
  /** @class */
  function() {
    function e(t) {
      this.table = null, this.containerHeight = 0, this.topCacheCount = 0, this.attendedSkip = 0, this.propsSkip = 0, this.total = 0, this.scrollableVirtual = !1, this.realSkip = 0, this.pageSize = 0, this.PageChange = null, this.tableBodyRef = l.createRef(), this.fixedScroll = !1, this.askedSkip = void 0, this.containerRef = l.createRef(), this.tableTransform = "", this.scrollSyncing = !1, this.lastLoaded = 0, this.firstLoaded = 0, this.lastScrollTop = 0, this.reactVersion = Number.parseFloat(l.version), this.firstLoaded = this.pageSize, this.lastLoaded = this.realSkip + this.pageSize, this.scrollHandler = this.scrollHandler.bind(this);
    }
    return Object.defineProperty(e.prototype, "container", {
      get: function() {
        return this.containerRef.current;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.translate = function(t, n) {
      this.scrollableVirtual && this.table && (this.reactVersion <= 17 || n ? this.table.style.transform = "translateY(" + t + "px)" : this.tableTransform = "translateY(" + t + "px)");
    }, e.prototype.changePage = function(t, n) {
      this.PageChange && this.PageChange({ skip: Math.max(0, t), take: this.pageSize }, n);
    }, e.prototype.reset = function() {
      this.scrollSyncing = !0, !this.fixedScroll && (this.container && (this.container.scrollTop = 0), this.translate(0, !0));
    }, e.prototype.scrollHandler = function(t) {
      if (!(!this.scrollableVirtual || !this.container || !this.table || !this.rowHeightService || !this.containerRef.current)) {
        if (this.scrollSyncing) {
          this.scrollSyncing = !1;
          return;
        }
        var n = this.container.scrollTop, r = this.lastScrollTop >= n, o = !r;
        this.lastScrollTop = n;
        var i = this.rowHeightService.index(n), a = this.rowHeightService.offset(i), s = this.containerRef.current.offsetHeight, u = this.rowHeightService.index(n + s);
        if (o && u >= this.lastLoaded && this.lastLoaded < this.total) {
          var c = i + this.pageSize - this.total;
          c > 0 && (i = i - c, a = this.rowHeightService.offset(i)), this.firstLoaded = i, this.translate(a);
          var f = this.firstLoaded + this.pageSize;
          this.lastLoaded = Math.min(f, this.total), this.changePage(this.firstLoaded, t);
        } else if (r && i < this.firstLoaded) {
          var d = Math.floor(this.pageSize * 0.3);
          this.firstLoaded = Math.max(i - d, 0), this.translate(this.rowHeightService.offset(this.firstLoaded)), this.lastLoaded = Math.min(this.firstLoaded + this.pageSize, this.total), this.changePage(this.firstLoaded, t);
        }
      }
    }, e;
  }()
), df = 1, hf = (
  /** @class */
  function() {
    function e(t) {
      var n = this;
      this.columns = [], this.resizable = !1, this.isRtl = !1, this.setIsRtl = function(r) {
        n.isRtl = r;
      }, this.dragHandler = function(r, o, i, a) {
        var s = r.originalEvent;
        a || (s.preventDefault(), s.stopPropagation(), s.stopImmediatePropagation());
        var u = i.parentElement;
        if (!(!u || !u.parentElement)) {
          var c = u.clientWidth, f = c;
          if (n.isRtl ? f += i.getBoundingClientRect().right - i.offsetWidth / 2 - r.clientX : f += r.clientX - i.getBoundingClientRect().left - i.offsetWidth / 2, !(!a && Math.abs(f - c) < 1)) {
            n.fixateInitialWidths(u.parentElement.clientWidth), n.setWidths(o, Math.floor(f) / c);
            var d = n.columns.filter(function(h) {
              return !h.children.length;
            }).findIndex(function(h) {
              return h.id === o.id;
            });
            n.onResize(d, c, f, s, a, o.id);
          }
        }
      }, this.dblClickHandler = function(r, o) {
        var i = n.columns.filter(function(g) {
          return o.indexOf(g.id) > -1;
        });
        if (!(!n.colGroupMain || !i.length)) {
          for (var a = {}, s = i; s.length > 0; ) {
            var u = s.pop();
            if (!u)
              break;
            u.children.length ? s.push.apply(s, u.children) : a[u.id] = u;
          }
          var c = n.columns.filter(function(g) {
            return !g.children.length;
          }), f = [];
          c.forEach(function(g, y) {
            a[g.id] && f.push(y);
          });
          var d = [n.colGroupMain.parentElement], h = [n.colGroupMain];
          n.colGroupHeader && (d.push(n.colGroupHeader.parentElement), h.push(n.colGroupHeader)), n.colGroupFooter && (d.push(n.colGroupFooter.parentElement), h.push(n.colGroupFooter)), d.forEach(function(g) {
            return g.classList.add("k-autofitting");
          });
          var m = [];
          h.forEach(function(g) {
            f.forEach(function(y) {
              g.children[y] && (g.children[y].width = "", m[y] = Math.max(m[y] || 0, g.children[y].offsetWidth + df));
            });
          }), h.forEach(function(g) {
            f.forEach(function(y) {
              g.children[y] && (g.children[y].width = m[y] + "px", c[y].width = m[y]);
            });
          }), d.forEach(function(g) {
            return g.classList.remove("k-autofitting");
          }), n.onResize(f[0], 0, 0, r, !0, o[0]);
        }
      }, this.updateColElements = function(r) {
        for (var o = n.columns.filter(function(u) {
          return !u.children.length;
        }), i = 1e-10, a = function(u) {
          var c = r[u], f = o.findIndex(function(g) {
            return g.id === c.id;
          }), d = parseFloat((c.width || 0).toString()), h = Math.floor(d);
          i += d - h;
          var m = h + Math.floor(i);
          i -= Math.floor(i), n.colGroupMain && n.colGroupMain.children[f] && (n.colGroupMain.children[f].width = m + "px"), n.colGroupHeader && n.colGroupHeader.children[f] && (n.colGroupHeader.children[f].width = m + "px"), n.colGroupFooter && n.colGroupFooter.children[f] && (n.colGroupFooter.children[f].width = m + "px");
        }, s = 0; s < r.length; s++)
          a(s);
      }, this.onResize = t;
    }
    return e.prototype.fixateInitialWidths = function(t) {
      for (var n = this.columns.filter(function(u) {
        return !u.children.length;
      }), r = 0, o = this.colGroupMain ? this.colGroupMain.children : [], i = 0; i < o.length; i++)
        o[i].width ? t -= parseFloat(o[i].width) : r++;
      if (r !== 0)
        for (var a = Math.floor(t / r), i = 0; i < o.length; i++) {
          var s = o[i];
          s.width || (s.width = a, n[i].width = a.toString(), this.colGroupHeader && (this.colGroupHeader.children[i].width = a), this.colGroupFooter && (this.colGroupFooter.children[i].width = a));
        }
    }, e.prototype.setWidths = function(t, n) {
      for (var r = this.columns.findIndex(function(u) {
        return u.id === t.id;
      }), o = [], i = t.children.length, a = r + 1; i > 0 && a < this.columns.length; a++, i--) {
        var s = this.columns[a];
        s.children.length ? i += s.children.length : o.push(s);
      }
      return o.length === 0 && o.push(t), o.forEach(function(u) {
        var c = u.width ? parseFloat(u.width.toString()) * n : 0, f = u.minResizableWidth === void 0 ? 10 : u.minResizableWidth;
        c < f && (c = f), u.width = c;
      }), this.updateColElements(o), o;
    }, e;
  }()
), pf = (
  /** @class */
  function() {
    function e(t, n, r) {
      var o = this;
      this.refDragElementClue = l.createRef(), this.refDropElementClue = l.createRef(), this.columns = [], this.reorderable = !1, this.groupable = !1, this.startColumn = -1, this.startGroup = -1, this.currentColumn = -1, this.currentGroup = -1, this.groupPanelDivElement = null, this.refGroupPanelDiv = function(i) {
        o.groupPanelDivElement = i && i.children ? i.children[0] : i;
      }, this.pressHandler = function(i, a) {
        var s = o.getColumnIndex(i, a);
        if (o.startGroup = o.getGroupIndex(i), s >= 0) {
          var u = o.columns[s];
          (u.reorderable && o.reorderable || u.groupable && o.groupable) && (o.startColumn = s);
        }
      }, this.dragHandler = function(i, a) {
        if (i.isTouch || i.originalEvent.preventDefault(), i.originalEvent.stopPropagation(), !(o.startColumn === -1 && o.startGroup === -1)) {
          o.currentColumn = o.getColumnIndex(i, a);
          var s = o.groupPanelDivElement && o.groupPanelDivElement.children;
          o.currentGroup = o.isTargetGroupingContainer(i) ? s && s.length ? s.length : 0 : o.getGroupIndex(i);
          var u = !o.isValid();
          u && (o.currentColumn = -1, o.currentGroup = -1);
          var c = o.currentColumn >= 0 ? a.children[o.columns[o.currentColumn].index] : o.isTargetGroupingContainer(i) ? i.originalEvent.target : o.groupPanelDivElement && o.groupPanelDivElement.children[o.currentGroup];
          o.updateDragElementClue(i, a, c, u), o.updateDropElementClue(i, a, c, u);
        }
      }, this.releaseHandler = function(i) {
        var a = o.startColumn, s = o.currentColumn, u = o.startGroup, c = o.currentGroup;
        i.originalEvent.preventDefault(), o.dropElementClue && o.dropElementClue.setState({ visible: !1 }), o.dragElementClue && o.dragElementClue.setState({ visible: !1 });
        var f = o.isValid();
        o.startColumn = o.startGroup = o.currentColumn = o.currentGroup = -1, f && (a >= 0 && s >= 0 ? o.columnReorder(a, s, i.originalEvent) : u >= 0 && c >= 0 ? o.groupReorder(u, c, i.originalEvent) : a >= 0 && c >= 0 && o.columnToGroup(a, c, i.originalEvent));
      }, this.columnReorder = t, this.groupReorder = n, this.columnToGroup = r;
    }
    return Object.defineProperty(e.prototype, "dragClueRef", {
      get: function() {
        return this.refDragElementClue;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "dropClueRef", {
      get: function() {
        return this.refDropElementClue;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "dragElementClue", {
      get: function() {
        return this.refDragElementClue.current;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "dropElementClue", {
      get: function() {
        return this.refDropElementClue.current;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.getColumnIndex = function(t, n) {
      if (!n || n.parentElement === this.groupPanelDivElement)
        return -1;
      var r = ui(t, n);
      if (r === -1)
        return -1;
      for (var o = function(u) {
        if (n.parentNode.children[u] === n)
          return { value: i.columns.findIndex(function(c) {
            return c.index === r && c.depth === u;
          }) };
      }, i = this, a = 0; a < n.parentNode.children.length; a++) {
        var s = o(a);
        if (typeof s == "object")
          return s.value;
      }
      return -1;
    }, e.prototype.isTargetGroupingContainer = function(t) {
      var n = t.originalEvent.target;
      return n.className.indexOf ? n.className.indexOf("k-grouping-drop-container") !== -1 : !1;
    }, e.prototype.getGroupIndex = function(t) {
      return ui(t, this.groupPanelDivElement);
    }, e.prototype.isValid = function() {
      return this.startGroup >= 0 ? this.currentGroup >= 0 && this.currentGroup !== this.startGroup : this.startColumn === -1 ? !1 : this.currentGroup >= 0 ? this.columns[this.startColumn].groupable === !0 && this.groupable === !0 : this.reorderable === !0 && this.currentColumn >= 0 && this.currentColumn !== this.startColumn && this.columns[this.startColumn].reorderable === !0 && this.columns[this.currentColumn].parentIndex === this.columns[this.startColumn].parentIndex;
    }, e.prototype.updateDragElementClue = function(t, n, r, o) {
      if (this.dragElementClue) {
        var i = this.startColumn >= 0 ? n.children[this.columns[this.startColumn].index].innerText : n.innerText;
        this.dragElementClue.setState({
          visible: !0,
          top: t.pageY + 10,
          left: t.pageX,
          innerText: i,
          status: o || !r ? "k-i-cancel" : "k-i-plus"
        });
      }
    }, e.prototype.updateDropElementClue = function(t, n, r, o) {
      if (this.dropElementClue) {
        if (o || !r) {
          this.dropElementClue.setState({ visible: !1 });
          return;
        }
        var i = r.getBoundingClientRect(), a = r.closest(".k-grouping-header"), s = (a || r).getBoundingClientRect(), u = i.left + t.pageX - t.clientX - 6;
        !this.isTargetGroupingContainer(t) && (this.currentColumn > this.startColumn || this.currentGroup > this.startGroup && this.startGroup !== -1) && (u += i.width);
        var c = s.top + t.pageY - t.clientY;
        this.dropElementClue.setState({
          visible: !0,
          top: c,
          left: u,
          height: this.currentColumn >= 0 ? n.clientHeight : s.height
        });
      }
    }, e;
  }()
), Wt = globalThis && globalThis.__assign || function() {
  return Wt = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, Wt.apply(this, arguments);
}, gf = function(e) {
  var t, n = null, r = Nl(), o = ht(e.id), i = l.useCallback(function(m) {
    e.onContextMenu && e.onContextMenu.call(void 0, m, e.dataItem, e.field);
  }, [e.onContextMenu, e.dataItem, e.field]), a = null, s = null;
  if (e.rowType === "groupFooter")
    a = {
      onContextMenu: i,
      className: e.className
    }, n = l.createElement("td", Wt({}, a));
  else if (e.field !== void 0 && e.rowType !== "groupHeader") {
    var u = Ke(e.field, e.dataItem);
    u != null && (s = e.format ? r.format(e.format, u) : u.toString());
    var c = le("k-table-td", e.className, { "k-selected": e.isSelected });
    a = Wt((t = { onContextMenu: i, colSpan: e.colSpan, style: e.style, className: c, role: "gridcell", "aria-colindex": e.ariaColumnIndex, "aria-selected": e.isSelected }, t[or] = e.columnIndex, t), o), n = l.createElement("td", Wt({}, a), s);
  }
  var f = e.rowType || "data", d = e.cells;
  if (d && d[f]) {
    var h = d[f];
    return l.createElement(h, Wt({}, e, { tdProps: a }), s);
  }
  return e.render ? e.render.call(void 0, n, e) : n;
}, tt = globalThis && globalThis.__assign || function() {
  return tt = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, tt.apply(this, arguments);
}, bi = function(e) {
  var t = null, n = e.columnIndex, r = e.level, o = e.columnsCount, i = e.rowType, a = e.dataItem, s = e.field, u = e.onChange, c = e.expanded, f = e.render, d = e.dataIndex, h = e.ariaColumnIndex, m = e.isRtl, g = s || "", y = ht(e.id), w = ji(), x = null, b = null, C = null, S = l.useCallback(function(B) {
    B.isDefaultPrevented() || B.keyCode === yo.enter && u && (B.preventDefault(), u({
      dataItem: a,
      dataIndex: d,
      syntheticEvent: B,
      field: void 0,
      value: !c
    }));
  }, [c, u, a, d]), T = l.useCallback(function(B) {
    e.onContextMenu && e.onContextMenu.call(void 0, B, e.dataItem, e.field);
  }, [e.onContextMenu, e.dataItem, e.field]), _ = function(B, F) {
    var G, Z = c ? Da : Ra, ee = w.toLanguageString(Z, ue[Z]);
    return x = tt((G = { className: "k-table-td", style: tt(tt({}, e.style), F), colSpan: B, key: "g-colspan", role: "gridcell" }, G["aria-selected"] = !1, G["aria-expanded"] = c, G["aria-colindex"] = h, G.onKeyDown = S, G.onContextMenu = T, G), y), C = l.createElement(
      "p",
      { className: "k-reset" },
      l.createElement(
        "a",
        { onClick: function(D) {
          D.preventDefault(), u && u({
            dataItem: a,
            dataIndex: d,
            syntheticEvent: D,
            field: void 0,
            value: !c
          });
        }, href: "#", tabIndex: -1, "aria-label": ee },
        l.createElement(ot, { name: c ? "caret-alt-down" : m ? "caret-alt-left" : "caret-alt-right", icon: c ? zi : m ? Lr : jr })
      ),
      a[g] instanceof Date && a[g].toString ? a[g].toString() : a[g]
    ), l.createElement("td", tt({}, x), C);
  };
  n === void 0 || r === void 0 || n < r || o === void 0 || i !== "groupHeader" || a[g] === void 0 ? (x = {
    style: e.style,
    key: "g" + n,
    className: le("k-table-td", "k-group-cell", { "k-grid-content-sticky": e.locked }),
    role: "gridcell",
    onContextMenu: T
  }, t = l.createElement("td", tt({}, x))) : n <= r && !e.locked ? t = _(o - n, {}) : n <= r && e.locked && (b = {
    className: "k-table-td",
    role: "gridcell",
    colSpan: o - n,
    style: { borderLeftWidth: 0, borderRightWidth: 0 },
    onContextMenu: T
  }, t = l.createElement(
    l.Fragment,
    null,
    _(0, { position: "sticky", zIndex: 2 }),
    l.createElement("td", tt({}, b))
  ));
  var k = e.rowType || "data", H = e.cells;
  if (H && H.group && H.group[k]) {
    var L = H.group[k];
    return l.createElement(L, tt({}, e, { tdProps: x, td2Props: b }), C);
  }
  return f ? f.call(void 0, t, e) : t;
}, vf = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), eo = globalThis && globalThis.__assign || function() {
  return eo = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, eo.apply(this, arguments);
}, mf = (
  /** @class */
  function(e) {
    vf(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.render = function() {
      var n, r = le("k-table-row", {
        "k-grouping-row": this.props.rowType === "groupHeader",
        "k-group-footer": this.props.rowType === "groupFooter",
        "k-master-row": this.props.rowType !== "groupHeader" && this.props.rowType !== "groupFooter",
        "k-table-alt-row k-alt": this.props.rowType !== "groupHeader" && this.props.rowType !== "groupFooter" && this.props.isAltRow,
        "k-selected": this.props.isSelected,
        "k-grid-edit-row": this.props.isInEdit
      }), o = l.createElement("tr", eo({ id: this.props.id, onClick: this.props.onClick, onDoubleClick: this.props.onDoubleClick, className: r, style: {
        height: this.props.rowHeight ? this.props.rowHeight + "px" : "",
        visibility: this.props.isHidden ? "hidden" : ""
      }, role: "row", "aria-rowindex": this.props.ariaRowIndex, "absolute-row-index": this.props.absoluteRowIndex }, (n = {}, n[Lc] = this.props.rowType === "data" ? this.props.dataIndex : void 0, n)), this.props.children);
      return this.props.render ? this.props.render.call(void 0, o, this.props) : o;
    }, t;
  }(l.Component)
), yf = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), to = globalThis && globalThis.__assign || function() {
  return to = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, to.apply(this, arguments);
}, Cf = (
  /** @class */
  function(e) {
    yf(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n._inputId = tn(), n;
    }
    return t.prototype.render = function() {
      var n = this, r = this.props.columnMenuWrapperProps, o = [
        l.createElement("input", { key: 0, checked: this.props.selectionValue, id: this._inputId, type: "checkbox", className: "k-checkbox k-checkbox-md k-rounded-md", onChange: function(i) {
          return n.props.selectionChange({
            field: n.props.field,
            syntheticEvent: i
          });
        } }),
        l.createElement("label", { key: 1, className: "k-checkbox-label", htmlFor: this._inputId }),
        r.columnMenu && l.createElement(Fa, to({}, r))
      ];
      return this.props.render ? this.props.render.call(void 0, o, this.props) : o;
    }, t;
  }(l.Component)
), bf = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Va = (
  /** @class */
  function(e) {
    bf(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.render = function() {
      return this.props.children || We(this).toLanguageString(Bn, ue[Bn]);
    }, t.displayName = "KendoReactGridNoRecords", t;
  }(l.Component)
);
dt(Va);
var xf = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Vt = globalThis && globalThis.__assign || function() {
  return Vt = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, Vt.apply(this, arguments);
}, wf = (
  /** @class */
  function(e) {
    xf(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n._element = null, n.renderCell = function(r, o) {
        var i, a = (i = {
          colSpan: r.colSpan !== 1 ? r.colSpan : void 0,
          style: r.left !== void 0 ? n.props.isRtl ? { left: r.right, right: r.left } : { left: r.left, right: r.right } : {},
          className: le("k-table-td", r.locked && r.left !== void 0 ? "k-grid-footer-sticky" : ""),
          key: o,
          role: "columnfooter"
        }, i["aria-selected"] = !1, i["aria-colindex"] = r.ariaColumnIndex, i), s = Vt({ field: r.field, ariaColumnIndex: r.ariaColumnIndex }, a), u = on(n.props.cells, r.cells);
        if (u && u.footerCell) {
          var c = u.footerCell;
          return l.createElement(c, Vt({}, s, { tdProps: a, index: o }));
        }
        return r.footerCell && l.createElement(r.footerCell, Vt({}, s, { key: o })) || l.createElement("td", Vt({}, a));
      }, n;
    }
    return Object.defineProperty(t.prototype, "element", {
      get: function() {
        return this._element;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.render = function() {
      return l.createElement("tr", { className: "k-table-row", role: "row", "aria-rowindex": this.props.ariaRowIndex }, xc(this.props.columns).map(this.renderCell));
    }, t;
  }(l.Component)
), _f = function(e) {
  var t = e.buttonCount, n = t === void 0 ? 10 : t, r = e.info, o = r === void 0 ? !0 : r, i = e.type, a = i === void 0 ? "numeric" : i, s = e.pageSizes, u = s === void 0 ? void 0 : s, c = e.previousNext, f = c === void 0 ? !0 : c, d = e.responsive, h = d === void 0 ? !0 : d, m = e.pageSizeValue, g = m === void 0 ? void 0 : m;
  return {
    buttonCount: n,
    info: o,
    pageSizes: u === !0 ? [5, 10, 20] : u || void 0,
    previousNext: f,
    responsive: h,
    type: a,
    pageSizeValue: g
  };
}, Ef = function(e) {
  return _f(e === !0 ? {} : e);
}, xi = {
  name: "@progress/kendo-react-grid",
  productName: "KendoReact",
  productCodes: ["KENDOUIREACT", "KENDOUICOMPLETE"],
  publishDate: 1690380873,
  version: "",
  licensingDocsUrl: "https://www.telerik.com/kendo-react-ui/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-warning"
}, ro = globalThis && globalThis.__assign || function() {
  return ro = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, ro.apply(this, arguments);
}, If = function(e) {
  var t = e.colSpan, n = e.ariaColIndex, r = e.dataItem, o = e.dataIndex, i = e.id, a = ht(i), s = l.useCallback(function(u) {
    e.onContextMenu && e.onContextMenu.call(void 0, u, e.dataItem);
  }, [e.onContextMenu, e.dataItem]);
  return l.createElement(
    "td",
    ro({ onContextMenu: s, className: "k-table-td k-detail-cell", colSpan: t, "aria-colindex": n, role: "gridcell" }, a),
    l.createElement(e.detail, { dataItem: r, dataIndex: o })
  );
}, no = globalThis && globalThis.__assign || function() {
  return no = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, no.apply(this, arguments);
}, kf = function(e) {
  var t = ht(e.id);
  return l.createElement("td", no({ className: "k-table-td k-hierarchy-cell" }, t, { role: "gridcell" }));
}, Of = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), K = globalThis && globalThis.__assign || function() {
  return K = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, K.apply(this, arguments);
}, wi = globalThis && globalThis.__spreadArray || function(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, i; r < o; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}, Sf = (
  /** @class */
  function(e) {
    Of(t, e);
    function t(n) {
      var r = e.call(this, n) || this;
      r._columns = [], r._columnsMap = [[]], r._columnsMutations = 0, r.contextStateRef = { current: void 0 }, r.navigationStateRef = { current: void 0 }, r._data = [], r._slicedData = void 0, r.wrapperScrollTop = 0, r.showLicenseWatermark = !1, r.headerRef = l.createRef(), r.headerElementRef = l.createRef(), r._element = null, r.tableElement = null, r.containerRef = l.createRef(), r.tableBodyRef = l.createRef(), r._footer = null, r.forceUpdateTimeout = void 0, r.isRtl = !1, r._gridId = tn(), r.observer = null, r.handleIntersection = function(a) {
        var s = { rowIndex: r.rowIndex };
        a.forEach(function(u) {
          u.isIntersecting || r.setCurrentOnTop(s);
        });
      }, r.setCurrentOnTop = function(a) {
        if (!(!r.vs.container || r.props.scrollable === "none")) {
          r.observer && r.observer.disconnect();
          var s = a.rowIndex;
          if (r.props.scrollable === "virtual")
            r.vs.askedSkip = s, r.vs.container.scroll(0, Math.round(r.vs.askedSkip / r.vs.total * r.vs.container.scrollHeight));
          else if (r.element) {
            var u = s < 1 ? r.element.querySelector("tbody > tr:nth-child(".concat(1, ")")) : r.element.querySelector("tbody > tr:nth-child(".concat(s + 1, ")"));
            u && r.containerRef.current && (r.containerRef.current.scrollTop = u.offsetTop);
          }
        }
      }, r.scrollIntoView = function(a) {
        if (!(!r.vs.container || r.props.scrollable === "none")) {
          r.rowIndex = a.rowIndex;
          var s = a.rowIndex, u = r.element;
          if (r.observer && u) {
            r.observer.disconnect();
            var c = u.querySelector('[absolute-row-index="'.concat(s, '"]'));
            c ? r.observer.observe(c) : r.setCurrentOnTop(a);
          }
        }
      }, r.fitColumns = function(a) {
        r.columnResize.dblClickHandler(null, a);
      }, r.onContextMenu = function(a, s, u) {
        if (r.props.onContextMenu) {
          var c = {
            target: r,
            syntheticEvent: a,
            nativeEvent: a.nativeEvent,
            dataItem: s,
            field: u
          };
          r.props.onContextMenu.call(void 0, c);
        }
      }, r.getVirtualScroll = function(a) {
        var s = a.rowHeight, u = a.detailRowHeight, c = a.detail, f = a.expandField, d = a.groupable, h = r.isAllData(), m = s !== void 0 && s > 0, g = u !== void 0 && u > 0, y = d === !0 || typeof d == "object" && d.enabled !== !1, w = !!(c && f);
        return !m || y && !h || w && (!g || !h) ? ff : Ci;
      }, r.isAllData = function() {
        var a = r.props, s = a.data, u = a.total;
        return Array.isArray(s) ? s.length === u : s ? u === s.total : !1;
      }, r.initializeVirtualization = function(a, s) {
        if (r.reInitVirtualization(r.props.scrollable === "virtual", r.props.total, r.props.filter, r.props.group, r.props.sort, s || r.props.rowHeight === void 0 || r.props.rowHeight === 0), r.vs.fixedScroll = r.props.fixedScroll || !1, r.vs.PageChange = r.pageChange, r.vs.realSkip = r.props.skip || 0, r.vs.pageSize = (r.props.take !== void 0 ? r.props.take : r.props.pageSize) || 0, r.vs.scrollableVirtual = r.props.scrollable === "virtual", r.vs.total = a, r.vs.propsSkip = (r.props.skip || 0) + (r.props.scrollable === "virtual" ? r.vs.topCacheCount + (r.vs.attendedSkip - (r.props.skip || 0)) : 0), r.props.rowHeight !== void 0 && r.props.rowHeight > 0 && !s) {
          var u = r.props.rowHeight * a;
          r.vs.containerHeight = gi ? Math.min(vi, u) : u;
        } else
          r.vs.containerHeight = 1533915;
        if (r.vs.containerRef = r.containerRef, r.vs.tableBodyRef = r.tableBodyRef, r.vs.table = r.tableElement, r._slicedData = void 0, r.vs instanceof Ci) {
          var c = r.props, f = c.rowHeight, d = f === void 0 ? 0 : f, h = c.detail, m = c.expandField, g = r.props.detailRowHeight, y = g === void 0 ? 0 : g;
          y = h && m ? y : d, r.isAllData() ? (r.vs.total = r._data.length, r._slicedData = r._data.slice(r.vs.realSkip, r.vs.realSkip + r.vs.pageSize), r.vs.rowHeightService = r.rowHeightService(r.vs, r._data.length, d, y, r._data)) : r.vs.rowHeightService = new yi(a, d, y);
          var u = r.vs.rowHeightService.totalHeight();
          r.vs.containerHeight = gi ? Math.min(vi, u) : u;
        }
      }, r.scrollHandler = function(a) {
        if (a.target === a.currentTarget) {
          clearTimeout(r.forceUpdateTimeout), r.vs.table = r.tableElement;
          var s = a.currentTarget.scrollLeft, u = a.currentTarget.scrollTop;
          r.props.columnVirtualization && (!r.vs.scrollableVirtual || u === r.wrapperScrollTop) && (r.forceUpdateTimeout = window.setTimeout(function() {
            r.forceUpdate();
          }, 0)), r._header && r._header.setScrollLeft(s), r._footer && r._footer.setScrollLeft(s), r.vs && u !== r.wrapperScrollTop && r.vs.scrollHandler(a), eu(r.props.onScroll, a, r, void 0), r.wrapperScrollTop = u;
        }
      }, r.onKeyDown = function(a) {
        if (Ht.onKeyDown(a, {
          contextStateRef: r.contextStateRef,
          navigationStateRef: r.navigationStateRef,
          onNavigationAction: r.onNavigationAction
        }), r.props.onKeyDown) {
          var s = Hn(r.props.selectable), u = s.mode, c = s.cell, f = K({ dataItems: r.getLeafDataItems(), mode: u, cell: c, componentId: r._gridId, selectedField: r.props.selectedField }, r.getArguments(a));
          r.props.onKeyDown.call(void 0, f);
        }
      }, r.onFocus = function(a) {
        Ht.onFocus(a, {
          contextStateRef: r.contextStateRef
        });
      }, r.onNavigationAction = function(a) {
        if (r.props.onNavigationAction) {
          var s = K({ focusElement: a.focusElement }, r.getArguments(a.event));
          r.props.onNavigationAction.call(void 0, s);
        }
      }, r.rowClick = function(a, s) {
        r.props.onRowClick && a.target.nodeName === "TD" && r.props.onRowClick.call(void 0, K({ dataItem: s.dataItem }, r.getArguments(a)));
      }, r.rowDblClick = function(a, s) {
        r.props.onRowDoubleClick && a.target.nodeName === "TD" && r.props.onRowDoubleClick.call(void 0, K({ dataItem: s.dataItem }, r.getArguments(a)));
      }, r.itemChange = function(a) {
        var s = r.props.onItemChange;
        if (a.field === r.props.expandField || r.props.group && a.field === void 0) {
          var u = r.props.onExpandChange;
          u && u.call(void 0, K(K({}, r.getArguments(a.syntheticEvent)), { dataItem: a.dataItem, dataIndex: a.dataIndex, value: a.value }));
          return;
        }
        s && s.call(void 0, K(K({}, r.getArguments(a.syntheticEvent)), { dataItem: a.dataItem, field: a.field, value: a.value }));
      }, r.onHeaderSelectionChange = function(a) {
        r.props.onHeaderSelectionChange && r.props.onHeaderSelectionChange.call(void 0, {
          field: a.field,
          nativeEvent: a.syntheticEvent && a.syntheticEvent.nativeEvent,
          syntheticEvent: a.syntheticEvent,
          target: r,
          dataItems: r.getLeafDataItems(),
          selectedField: r.props.selectedField
        });
      }, r.selectionRelease = function(a) {
        if (r.props.onSelectionChange) {
          var s = K({ syntheticEvent: void 0, target: r, selectedField: r.props.selectedField || "", componentId: r._gridId, dataItems: r.getLeafDataItems(), dataItem: null }, a);
          r.props.onSelectionChange.call(void 0, s);
        }
      }, r.pageChange = function(a, s, u) {
        r.raiseDataEvent(r.props.onPageChange, { page: a }, { skip: a.skip, take: a.take }, s, u);
      }, r.pagerPageChange = function(a) {
        r.pageChange({ skip: a.skip, take: a.take }, a.syntheticEvent, a.targetEvent);
      }, r.sortChange = function(a, s) {
        r.raiseDataEvent(r.props.onSortChange, { sort: a }, K({ sort: a }, r.props.scrollable === "virtual" ? { skip: 0 } : {}), s);
      }, r.filterChange = function(a, s) {
        r.raiseDataEvent(r.props.onFilterChange, { filter: a }, { filter: a || void 0, skip: 0 }, s);
      }, r.groupChange = function(a, s) {
        var u = s.nativeEvent ? s : { nativeEvent: s.nativeEvent || s.originalEvent };
        r.raiseDataEvent(r.props.onGroupChange, { group: a }, { group: a, skip: 0 }, u);
      }, r.onResize = function(a, s, u, c, f, d) {
        r.resetTableWidth(), r._columnsMutations++, r.props.onColumnResize && r.props.onColumnResize.call(void 0, {
          columns: r.columns,
          nativeEvent: c,
          targetColumnId: d,
          index: a,
          newWidth: s,
          oldWidth: u,
          end: f,
          target: r
        });
      }, r.reInitVirtualization = ct(function(a, s, u, c, f, d) {
        r.vs.reset();
        var h = r.getVirtualScroll(r.props);
        r.vs = new h(d);
      }), r.flatData = ct(function(a, s, u, c, f, d, h) {
        var m = [], g = Sa(m, a, s, { index: u }, c !== void 0, f);
        return { flattedData: m, resolvedGroupsCount: g };
      }), r.rowHeightService = ct(function(a, s, u, c, f) {
        return new yi(s, u, c, f);
      }), r.childrenToArray = ct(function(a) {
        return l.Children.toArray(a);
      }), r.readColumns = ct(function(a, s, u) {
        var c = a.filter(function(f) {
          return f && f.type && f.type.displayName === "KendoReactGridColumn";
        });
        return Pa(c, r.columns, { prevId: 0, idPrefix: s });
      }), r.mapColumns = ct(function(a) {
        return Zu(a);
      }), r.configureColumns = ct(function(a, s, u) {
        r.props.selectedField && a.filter(function(h) {
          return h.field === r.props.selectedField;
        }).forEach(function(h) {
          h.width = h.width || "50px", h.cell = h.cell || wc, h.headerCell = h.headerCell || Cf;
        });
        var c = {
          id: "",
          resizable: !0,
          width: "32px",
          title: " ",
          declarationIndex: -1,
          orderIndex: -1,
          children: [],
          parentIndex: -1,
          depth: 0,
          colSpan: 0,
          rowSpan: 0,
          left: 0,
          right: 0,
          index: 0,
          rightBorder: !1,
          ariaColumnIndex: 0,
          isAccessible: !0
        }, f = 0;
        r.props.expandField && r.props.onExpandChange && r.props.detail && (a.unshift(K(K({}, c), { cell: Nc, field: r.props.expandField, headerClassName: "k-hierarchy-cell k-header", id: J.generateNavigatableId("".concat(r._columns.length), u, "column") })), f++);
        for (var d = 0; d < s; d++)
          a.unshift(K(K({}, c), { isAccessible: !1, cell: bi, field: "value", locked: r.props.lockGroups })), f++;
        a.slice(f).forEach(function(h) {
          return h.parentIndex >= 0 && (h.parentIndex += f);
        });
      }), r.getHeaderRow = ct(function(a, s, u, c, f, d, h, m, g, y, w) {
        return l.createElement(Na, { cells: r.props.cells, sort: a, sortable: s, sortChange: r.sortChange, group: u || [], groupable: c, groupChange: r.groupChange, filter: f, filterable: d, filterOperators: h, filterChange: r.filterChange, columnMenu: g, selectionChange: r.onHeaderSelectionChange, columns: y, columnResize: r.columnResize, pressHandler: r.dragLogic.pressHandler, dragHandler: r.dragLogic.dragHandler, releaseHandler: r.dragLogic.releaseHandler, columnsMap: w, cellRender: m, isRtl: r.isRtl, dragClue: r.dragLogic.dragClueRef, headerRef: r.headerElementRef, containerRef: r.containerRef });
      }), r.resolveTitle = function(a) {
        var s = r._columns.find(function(c) {
          return c.field === a;
        }), u = s && (s.title || s.field);
        return u === void 0 ? a : u;
      }, r.getLeafDataItems = function() {
        return r._data.filter(function(a) {
          return a.rowType === "data";
        }).map(function(a) {
          return a.dataItem;
        });
      }, Ys(xi), r.showLicenseWatermark = Zs(xi);
      var o = r.props.groupable === !0 || typeof r.props.groupable == "object" && r.props.groupable.enabled !== !1, i = r.getVirtualScroll(n);
      return r.vs = new i(o || n.rowHeight === void 0 || n.rowHeight === 0), r.dragLogic = new pf(r.columnReorder.bind(r), r.groupReorder.bind(r), r.columnToGroup.bind(r)), r.columnResize = new hf(r.onResize), Ht.onConstructor({
        navigatable: !!n.navigatable,
        contextStateRef: r.contextStateRef,
        navigationStateRef: r.navigationStateRef,
        idPrefix: r._gridId
      }), r;
    }
    return Object.defineProperty(t.prototype, "columns", {
      /* eslint-disable max-len */
      /**
       * A getter of the current columns. Gets the current column width or current columns, or any other [`GridColumnProps`]({% slug api_grid_gridcolumnprops %}) for each defined column. Can be used on each Grid instance. To obtain the instance of the rendered Grid, use the `ref` callback. The following example demonstrates how to reorder the columns by dragging their handlers and check the properties afterwards. You can check the result in the browser console.
       *
       * @example
       * ```jsx
       * class App extends React.Component {
       *     constructor(props) {
       *         super(props);
       *         this.state = {
       *             data: [
       *                 { 'foo': 'A1', 'bar': 'B1' },
       *                 { 'foo': 'A2', 'bar': 'B2' },
       *                 { 'foo': 'A3', 'bar': 'B2' }
       *             ]
       *         };
       *         this.grid = null;
       *     }
       *     render() {
       *         return (
       *             <div>
       *                 <Grid
       *                     data={this.state.data}
       *                     reorderable={true}
       *                     ref={(g) => { this.grid = g; }}
       *                 >
       *                     <GridColumn field="foo" />
       *                     <GridColumn field="bar" />
       *                 </Grid>
       *                 <button onClick={() => console.log(JSON.stringify(this.grid.columns))}>
       *                     log current properties into browser console.
       *                 </button>
       *             </div>
       *         );
       *     }
       * }
       * ReactDOM.render(<App />, document.querySelector('my-app'));
       * ```
       */
      // tslint:enable:max-line-length
      get: function() {
        var n = this._columns.filter(function(r) {
          return r.declarationIndex >= 0 && r.parentIndex === -1;
        });
        return Ta(n);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "element", {
      /**
       * Returns the HTML element of the Grid component.
       */
      get: function() {
        return this._element;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "document", {
      get: function() {
        if (Hr)
          return this.element && this.element.ownerDocument || document;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "_header", {
      get: function() {
        return this.headerRef.current;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.componentDidMount = function() {
      this.resetTableWidth(), Jo();
      var n = Ea(this.element);
      this.isRtl = n, Ht.onComponentDidMount({
        scope: this.element || void 0,
        contextStateRef: this.contextStateRef,
        navigationStateRef: this.navigationStateRef
      }), this.isRtl && this.forceUpdate();
      var r = {
        rootMargin: "0px",
        threshold: 0.9
      };
      this.observer = Hr && window.IntersectionObserver && new window.IntersectionObserver(this.handleIntersection, r) || null;
    }, t.prototype.getSnapshotBeforeUpdate = function() {
      return Ht.onGetSnapshotBeforeUpdate({
        document: this.document,
        contextStateRef: this.contextStateRef,
        navigationStateRef: this.navigationStateRef
      }), null;
    }, t.prototype.componentDidUpdate = function() {
      this.resetTableWidth(), Jo(), this.vs.tableTransform && this.vs.table && (this.vs.table.style.transform = this.vs.tableTransform, this.vs.tableTransform = ""), Ht.onComponentDidUpdate({
        scope: this.element || void 0,
        contextStateRef: this.contextStateRef,
        navigationStateRef: this.navigationStateRef
      });
    }, t.prototype.componentWillUnmount = function() {
      clearTimeout(this.forceUpdateTimeout);
    }, t.prototype.render = function() {
      var n, r, o, i, a = this, s = this.props.total || 0, u = J.getIdPrefix(this.navigationStateRef), c = [];
      Array.isArray(this.props.data) ? (c = this.props.data, s = s || this.props.data.length) : this.props.data && (c = this.props.data.data, s = s || this.props.data.total);
      var f = typeof this.props.groupable == "object" && this.props.groupable.footer || "none", d = this.flatData(c, f, this.props.skip || 0, this.props.group, this.props.expandField, this.props.filter, this.props.sort), h = d.resolvedGroupsCount, m = d.flattedData;
      this._data = m;
      var g = this.props.groupable === !0 || typeof this.props.groupable == "object" && this.props.groupable.enabled !== !1;
      this.columnResize.resizable = this.props.resizable || !1, this.dragLogic.reorderable = this.props.reorderable || !1, this.dragLogic.groupable = g;
      var y = this.props.selectable && this.props.selectable.drag ? "none" : void 0;
      this.initializeVirtualization(s, g);
      var w = this.childrenToArray(this.props.children);
      this.initColumns(w, h);
      var x = w.filter(function(I) {
        return I && I.type && I.type.displayName === "KendoReactGridToolbar";
      }), b = w.filter(function(I) {
        return I && I.type && I.type.displayName === "KendoReactGridNoRecords";
      }), C = this._columns.filter(function(I) {
        return I.children.length === 0;
      }), S = g && l.createElement(Wa, { group: this.props.group || [], groupChange: this.groupChange, pressHandler: this.dragLogic.pressHandler, dragHandler: this.dragLogic.dragHandler, releaseHandler: this.dragLogic.releaseHandler, refCallback: this.dragLogic.refGroupPanelDiv, resolveTitle: this.resolveTitle }), T = this.props, _ = T.sort, k = T.sortable, H = T.group, L = T.filter, B = T.filterable, F = T.filterOperators, G = F === void 0 ? mi : F, Z = T.headerCellRender, ee = T.columnMenu, D = l.createElement(Hc, { size: this.props.size, columnResize: this.columnResize, staticHeaders: this.props.scrollable !== "none", scrollableDataElement: function() {
        return a.vs.container;
      }, draggable: this.props.reorderable || g, ref: this.headerRef, elemRef: this.headerElementRef, headerRow: this.getHeaderRow(_, k, H, g, L, B, G, Z, ee, this._columns, this._columnsMap), filterRow: this.props.filterable && l.createElement(Ua, { cells: this.props.cells, size: this.props.size, columns: this._columns, filter: this.props.filter, filterOperators: this.props.filterOperators || mi, filterChange: this.filterChange, sort: this.props.sort, cellRender: this.props.filterCellRender, isRtl: this.isRtl, ariaRowIndex: this._columnsMap.length + 1 }) || void 0, cols: C.map(function(I, de) {
        return l.createElement("col", { key: de.toString(), width: I.width !== void 0 ? Math.floor(parseFloat(I.width.toString())) + "px" : void 0 });
      }) }), N = this.vs && this.vs.container && this.vs.container.scrollLeft || 0, E = parseFloat(((this.props.style || {}).width || "").toString()), j = tc({
        enabled: this.props.columnVirtualization,
        columns: C,
        tableViewPortWidth: E,
        scrollLeft: N
      }), X = j.colSpans, se = j.hiddenColumns, ie = function(I, de, $e) {
        var Be = !1, be = a.props.selectedField ? Ke(a.props.selectedField, I.dataItem) : void 0;
        return {
          row: C.map(function(Y, ve) {
            if (se[ve])
              return null;
            var Ee = Y.id ? Y.id : ve, et = "".concat(Y.className ? Y.className + " " : "") + "".concat(Y.locked ? "k-grid-content-sticky" : ""), Pe = Y.left !== void 0 ? a.isRtl ? { left: Y.right, right: Y.left } : { left: Y.left, right: Y.right } : {}, Le = !1;
            if (Y.editable && a.props.editField) {
              var Xe = Ke(a.props.editField, I.dataItem);
              (Xe === !0 || Xe === Y.field) && (Be = !0, Le = !0);
            }
            var Ge = Y.cell || Le && jc || gf;
            return l.createElement(Ge, { onContextMenu: a.onContextMenu, key: Ee, locked: a.props.lockGroups, id: J.generateNavigatableId("".concat(de, "-").concat(String(ve)), u), colSpan: X[ve], dataItem: I.dataItem, field: Y.field, editor: Y.editor, format: Y.format, className: et, render: a.props.cellRender, cells: on(a.props.cells, Y.cells), onChange: a.itemChange, selectionChange: a.props.onSelectionChange ? function(pt) {
              a.selectionChange({ event: pt, dataItem: I.dataItem, dataIndex: $e, columnIndex: ve });
            } : void 0, columnIndex: ve, columnsCount: C.length, rowType: I.rowType, level: I.level, expanded: I.expanded, dataIndex: I.dataIndex, style: Pe, ariaColumnIndex: Y.ariaColumnIndex, isSelected: Array.isArray(be) && be.indexOf(ve) > -1 });
          }),
          isInEdit: Be,
          isSelected: typeof be == "boolean" && be
        };
      }, ce = 0;
      if (this.props.scrollable === "virtual")
        for (var pe = 0; pe < this.vs.topCacheCount + this.vs.attendedSkip - (this.props.skip || 0); pe++) {
          var ae = this._data.shift();
          if (ae)
            this._data.push(ae), ce++, ae.rowType === "groupHeader" && pe--;
          else
            break;
        }
      var ye = function(I) {
        return I >= a._data.length - ce;
      }, Se = this.vs.realSkip || 0, P = [], M = this._columnsMap.length + (this.props.filterable ? 1 : 0) + 1, U = 0;
      if (this._data.length) {
        var W = -1, ge = 0;
        (this._slicedData || this._data).forEach(function(I, de) {
          I.rowType === "data" && (Se++, W++);
          var $e = Se % 2 === 0, Be = a.props.dataItemKey && $s(a.props.dataItemKey)(I.dataItem), be = de + (a.vs.realSkip || 0), Y = Be || "ai" + be, ve = Y + "_1", Ee = ie(I, Y, W);
          if (U = be + M + ge, P.push(l.createElement(mf, { key: Y, dataItem: I.dataItem, isAltRow: $e, isInEdit: Ee.isInEdit, rowType: I.rowType, isHidden: ye(de), onClick: function(Pe) {
            return a.rowClick(Pe, I);
          }, onDoubleClick: function(Pe) {
            return a.rowDblClick(Pe, I);
          }, selectedField: a.props.selectedField, rowHeight: a.props.rowHeight, render: a.props.rowRender, ariaRowIndex: U, absoluteRowIndex: be, dataIndex: W, isSelected: Ee.isSelected }, Ee.row)), a.props.detail && I.rowType === "data" && I.expanded) {
            var et = C.length - (a.props.expandField ? 1 : 0) - (a.props.group ? a.props.group.length : 0) || 1;
            ge++, U = be + M + ge, P.push(l.createElement(
              "tr",
              { key: ve, className: le("k-table-row", $e ? "k-detail-row k-table-alt-row k-alt" : "k-detail-row"), style: { visibility: ye(de) ? "hidden" : "", height: a.props.detailRowHeight }, role: "row", "aria-rowindex": U },
              a.props.group && a.props.group.map(function(Pe, Le) {
                var Xe, Ge = (Xe = Ee == null ? void 0 : Ee.row[Le]) === null || Xe === void 0 ? void 0 : Xe.props.style, pt = Ge ? a.isRtl ? { left: Ge.right, right: Ge.left } : { left: Ge.left, right: Ge.right } : {};
                return l.createElement(bi, { id: "", dataIndex: I.dataIndex, field: Pe.field, dataItem: I.dataItem, key: Le, style: pt, ariaColumnIndex: 1 + Le, isSelected: !1, locked: a.props.lockGroups, isRtl: a.isRtl, cells: a.props.cells });
              }),
              a.props.expandField && l.createElement(kf, { id: J.generateNavigatableId("".concat(ve, "-dhcell"), u) }),
              l.createElement(If, { onContextMenu: a.onContextMenu, dataItem: I.dataItem, dataIndex: I.dataIndex, colSpan: et, ariaColIndex: 2 + (a.props.group ? a.props.group.length : 0), detail: a.props.detail, id: J.generateNavigatableId("".concat(ve, "-dcell"), u) })
            ));
          }
        });
      } else
        P.push(l.createElement(
          "tr",
          { key: "no-records", className: "k-table-row k-grid-norecords", role: "row", "aria-rowindex": M },
          l.createElement("td", { className: "k-table-td", colSpan: C.length, role: "gridcell" }, b.length ? b : l.createElement(Va, null))
        ));
      var Ne = K({ size: this.props.size, onPageChange: this.pagerPageChange, total: s, dir: this.isRtl ? "rtl" : void 0, skip: this.vs.propsSkip || 0, take: (this.props.take !== void 0 ? this.props.take : this.props.pageSize) || 10, messagesMap: Fc }, Ef(this.props.pageable || {})), He = this.props.pager ? l.createElement(this.props.pager, K({}, Ne)) : l.createElement(Ql, K({ className: "k-grid-pager" }, Ne)), fe = function(I) {
        return a.props.sort && a.props.sort.filter(function(de) {
          return de.field === I;
        }).length > 0;
      }, jt = this._columns.some(function(I) {
        return !!I.footerCell;
      }) ? l.createElement(cf, { size: this.props.size, columnResize: this.columnResize, staticHeaders: this.props.scrollable !== "none", ref: function(I) {
        return a._footer = I;
      }, row: l.createElement(wf, { cells: this.props.cells, columns: this._columns, isRtl: this.isRtl, ariaRowIndex: U + 1 }), cols: C.map(function(I, de) {
        return l.createElement("col", { key: de.toString(), width: I.width !== void 0 ? Math.floor(parseFloat(I.width.toString())) + "px" : void 0 });
      }) }) : null, lt = l.createElement("colgroup", { ref: function(I) {
        a.columnResize.colGroupMain = I;
      } }, C.map(function(I, de) {
        return l.createElement("col", { key: de.toString(), className: fe(I.field) ? "k-sorted" : void 0, width: I.width !== void 0 ? Math.floor(parseFloat(I.width.toString())) + "px" : void 0 });
      })), st = this.dragLogic.reorderable || this.dragLogic.groupable, we = this.props.columnVirtualization ? "block" : "table";
      if (this.props.scrollable === "none")
        return l.createElement(
          ur.Provider,
          { value: this.contextStateRef.current },
          l.createElement(
            "div",
            K({ id: this.props.id, style: this.props.style, className: le("k-grid", (n = {
              "k-grid-md": !this.props.size
            }, n["k-grid-".concat(Dt.sizeMap[this.props.size] || this.props.size)] = this.props.size, n), this.props.className), ref: function(I) {
              a._element = I;
            }, "aria-label": this.props.ariaLabel, onKeyDown: this.onKeyDown, onFocus: this.onFocus }, ai),
            x,
            S,
            l.createElement(
              pi,
              { selectable: this.props.selectable, onRelease: this.selectionRelease, childRef: function(I) {
                a.tableElement = I;
              } },
              l.createElement(
                "table",
                { className: le("k-table k-grid-table", (r = {}, r["k-table-".concat(Dt.sizeMap[this.props.size] || this.props.size)] = this.props.size, r)), style: { userSelect: y, display: we } },
                lt,
                D,
                l.createElement("tbody", K({ role: "rowgroup", className: "k-table-tbody" }, si), P),
                jt
              )
            ),
            this.props.pageable && He,
            st && l.createElement(
              l.Fragment,
              null,
              l.createElement(fi, { ref: this.dragLogic.refDropElementClue }),
              l.createElement(ci, { ref: this.dragLogic.refDragElementClue })
            )
          )
        );
      var _e = this.props.style || {};
      return this.props.scrollable === "virtual" && (_e.height || (_e = Object.assign({}, _e, { height: "450px" }))), l.createElement(
        ur.Provider,
        { value: this.contextStateRef.current },
        l.createElement(
          "div",
          K({ id: this.props.id, style: _e, className: le("k-grid", (o = {
            "k-grid-md": !this.props.size
          }, o["k-grid-".concat(Dt.sizeMap[this.props.size] || this.props.size)] = this.props.size, o["k-grid-virtual"] = this.props.scrollable === "virtual", o), this.props.className), ref: function(I) {
            a._element = I;
          }, role: "grid", "aria-colcount": C.length, "aria-rowcount": s, "aria-label": this.props.ariaLabel, onKeyDown: this.onKeyDown, onFocus: this.onFocus }, ai),
          x,
          S,
          D,
          l.createElement(
            "div",
            { className: "k-grid-container", role: "presentation" },
            l.createElement(
              "div",
              { ref: this.containerRef, className: "k-grid-content k-virtual-content", onScroll: this.scrollHandler, role: "presentation" },
              l.createElement(
                "div",
                { className: "k-grid-table-wrap", role: "presentation" },
                l.createElement(
                  pi,
                  { selectable: this.props.selectable, onRelease: this.selectionRelease, childRef: function(I) {
                    a.tableElement = I;
                  } },
                  l.createElement(
                    "table",
                    { className: le("k-table k-grid-table", (i = {
                      "k-table-md": !this.props.size
                    }, i["k-table-".concat(Dt.sizeMap[this.props.size] || this.props.size)] = this.props.size, i)), role: "presentation", style: { userSelect: y, display: we } },
                    lt,
                    l.createElement("tbody", K({ className: "k-table-tbody", ref: this.tableBodyRef, role: "rowgroup" }, si), P)
                  )
                )
              ),
              l.createElement(
                "div",
                { className: "k-height-container", role: "presentation" },
                l.createElement("div", { style: this.props.scrollable === "virtual" ? { height: this.vs.containerHeight + "px" } : {} })
              )
            )
          ),
          jt,
          this.props.pageable && He,
          st && l.createElement(
            l.Fragment,
            null,
            l.createElement(fi, { ref: this.dragLogic.refDropElementClue }),
            l.createElement(ci, { ref: this.dragLogic.refDragElementClue })
          ),
          this.showLicenseWatermark && l.createElement(Js, null)
        )
      );
    }, t.prototype.selectionChange = function(n) {
      if (this.props.onSelectionChange) {
        var r = n.event, o = n.dataItem, i = n.dataIndex, a = n.columnIndex, s = Hn(this.props.selectable), u = s.mode, c = s.cell, f = K(K({}, this.getArguments(r.syntheticEvent)), { dataItem: o, startColIndex: a, endColIndex: a, startRowIndex: i, endRowIndex: i, dataItems: this.getLeafDataItems(), altKey: !1, ctrlKey: !1, shiftKey: !1, metaKey: !1, mode: u, cell: c, isDrag: !1, componentId: this._gridId, selectedField: this.props.selectedField || "" });
        this.props.onSelectionChange.call(void 0, f);
      }
    }, t.prototype.raiseDataEvent = function(n, r, o, i, a) {
      var s = this.props.onDataStateChange;
      if (n) {
        var u = K(K(K({}, this.getArguments(i)), r), { targetEvent: a });
        n.call(void 0, u);
      } else
        s && s.call(void 0, K(K({}, this.getArguments(i)), { targetEvent: a || {}, dataState: K(K({}, this.getDataState()), o) }));
    }, t.prototype.columnReorder = function(n, r, o) {
      var i, a = this, s = this._columns[n], u = s.depth, c = function(m) {
        do
          m++;
        while (m < a._columns.length && a._columns[m].depth > u);
        return m;
      }, f = this._columns.splice(n, c(n) - n);
      (i = this._columns).splice.apply(i, wi([n < r ? c(r - f.length) : r, 0], f, !1)), this._columns.filter(function(m) {
        return m.declarationIndex >= 0;
      }).forEach(function(m, g) {
        return m.orderIndex = g;
      }), this._columnsMutations++;
      var d = this.columns;
      if (this.forceUpdate(), this.props.onColumnReorder) {
        var h = {
          target: this,
          columns: d,
          columnId: s.id,
          nativeEvent: o
        };
        this.props.onColumnReorder.call(void 0, h);
      }
    }, t.prototype.groupReorder = function(n, r, o) {
      if (this.props.group !== void 0) {
        var i = this.props.group.slice();
        i.splice.apply(i, wi([r, 0], i.splice(n, 1), !1)), this.groupChange(i, o);
      }
    }, t.prototype.columnToGroup = function(n, r, o) {
      var i = this._columns[n].field;
      if (i) {
        var a = (this.props.group || []).slice();
        a.splice(r, 0, { field: i }), this.groupChange(a, o);
      }
    }, t.prototype.resetTableWidth = function() {
      var n = 0;
      if (this.columnResize.colGroupMain) {
        for (var r = this.columnResize.colGroupMain.children, o = 0; o < r.length; o++) {
          var i = r[o].width;
          if (!i)
            return;
          n += parseFloat(i.toString());
        }
        n = Math.round(n), this._header && this._header.setWidth(n), this._footer && this._footer.setWidth(n), this.tableElement && (this.tableElement.style.width = n + "px");
      }
    }, t.prototype.initColumns = function(n, r) {
      var o = J.getIdPrefix(this.navigationStateRef);
      this._columns = this.readColumns(n, o, this._columnsMutations), this._columns.length === 0 && (this._columns = Cc(this.props.data, this.props.group, this.props.expandField, { prevId: 0, idPrefix: o })), this.configureColumns(this._columns, r, o), this._columnsMap = this.mapColumns(this._columns), this.columnResize.columns = this._columns, this.dragLogic.columns = this._columns;
    }, t.prototype.getDataState = function() {
      return {
        filter: this.props.filter,
        sort: this.props.sort,
        skip: this.props.skip,
        take: this.props.take !== void 0 ? this.props.take : this.props.pageSize,
        group: this.props.group
      };
    }, t.prototype.getArguments = function(n) {
      return {
        nativeEvent: n && n.nativeEvent,
        syntheticEvent: n,
        target: this
      };
    }, t.displayName = "KendoReactGrid", t.defaultProps = {
      // never use this
    }, t.propTypes = {
      data: p.oneOfType([
        p.array,
        p.shape({
          data: p.array,
          total: p.number
        })
      ]),
      sortable: p.oneOfType([
        p.bool,
        p.shape({
          mode: p.oneOf(["single", "multiple"]),
          allowUnsort: p.bool
        })
      ]),
      onSortChange: p.func,
      sort: p.array,
      filterable: p.bool,
      filter: p.any,
      onFilterChange: p.func,
      pageable: p.oneOfType([
        p.bool,
        p.shape({
          buttonCount: p.number,
          info: p.bool,
          type: p.oneOf(["numeric", "input"]),
          pageSizes: p.oneOfType([
            p.bool,
            p.arrayOf(p.oneOfType([
              p.string,
              p.number
            ]))
          ]),
          previousNext: p.bool
        })
      ]),
      pageSize: p.number,
      onPageChange: p.func,
      total: p.number,
      skip: p.number,
      take: p.number,
      fixedScroll: p.bool,
      onExpandChange: p.func,
      expandField: p.string,
      selectedField: p.string,
      onSelectionChange: p.func,
      onHeaderSelectionChange: p.func,
      resizable: p.bool,
      reorderable: p.bool,
      group: p.any,
      groupable: p.oneOfType([
        p.bool,
        p.shape({
          enabled: p.bool,
          footer: p.oneOf(["always", "visible", "none"])
        })
      ]),
      onGroupChange: p.func,
      onRowClick: p.func,
      onRowDoubleClick: p.func,
      onItemChange: p.func,
      editField: p.string,
      scrollable: p.oneOf(["none", "scrollable", "virtual"]),
      rowHeight: p.number,
      detailRowHeight: p.number,
      detail: p.any,
      style: p.object,
      onDataStateChange: p.func,
      onColumnResize: p.func,
      onColumnReorder: p.func,
      dataItemKey: p.string,
      navigatable: p.bool,
      size: p.oneOf(["small", "medium"])
    }, t.contextType = ur, t;
  }(l.Component)
), Pf = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), qa = (
  /** @class */
  function(e) {
    Pf(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.render = function() {
      var n = this.props.children;
      return l.createElement("div", { id: this.props.id, className: le("k-columnmenu-item-wrapper", this.props.className), style: this.props.style }, n);
    }, t;
  }(l.Component)
), Tf = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), $a = (
  /** @class */
  function(e) {
    Tf(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.onClick = function(r) {
        n.props.onClick && n.props.onClick(r);
      }, n;
    }
    return t.prototype.render = function() {
      var n = this.props, r = n.title, o = n.iconClass, i = n.svgIcon, a = n.selected;
      return l.createElement(
        "div",
        { onClick: this.onClick, className: "k-columnmenu-item ".concat(a ? "k-selected" : "") },
        (o || i) && l.createElement(ot, { name: o && iu(o), icon: i }),
        r
      );
    }, t;
  }(l.Component)
), Rf = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Xa = (
  /** @class */
  function(e) {
    Rf(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.render = function() {
      return l.createElement(
        "div",
        { id: this.props.id, className: le("k-columnmenu-item-content", this.props.className), style: this.props.style },
        l.createElement(Yl, { style: { position: "relative", display: "block" } }, this.props.show ? this.props.children : null)
      );
    }, t;
  }(l.Component)
), Df = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), _i = (
  /** @class */
  function(e) {
    Df(t, e);
    function t(n) {
      var r = e.call(this, n) || this;
      return r.renderOperatorEditor = function() {
        if (r.props.filterType !== "boolean") {
          var o = r.props.operators.find(function(i) {
            return i.operator === r.props.operator;
          }) || null;
          return l.createElement(gr, { value: o, onChange: r.operatorChange, data: r.props.operators, textField: "text" });
        }
      }, r.inputChange = r.inputChange.bind(r), r.operatorChange = r.operatorChange.bind(r), r.boolDropdownChange = r.boolDropdownChange.bind(r), r;
    }
    return t.prototype.render = function() {
      return l.createElement(
        l.Fragment,
        null,
        this.renderOperatorEditor(),
        this.filterComponent(this.props.filterType, this.props.value, this.props.booleanValues)
      );
    }, t.prototype.inputChange = function(n, r) {
      ja(n, r, this.props);
    }, t.prototype.operatorChange = function(n) {
      Ba(n, this.props.value, this.props.onChange);
    }, t.prototype.boolDropdownChange = function(n) {
      Ha(n, this.props.onChange);
    }, t.prototype.filterComponent = function(n, r, o) {
      var i = this;
      switch (n) {
        case "numeric":
          return l.createElement(go, { value: r, onChange: function(s) {
            i.inputChange(s.value, s.syntheticEvent);
          }, rangeOnEnter: !1 });
        case "date":
          return l.createElement(vo, { value: r, onChange: function(s) {
            i.inputChange(s.value, s.syntheticEvent);
          } });
        case "boolean":
          var a = function(s) {
            return s == null;
          };
          return l.createElement(gr, { onChange: this.boolDropdownChange, value: o.find(function(s) {
            return s.operator === (a(r) ? "" : r);
          }), data: o, textField: "text" });
        default:
          return l.createElement(Vi, { value: r || "", onChange: function(s) {
            i.inputChange(s.target.value, s.syntheticEvent);
          } });
      }
    }, t;
  }(l.Component)
), Af = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Xr = globalThis && globalThis.__assign || function() {
  return Xr = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, Xr.apply(this, arguments);
}, Mf = (
  /** @class */
  function(e) {
    Af(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.render = function() {
      var n = this.props, r = n.firstFilterProps, o = n.hideSecondFilter, i = n.secondFilterProps, a = n.logicData, s = n.logicValue, u = n.onLogicChange;
      return l.createElement(
        l.Fragment,
        null,
        l.createElement(_i, Xr({}, r)),
        !o && l.createElement(
          l.Fragment,
          null,
          l.createElement(gr, { data: a, value: s, onChange: u, className: "k-filter-and", textField: "text" }),
          l.createElement(_i, Xr({}, i))
        )
      );
    }, t;
  }(l.Component)
), Ff = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Q = globalThis && globalThis.__assign || function() {
  return Q = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, Q.apply(this, arguments);
}, kr = globalThis && globalThis.__spreadArray || function(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, i; r < o; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}, oo = function(e) {
  return e || { filters: [], logic: "and" };
}, Or = function(e, t) {
  var n = oo(t), r = n.filters.filter(function(o) {
    return zo(o) ? o.filters && o.filters.length && o.filters.length <= 2 && !o.filters.find(function(i) {
      return zo(i) || i.field !== e;
    }) : !1;
  });
  return r[0] || null;
}, Ya = (
  /** @class */
  function(e) {
    Ff(t, e);
    function t(n) {
      var r = e.call(this, n) || this;
      r.removeGroup = function(s, u) {
        var c = kr([], u.filters, !0), f = c.findIndex(function(d) {
          return d === s;
        });
        return f > -1 && c.splice(f, 1), Q(Q({}, u), { filters: c });
      }, r.insertGroup = function(s, u) {
        return Q(Q({}, u), { filters: kr([
          s
        ], u.filters, !0) });
      }, r.isControlled = function() {
        return r.props.expanded !== void 0;
      }, r.onFilterExpand = function() {
        var s = r.isControlled(), u = !(s ? r.props.expanded : r.state.expanded);
        r.props.onExpandChange && r.props.onExpandChange(u), s || r.setState({
          expanded: u
        });
      }, r.firstFilterChange = function(s) {
        r.filterChange(0, s);
      }, r.secondFilterChange = function(s) {
        r.filterChange(1, s);
      }, r.filterChange = function(s, u) {
        var c = r.state.filterGroup.filters.map(function(f, d) {
          return d === s ? Q(Q({}, f), { value: u.value, operator: u.operator }) : f;
        });
        r.setState({
          filterGroup: Q(Q({}, r.state.filterGroup), { filters: c })
        });
      }, r.logicChange = function(s) {
        r.setState({
          filterGroup: Q(Q({}, r.state.filterGroup), { logic: s.target.value.operator })
        });
      }, r.clear = function(s) {
        if (s.preventDefault(), !!r.props.onFilterChange) {
          var u = r.props.column.field, c = oo(r.props.filter), f = Or(u, r.props.filter), d = c.filters.filter(function(h) {
            return h !== f;
          });
          d.length ? r.props.onFilterChange(Q(Q({}, c), { filters: d }), s) : r.props.onFilterChange(null, s), r.props.onCloseMenu && r.props.onCloseMenu();
        }
      }, r.currentFilterGroup = function() {
        return Q(Q({}, r.state.filterGroup), { filters: r.state.filterGroup.filters.filter(function(s) {
          return s.value !== void 0 && s.value !== null && s.value !== "" || s.value === null && s.operator;
        }) });
      }, r.submit = function(s) {
        if (s.preventDefault(), !!r.props.onFilterChange) {
          var u = r.props.column.field, c = oo(r.props.filter), f = Or(u, r.props.filter), d = r.currentFilterGroup(), h = null;
          if (f && d.filters.length > 0) {
            var m = c.filters.map(function(g) {
              return g === f ? d : g;
            });
            h = Q(Q({}, c), { filters: m });
          } else if (d.filters.length === 0) {
            var m = c.filters.filter(function(y) {
              return y !== f;
            });
            m.length && (h = Q(Q({}, c), { filters: m }));
          } else
            h = Q(Q({}, c), { filters: kr(kr([], c.filters, !0), [d], !1) });
          r.props.onFilterChange(h, s), r.props.onCloseMenu && r.props.onCloseMenu();
        }
      };
      var o;
      if (n.column && n.column.field) {
        var i = Jn(n.column.filter), a = za(n.filterOperators, i);
        o = Or(n.column.field, n.filter), o = o ? Q(Q({}, o), { filters: o.filters.map(function(s) {
          return Q({}, s);
        }) }) : {
          logic: "and",
          filters: [
            { field: n.column.field, operator: a, value: rt(a) ? null : void 0 },
            { field: n.column.field, operator: a, value: rt(a) ? null : void 0 }
          ]
        }, o.filters.filter(function(s) {
          return s.field === n.column.field;
        }).length === 1 && o.filters.splice(1, 0, { field: n.column.field, operator: a });
      }
      return r.state = {
        expanded: n.expanded || !1,
        filterGroup: o
      }, r;
    }
    return t.prototype.render = function() {
      var n = this.props, r = n.column, o = n.filterUI, i = n.hideSecondFilter, a = n.filterOperators;
      if (!r || !r.field)
        return l.createElement("div", null);
      var s = Jn(r.filter), u = i !== void 0 ? i : rf[s], c = We(this), f = this.state.filterGroup.filters, d = dr(a[s], c), h = dr(La, c), m = {
        field: r.field,
        value: f[0].value,
        operator: f[0].operator,
        operators: d,
        booleanValues: h,
        onChange: this.firstFilterChange,
        filterType: s
      }, g = {
        field: r.field,
        value: f[1].value,
        operator: f[1].operator,
        operators: d,
        booleanValues: h,
        onChange: this.secondFilterChange,
        filterType: s
      }, y = this.state.filterGroup.logic, w = dr(ef, c), x = {
        value: w.find(function(_) {
          return _.operator === (y === null ? "" : y);
        }),
        onChange: this.logicChange,
        data: w
      }, b = o, C = {
        firstFilterProps: m,
        secondFilterProps: g,
        logicData: x.data,
        logicValue: x.value,
        onLogicChange: x.onChange,
        hideSecondFilter: u
      }, S = this.currentFilterGroup().filters.length !== 0 || rt(f[0].operator) || rt(f[1].operator), T = this.isControlled() ? this.props.expanded : this.state.expanded;
      return l.createElement(
        qa,
        null,
        l.createElement($a, { title: c.toLanguageString(mr, ue[mr]), iconClass: "k-i-filter", svgIcon: Qr, onClick: this.onFilterExpand }),
        l.createElement(
          Xa,
          { show: !!T },
          l.createElement(
            "div",
            { className: "kendo-grid-filter-menu-container" },
            l.createElement(
              "form",
              { className: "k-filter-menu k-group k-reset k-state-border-up", onSubmit: this.submit, onReset: this.clear, onKeyDown: function(_) {
                return _.stopPropagation();
              } },
              l.createElement(
                "div",
                { className: "k-filter-menu-container" },
                b ? l.createElement(b, Q({}, C)) : l.createElement(Mf, Q({}, C)),
                l.createElement(
                  "div",
                  { className: "k-actions k-actions-stretched" },
                  l.createElement(nt, { themeColor: "primary", disabled: !S }, c.toLanguageString(vr, ue[vr])),
                  l.createElement(nt, { type: "reset" }, c.toLanguageString(Mt, ue[Mt]))
                )
              )
            )
          )
        )
      );
    }, t.active = function(n, r) {
      return !!Or(n, r);
    }, t;
  }(l.Component)
);
dt(Ya);
var Nf = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), io = globalThis && globalThis.__assign || function() {
  return io = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, io.apply(this, arguments);
}, vn = globalThis && globalThis.__spreadArray || function(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, i; r < o; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}, Lf = function(e, t) {
  return e.length !== t.length ? !1 : e.every(function(n, r) {
    return n === t[r];
  });
}, Za = (
  /** @class */
  function(e) {
    Nf(t, e);
    function t(n) {
      var r = e.call(this, n) || this;
      return r.defaultFilter = function() {
        return r.props.filter ? Ks(r.props.filter) : { filters: [], logic: "and" };
      }, r.isControlled = function() {
        return r.props.expanded !== void 0;
      }, r.parseData = function(o, i) {
        var a = r.props.column.field || "", s = o.map(function(u) {
          return Ke(a, u);
        });
        return i ? s.filter(function(u, c) {
          return s.indexOf(u) === c;
        }) : s;
      }, r.getFilterIndex = function() {
        var o = r.props.column.field, i = r.defaultFilter(), a = i.filters.findIndex(function(s) {
          return s.filters && s.filters.length > 0 && s.filters[0].field === o;
        });
        return a;
      }, r.onFilterExpand = function() {
        var o = r.isControlled(), i = !(o ? r.props.expanded : r.state.expanded);
        r.props.onExpandChange && r.props.onExpandChange(i), o || r.setState({
          expanded: i
        });
      }, r.handleSearchChange = function(o) {
        var i = r.props.searchBoxFilterOperator ? r.props.searchBoxFilterOperator : "startswith", a = {
          logic: "and",
          filters: [
            { field: r.props.column.field, operator: i, value: o.target.value, ignoreCase: !0 }
          ]
        };
        r.setState({
          value: o.target.value,
          data: r.parseData(wn(r.props.data || [], a), r.props.uniqueData)
        });
      }, r.handleClear = function() {
        var o = r.props.searchBoxFilterOperator ? r.props.searchBoxFilterOperator : "startswith", i = {
          logic: "and",
          filters: [
            { field: r.props.column.field, operator: o, value: "", ignoreCase: !0 }
          ]
        };
        r.setState({
          value: "",
          data: r.parseData(wn(r.props.data || [], i), r.props.uniqueData)
        });
      }, r.clear = function(o) {
        if (o.preventDefault(), !!r.props.onFilterChange) {
          var i = r.state.currentFilter || null;
          i !== null && i.filters.length > 0 ? (r.compositeFilterIndex >= 0 && i.filters.splice(r.compositeFilterIndex, 1), r.props.onFilterChange(i, o)) : r.props.onFilterChange(null, o), r.props.onCloseMenu && r.props.onCloseMenu();
        }
      }, r.submit = function(o) {
        if (o.preventDefault(), !!r.props.onFilterChange) {
          var i = r.state.currentFilter || null;
          r.props.onFilterChange(i, o), r.props.onCloseMenu && r.props.onCloseMenu();
        }
      }, r.handleCheckBoxChange = function(o, i) {
        var a = r.props.column.field || "", s = io({}, r.state.currentFilter), u = vn([], r.state.currentFilter.filters, !0) || [], c = [];
        if (r.compositeFilterIndex !== -1 && s.filters[r.compositeFilterIndex].filters && i !== "all" && (c = s.filters[r.compositeFilterIndex].filters), o.value && i === "all")
          r.state.data.forEach(function(d) {
            c.push({ field: a, operator: "eq", value: d });
          });
        else if (o.value)
          c.push({ field: a, operator: "eq", value: i });
        else if (r.state.currentFilter) {
          var f = c.findIndex(function(d) {
            return d.value === i;
          });
          c.splice(f, 1);
        }
        s.logic = "and", r.compositeFilterIndex !== -1 ? u[r.compositeFilterIndex] = {
          logic: "or",
          filters: c
        } : u.push({
          logic: "or",
          filters: c
        }), (!o.value && i === "all" || c.length === 0) && u.splice(r.compositeFilterIndex, 1), s.filters = u, r.setState({ currentFilter: s });
      }, r.isAllSelected = function() {
        var o = !1;
        if (r.state.currentFilter) {
          var i = vn([], r.state.currentFilter.filters, !0);
          return r.compositeFilterIndex === -1 ? !1 : (o = r.state.data.every(function(a) {
            if (r.compositeFilterIndex !== -1 && i[r.compositeFilterIndex].filters) {
              var s = i[r.compositeFilterIndex].filters.findIndex(function(u) {
                return u.value === a;
              });
              return s >= 0;
            }
            return !1;
          }), o);
        }
        return o;
      }, r.compositeFilterIndex = r.getFilterIndex(), r.state = {
        expanded: n.expanded || !1,
        value: "",
        data: r.parseData(r.props.data, r.props.uniqueData) || [],
        dataFromProps: r.parseData(r.props.data, !1) || [],
        currentFilter: r.defaultFilter()
      }, r;
    }
    return t.prototype.componentDidUpdate = function() {
      var n = this.props.column.field || "", r = this.props.data.map(function(o) {
        return Ke(n, o);
      });
      Lf(r, this.state.dataFromProps) || this.setState({
        data: r,
        dataFromProps: r
      });
    }, t.prototype.render = function() {
      var n = this, r = this.props.column;
      if (!r || !r.field)
        return l.createElement("div", null);
      var o = We(this), i = this.isControlled() ? this.props.expanded : this.state.expanded, a = [];
      if (this.state.currentFilter) {
        var s = vn([], this.state.currentFilter.filters, !0);
        this.compositeFilterIndex = s.findIndex(function(f) {
          return f.filters && f.filters.length > 0 ? f.filters[0].field === r.field : !1;
        }), this.compositeFilterIndex !== -1 && s[this.compositeFilterIndex].filters.length > 0 && s[this.compositeFilterIndex].filters.forEach(function(f) {
          f.field === n.props.column.field && a.push(f.value);
        });
      }
      var u = this.props.searchBox ? l.createElement(this.props.searchBox, { value: this.state.value, onChange: this.handleSearchChange }) : l.createElement(
        "div",
        { className: "k-searchbox k-textbox k-input k-input-md k-input-solid" },
        l.createElement(ot, { className: "k-input-icon", name: "search", icon: Gl }),
        l.createElement(Vi, { className: "k-input-inner", type: "text", placeholder: o.toLanguageString(Wn, ue[Wn]), value: this.state.value, onChange: function(f) {
          return n.handleSearchChange(f.nativeEvent);
        } }),
        l.createElement(nt, { type: "button", rounded: null, className: "k-input-button", onClick: this.handleClear, icon: "x", svgIcon: Ul })
      ), c = a.filter(function(f, d) {
        return a.indexOf(f) === d;
      });
      return l.createElement(
        qa,
        null,
        l.createElement($a, { title: o.toLanguageString(mr, ue[mr]), iconClass: "k-i-filter", svgIcon: Qr, onClick: this.onFilterExpand }),
        l.createElement(
          Xa,
          { show: !!i },
          l.createElement(
            "div",
            { className: "kendo-grid-filter-menu-container" },
            l.createElement(
              "form",
              { className: "k-filter-menu k-group k-reset k-state-border-up", onSubmit: this.submit, onReset: this.clear },
              l.createElement(
                "div",
                { className: "k-filter-menu-container" },
                u,
                l.createElement(
                  "ul",
                  { className: "k-reset k-multicheck-wrap" },
                  l.createElement(
                    "li",
                    { className: "k-item k-check-all-wrap" },
                    l.createElement(Go, { label: o.toLanguageString(Vn, ue[Vn]), onChange: function(f) {
                      return n.handleCheckBoxChange(f, "all");
                    }, checked: this.isAllSelected() })
                  ),
                  this.state.data.map(function(f, d) {
                    return l.createElement(
                      "li",
                      { className: "k-item", key: d },
                      l.createElement(Go, { label: String(f), onChange: function(h) {
                        return n.handleCheckBoxChange(h, f);
                      }, checked: c.includes(f) })
                    );
                  })
                ),
                l.createElement("div", { className: "k-filter-selected-items" }, c.length + " " + o.toLanguageString($n, ue[$n])),
                l.createElement(
                  "div",
                  { className: "k-actions k-hstack k-justify-content-stretch" },
                  l.createElement(nt, { themeColor: "primary", type: "submit" }, o.toLanguageString(vr, ue[vr])),
                  l.createElement(nt, { className: "k-button", type: "reset" }, o.toLanguageString(Mt, ue[Mt]))
                )
              )
            )
          )
        )
      );
    }, t.defaultProps = {
      uniqueData: !0
    }, t;
  }(l.Component)
);
dt(Za);
var jf = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), zf = (
  /** @class */
  function(e) {
    jf(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.render = function() {
      var n;
      return l.createElement("div", { className: le("k-toolbar k-grid-toolbar", (n = {
        "k-toolbar-md": !this.props.size
      }, n["k-toolbar-".concat(Dt.sizeMap[this.props.size] || this.props.size)] = this.props.size, n), this.props.className) }, this.props.children);
    }, t.displayName = "KendoReactGridToolbar", t;
  }(l.Component)
), Qa = {
  compile: function(e) {
    return e;
  }
}, Po = function() {
};
Po.register = function(t) {
  Qa = t;
};
Po.compile = function(t) {
  return Qa.compile(t);
};
const Sr = Po;
var Hf = /\[(?:(\d+)|['"](.*?)['"])\]|((?:(?!\[.*?\]|\.).)+)/g, ir = {}, Ja = "undefined";
ir[Ja] = function(e) {
  return e;
};
function Ei(e) {
  if (ir[e])
    return ir[e];
  var t = [];
  return e.replace(Hf, function(n, r, o, i) {
    t.push(typeof r !== Ja ? r : o || i);
  }), ir[e] = function(n) {
    for (var r = n, o = 0; o < t.length && r; o++)
      r = r[t[o]];
    return r;
  }, ir[e];
}
function Ze(e, t) {
  return e.reduce(function(n, r, o) {
    var i = t(r, o);
    return i != null && n.push(i), n;
  }, []);
}
function Bf(e) {
  return e.title + ": " + e.value;
}
function To(e, t) {
  for (var n = [], r = 0; r < e; r++)
    n.push(t(r));
  return n;
}
function Gf(e) {
  return e.id;
}
var ne = function(t) {
  t.columns = this._trimColumns(t.columns || []), this.allColumns = Ze(this._leafColumns(t.columns || []), this._prepareColumn), this.columns = this._visibleColumns(this.allColumns), this.options = t, this.data = t.data || [], this.aggregates = t.aggregates || {}, this.groups = [].concat(t.groups || []), this.hasGroups = this.groups.length > 0, this.hierarchy = t.hierarchy, this.hasGroupHeaderColumn = this.columns.some(function(n) {
    return n.groupHeaderColumnTemplate;
  }), this.collapsible = this.options.collapsible;
};
ne.prototype.workbook = function() {
  var t = {
    sheets: [{
      columns: this._columns(),
      rows: this.hierarchy ? this._hierarchyRows() : this._rows(),
      freezePane: this._freezePane(),
      filter: this._filter()
    }]
  };
  return t;
};
ne.prototype._trimColumns = function(t) {
  var n = this;
  return t.filter(function(r) {
    var o = !!r.field;
    return !o && r.columns && (o = n._trimColumns(r.columns).length > 0), o;
  });
};
ne.prototype._leafColumns = function(t) {
  for (var n = this, r = [], o = 0; o < t.length; o++)
    t[o].columns ? r = r.concat(n._leafColumns(t[o].columns)) : r.push(t[o]);
  return r;
};
ne.prototype._prepareColumn = function(t) {
  if (!t.field)
    return null;
  var n = function(o) {
    return Ei(t.field)(o);
  }, r = null;
  return t.values && (r = {}, t.values.forEach(function(o) {
    r[o.value] = o.text;
  }), n = function(o) {
    return r[Ei(t.field)(o)];
  }), Object.assign({}, t, {
    value: n,
    values: r,
    groupHeaderTemplate: t.groupHeaderTemplate ? Sr.compile(t.groupHeaderTemplate) : Bf,
    groupHeaderColumnTemplate: t.groupHeaderColumnTemplate ? Sr.compile(t.groupHeaderColumnTemplate) : null,
    groupFooterTemplate: t.groupFooterTemplate ? Sr.compile(t.groupFooterTemplate) : null,
    footerTemplate: t.footerTemplate ? Sr.compile(t.footerTemplate) : null
  });
};
ne.prototype._filter = function() {
  if (!this.options.filterable)
    return null;
  var t = this._depth();
  return {
    from: t,
    to: t + this.columns.length - 1
  };
};
ne.prototype._createPaddingCells = function(t) {
  var n = this;
  return To(t, function() {
    return Object.assign({
      background: "#dfdfdf",
      color: "#333"
    }, n.options.paddingCellOptions);
  });
};
ne.prototype._dataRow = function(t, n, r) {
  var o = this, i = this._createPaddingCells(n);
  if (this.hasGroups && r && t.items) {
    i = i.concat(this._groupHeaderCells(t, n, r));
    var a = this._dataRows(t.items, n + 1);
    return a.unshift({
      type: "group-header",
      cells: i,
      level: this.collapsible ? n : null
    }), a.concat(this._footer(t, n));
  }
  for (var s = [], u = 0; u < this.columns.length; u++)
    s[u] = o._cell(t, o.columns[u]);
  return this.hierarchy && (s[0].colSpan = r - n + 1), [{
    type: "data",
    cells: i.concat(s),
    level: this.collapsible ? n : null
  }];
};
ne.prototype._groupHeaderCells = function(t, n, r) {
  var o = [], i = this.allColumns.filter(function(f) {
    return f.field === t.field;
  })[0] || {}, a = i && i.title ? i.title : t.field, s = i ? i.groupHeaderTemplate || i.groupHeaderColumnTemplate : null, u = Object.assign({
    title: a,
    field: t.field,
    value: i && i.values ? i.values[t.value] : t.value,
    aggregates: t.aggregates,
    items: t.items
  }, t.aggregates[t.field]), c = s ? s(u) : a + ": " + t.value;
  return o.push(Object.assign({
    value: c,
    background: "#dfdfdf",
    color: "#333",
    colSpan: (this.hasGroupHeaderColumn ? 1 : this.columns.length) + r - n
  }, i.groupHeaderCellOptions)), this.hasGroupHeaderColumn && this.columns.forEach(function(f, d) {
    d > 0 && o.push(Object.assign({
      background: "#dfdfdf",
      color: "#333",
      value: f.groupHeaderColumnTemplate ? f.groupHeaderColumnTemplate(Object.assign({ group: u }, u, t.aggregates[f.field])) : void 0
    }, f.groupHeaderCellOptions));
  }), o;
};
ne.prototype._dataRows = function(t, n) {
  for (var r = this, o = this._depth(), i = [], a = 0; a < t.length; a++)
    i.push.apply(i, r._dataRow(t[a], n, o));
  return i;
};
ne.prototype._hierarchyRows = function() {
  var t = this, n = this._depth(), r = this.data, o = this.hierarchy.itemLevel, i = this.hierarchy.itemId || Gf, a = this._hasFooterTemplate(), s = [], u = [], c = 0, f;
  a || (this.collapsible = !1);
  for (var d = 0; d < r.length; d++) {
    var h = r[d], m = o(h, d);
    a && (m > c ? u.push({ id: f, level: c }) : m < c && s.push.apply(s, t._hierarchyFooterRows(u, m, n)), c = m, f = i(h, d)), s.push.apply(s, t._dataRow(h, m + 1, n));
  }
  if (a) {
    s.push.apply(s, this._hierarchyFooterRows(u, 0, n));
    var g = r.length ? this.aggregates[r[0].parentId] : {};
    s.push(this._hierarchyFooter(g, 0, n));
  }
  return this._prependHeaderRows(s), s;
};
ne.prototype._hierarchyFooterRows = function(t, n, r) {
  for (var o = this, i = []; t.length && t[t.length - 1].level >= n; ) {
    var a = t.pop();
    i.push(o._hierarchyFooter(o.aggregates[a.id], a.level + 1, r));
  }
  return i;
};
ne.prototype._hasFooterTemplate = function() {
  for (var t = this.columns, n = 0; n < t.length; n++)
    if (t[n].footerTemplate)
      return !0;
};
ne.prototype._hierarchyFooter = function(t, n, r) {
  var o = this.columns.map(function(i, a) {
    var s = a ? 1 : r - n + 1;
    if (i.footerTemplate) {
      var u = (t || {})[i.field];
      return Object.assign({
        background: "#dfdfdf",
        color: "#333",
        colSpan: s,
        value: i.footerTemplate(Object.assign({ aggregates: t }, u))
      }, i.footerCellOptions);
    }
    return Object.assign({
      background: "#dfdfdf",
      color: "#333",
      colSpan: s
    }, i.footerCellOptions);
  });
  return {
    type: "footer",
    cells: this._createPaddingCells(n).concat(o),
    level: this.collapsible ? n : null
  };
};
ne.prototype._footer = function(t, n) {
  var r = [], o = this.columns.some(function(u) {
    return u.groupFooterTemplate;
  }), i, a;
  o && (a = {
    group: {
      items: t.items,
      field: t.field,
      value: t.value
    }
  }, i = {}, Object.keys(t.aggregates).forEach(function(u) {
    i[u] = Object.assign({}, t.aggregates[u], a);
  }));
  var s = this.columns.map(function(u) {
    if (u.groupFooterTemplate) {
      var c = Object.assign({}, i, t.aggregates[u.field], a);
      return Object.assign({
        background: "#dfdfdf",
        color: "#333",
        value: u.groupFooterTemplate(c)
      }, u.groupFooterCellOptions);
    }
    return Object.assign({
      background: "#dfdfdf",
      color: "#333"
    }, u.groupFooterCellOptions);
  });
  return o && r.push({
    type: "group-footer",
    cells: this._createPaddingCells(this.groups.length).concat(s),
    level: this.collapsible ? n : null
  }), r;
};
ne.prototype._isColumnVisible = function(t) {
  return this._visibleColumns([t]).length > 0 && (t.field || t.columns);
};
ne.prototype._visibleColumns = function(t) {
  var n = this;
  return t.filter(function(r) {
    var o = r.exportable;
    typeof o == "object" && (o = r.exportable.excel);
    var i = !r.hidden && o !== !1, a = r.hidden && o === !0, s = i || a;
    return s && r.columns && (s = n._visibleColumns(r.columns).length > 0), s;
  });
};
ne.prototype._headerRow = function(t, n) {
  var r = this, o = t.cells.map(function(i) {
    return Object.assign(i, {
      colSpan: i.colSpan > 1 ? i.colSpan : 1,
      rowSpan: t.rowSpan > 1 && !i.colSpan ? t.rowSpan : 1
    });
  });
  return this.hierarchy && o[0].firstCell && (o[0].colSpan += this._depth()), {
    type: "header",
    cells: To(n.length, function() {
      return Object.assign({
        background: "#7a7a7a",
        color: "#fff"
      }, r.options.headerPaddingCellOptions);
    }).concat(o)
  };
};
ne.prototype._prependHeaderRows = function(t) {
  var n = this, r = this.groups, o = [{ rowSpan: 1, cells: [], index: 0 }];
  this._prepareHeaderRows(o, this.options.columns);
  for (var i = o.length - 1; i >= 0; i--)
    t.unshift(n._headerRow(o[i], r));
};
ne.prototype._prepareHeaderRows = function(t, n, r, o) {
  for (var i = this, a = o || t[t.length - 1], s = t[a.index + 1], u = 0, c = 0; c < n.length; c++) {
    var f = n[c];
    if (i._isColumnVisible(f)) {
      var d = Object.assign({
        background: "#7a7a7a",
        color: "#fff",
        value: f.title || f.field,
        colSpan: 0,
        firstCell: c === 0 && (!r || r.firstCell)
      }, f.headerCellOptions);
      a.cells.push(d), f.columns && f.columns.length && (s || (s = { rowSpan: 0, cells: [], index: t.length }, t.push(s)), d.colSpan = i._trimColumns(i._visibleColumns(f.columns)).length, i._prepareHeaderRows(t, f.columns, d, s), u += d.colSpan - 1, a.rowSpan = t.length - a.index);
    }
  }
  r && (r.colSpan += u);
};
ne.prototype._rows = function() {
  var t = this, n = this._dataRows(this.data, 0);
  if (this.columns.length) {
    this._prependHeaderRows(n);
    var r = !1, o = this.columns.map(function(i) {
      return i.footerTemplate ? (r = !0, Object.assign({
        background: "#dfdfdf",
        color: "#333",
        value: i.footerTemplate(Object.assign({}, t.aggregates, t.aggregates[i.field]))
      }, i.footerCellOptions)) : Object.assign({
        background: "#dfdfdf",
        color: "#333"
      }, i.footerCellOptions);
    });
    r && n.push({
      type: "footer",
      cells: this._createPaddingCells(this.groups.length).concat(o)
    });
  }
  return n;
};
ne.prototype._headerDepth = function(t) {
  for (var n = this, r = 1, o = 0, i = 0; i < t.length; i++)
    if (t[i].columns) {
      var a = n._headerDepth(t[i].columns);
      a > o && (o = a);
    }
  return r + o;
};
ne.prototype._freezePane = function() {
  var t = this._visibleColumns(this.options.columns || []), n = this._visibleColumns(this._trimColumns(this._leafColumns(t.filter(function(r) {
    return r.locked;
  })))).length;
  return {
    rowSplit: this._headerDepth(t),
    colSplit: n ? n + this.groups.length : 0
  };
};
ne.prototype._cell = function(t, n) {
  return Object.assign({
    value: n.value(t)
  }, n.cellOptions);
};
ne.prototype._depth = function() {
  var t = 0;
  return this.hierarchy ? t = this.hierarchy.depth : t = this.groups.length, t;
};
ne.prototype._columns = function() {
  var t = this._depth(), n = To(t, function() {
    return { width: 20 };
  });
  return n.concat(this.columns.map(function(r) {
    return {
      width: parseInt(r.width, 10),
      autoWidth: !r.width
    };
  }));
};
const Uf = ne;
var el = {
  toString: function(e) {
    return e;
  }
}, Ro = function() {
};
Ro.register = function(t) {
  el = t;
};
Ro.toString = function(t, n) {
  return el.toString(t, n);
};
const Kf = Ro;
var Je = {
  Promise
}, me = {
  base64: !0,
  array: !0,
  string: !0,
  nodebuffer: !1,
  nodestream: !1,
  get arraybuffer() {
    return typeof ArrayBuffer < "u" && typeof Uint8Array < "u";
  },
  // Returns true if JSZip can read/generate Uint8Array, false otherwise.
  get uint8array() {
    return typeof Uint8Array < "u";
  },
  get blob() {
    return tl();
  }
}, tl = function() {
  var e;
  if (typeof ArrayBuffer > "u")
    e = !1;
  else {
    var t = new ArrayBuffer(0);
    try {
      e = new Blob([t], {
        type: "application/zip"
      }).size === 0;
    } catch {
      e = !1;
    }
  }
  return tl = function() {
    return e;
  }, e;
}, Qe = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", Wf = function(e) {
  for (var t = [], n, r, o, i, a, s, u, c = 0, f = e.length, d = f, h = typeof e != "string"; c < e.length; )
    d = f - c, h ? (n = e[c++], r = c < f ? e[c++] : 0, o = c < f ? e[c++] : 0) : (n = e.charCodeAt(c++), r = c < f ? e.charCodeAt(c++) : 0, o = c < f ? e.charCodeAt(c++) : 0), i = n >> 2, a = (n & 3) << 4 | r >> 4, s = d > 1 ? (r & 15) << 2 | o >> 6 : 64, u = d > 2 ? o & 63 : 64, t.push(Qe.charAt(i) + Qe.charAt(a) + Qe.charAt(s) + Qe.charAt(u));
  return t.join("");
}, Vf = function(e) {
  var t, n, r, o, i, a, s, u = 0, c = 0, f = "data:";
  if (e.substr(0, f.length) === f)
    throw new Error("Invalid base64 input, it looks like a data url.");
  e = e.replace(/[^A-Za-z0-9\+\/\=]/g, "");
  var d = e.length * 3 / 4;
  if (e.charAt(e.length - 1) === Qe.charAt(64) && d--, e.charAt(e.length - 2) === Qe.charAt(64) && d--, d % 1 !== 0)
    throw new Error("Invalid base64 input, bad content length.");
  var h;
  for (me.uint8array ? h = new Uint8Array(d | 0) : h = new Array(d | 0); u < e.length; )
    o = Qe.indexOf(e.charAt(u++)), i = Qe.indexOf(e.charAt(u++)), a = Qe.indexOf(e.charAt(u++)), s = Qe.indexOf(e.charAt(u++)), t = o << 2 | i >> 4, n = (i & 15) << 4 | a >> 2, r = (a & 3) << 6 | s, h[c++] = t, a !== 64 && (h[c++] = n), s !== 64 && (h[c++] = r);
  return h;
};
function qf(e) {
  var t = null;
  return me.uint8array ? t = new Uint8Array(e.length) : t = new Array(e.length), ao(e, t);
}
var $f = function(e, t) {
  return br("blob"), new Blob([e], {
    type: t
  });
};
function Pr(e) {
  return e;
}
function ao(e, t) {
  for (var n = 0; n < e.length; ++n)
    t[n] = e.charCodeAt(n) & 255;
  return t;
}
function Xf(e, t, n) {
  var r = [], o = 0, i = e.length;
  if (i <= n)
    return String.fromCharCode.apply(null, e);
  for (; o < i; )
    t === "array" ? r.push(String.fromCharCode.apply(null, e.slice(o, Math.min(o + n, i)))) : r.push(String.fromCharCode.apply(null, e.subarray(o, Math.min(o + n, i)))), o += n;
  return r.join("");
}
function Yf(e) {
  for (var t = "", n = 0; n < e.length; n++)
    t += String.fromCharCode(e[n]);
  return t;
}
var rl = function() {
  var e;
  try {
    e = me.uint8array && String.fromCharCode.apply(null, new Uint8Array(1)).length === 1;
  } catch {
    e = !1;
  }
  return rl = function() {
    return e;
  }, e;
};
function Ar(e) {
  var t = 65536, n = Lt(e), r = !0;
  if (n === "uint8array" && (r = rl()), r)
    for (; t > 1; )
      try {
        return Xf(e, n, t);
      } catch {
        t = Math.floor(t / 2);
      }
  return Yf(e);
}
var Zf = Ar;
function Ii(e, t) {
  for (var n = 0; n < e.length; n++)
    t[n] = e[n];
  return t;
}
var nl = {
  // string to ?
  string: {
    string: Pr,
    array: function(e) {
      return ao(e, new Array(e.length));
    },
    arraybuffer: function(e) {
      return nl.string.uint8array(e).buffer;
    },
    uint8array: function(e) {
      return ao(e, new Uint8Array(e.length));
    }
  },
  // array to ?
  array: {
    string: Ar,
    array: Pr,
    arraybuffer: function(e) {
      return new Uint8Array(e).buffer;
    },
    uint8array: function(e) {
      return new Uint8Array(e);
    }
  },
  // arraybuffer to ?
  arraybuffer: {
    string: function(e) {
      return Ar(new Uint8Array(e));
    },
    array: function(e) {
      return Ii(new Uint8Array(e), new Array(e.byteLength));
    },
    arraybuffer: Pr,
    uint8array: function(e) {
      return new Uint8Array(e);
    }
  },
  // uint8array to ?
  uint8array: {
    string: Ar,
    array: function(e) {
      return Ii(e, new Array(e.length));
    },
    arraybuffer: function(e) {
      return e.buffer;
    },
    uint8array: Pr
  }
}, he = function(e, t) {
  if (t || (t = ""), !e)
    return t;
  br(e);
  var n = Lt(t), r = nl[n][e](t);
  return r;
}, Lt = function(e) {
  if (typeof e == "string")
    return "string";
  if (Object.prototype.toString.call(e) === "[object Array]")
    return "array";
  if (me.uint8array && e instanceof Uint8Array)
    return "uint8array";
  if (me.arraybuffer && e instanceof ArrayBuffer)
    return "arraybuffer";
}, br = function(e) {
  var t = me[e.toLowerCase()];
  if (!t)
    throw new Error(e + " is not supported by this platform");
}, Tr = 65535, qt = -1, lo = function(e) {
  var t = "", n, r;
  for (r = 0; r < (e || "").length; r++)
    n = e.charCodeAt(r), t += "\\x" + (n < 16 ? "0" : "") + n.toString(16).toUpperCase();
  return t;
}, Yr = function(e, t, n) {
  setTimeout(function() {
    e.apply(n || null, t || []);
  }, 0);
}, Do = function() {
  var e = arguments, t = {}, n, r;
  for (n = 0; n < arguments.length; n++)
    for (r in arguments[n])
      Object.hasOwnProperty.call(e[n], r) && typeof t[r] > "u" && (t[r] = e[n][r]);
  return t;
}, ol = function(e, t, n, r, o) {
  var i = Je.Promise.resolve(t).then(function(a) {
    var s = me.blob && (a instanceof Blob || ["[object File]", "[object Blob]"].indexOf(Object.prototype.toString.call(a)) !== -1);
    return s && typeof FileReader < "u" ? new Je.Promise(function(u, c) {
      var f = new FileReader();
      f.onload = function(d) {
        u(d.target.result);
      }, f.onerror = function(d) {
        c(d.target.error);
      }, f.readAsArrayBuffer(a);
    }) : a;
  });
  return i.then(function(a) {
    var s = Lt(a);
    return s ? (s === "arraybuffer" ? a = he("uint8array", a) : s === "string" && (o ? a = Vf(a) : n && r !== !0 && (a = qf(a))), a) : Je.Promise.reject(
      new Error("Can't read the data of '" + e + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?")
    );
  });
}, V = function(t) {
  this.name = t || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
    data: [],
    end: [],
    error: []
  }, this.previous = null;
};
V.prototype.push = function(t) {
  this.emit("data", t);
};
V.prototype.end = function() {
  if (this.isFinished)
    return !1;
  this.flush();
  try {
    this.emit("end"), this.cleanUp(), this.isFinished = !0;
  } catch (t) {
    this.emit("error", t);
  }
  return !0;
};
V.prototype.error = function(t) {
  return this.isFinished ? !1 : (this.isPaused ? this.generatedError = t : (this.isFinished = !0, this.emit("error", t), this.previous && this.previous.error(t), this.cleanUp()), !0);
};
V.prototype.on = function(t, n) {
  return this._listeners[t].push(n), this;
};
V.prototype.cleanUp = function() {
  this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
};
V.prototype.emit = function(t, n) {
  if (this._listeners[t])
    for (var r = 0; r < this._listeners[t].length; r++)
      this._listeners[t][r].call(this, n);
};
V.prototype.pipe = function(t) {
  return t.registerPrevious(this);
};
V.prototype.registerPrevious = function(t) {
  if (this.isLocked)
    throw new Error("The stream '" + this + "' has already been used.");
  this.streamInfo = t.streamInfo, this.mergeStreamInfo(), this.previous = t;
  var n = this;
  return t.on("data", function(r) {
    n.processChunk(r);
  }), t.on("end", function() {
    n.end();
  }), t.on("error", function(r) {
    n.error(r);
  }), this;
};
V.prototype.pause = function() {
  return this.isPaused || this.isFinished ? !1 : (this.isPaused = !0, this.previous && this.previous.pause(), !0);
};
V.prototype.resume = function() {
  if (!this.isPaused || this.isFinished)
    return !1;
  this.isPaused = !1;
  var t = !1;
  return this.generatedError && (this.error(this.generatedError), t = !0), this.previous && this.previous.resume(), !t;
};
V.prototype.flush = function() {
};
V.prototype.processChunk = function(t) {
  this.push(t);
};
V.prototype.withStreamInfo = function(t, n) {
  return this.extraStreamInfo[t] = n, this.mergeStreamInfo(), this;
};
V.prototype.mergeStreamInfo = function() {
  for (var t in this.extraStreamInfo)
    this.extraStreamInfo.hasOwnProperty(t) && (this.streamInfo[t] = this.extraStreamInfo[t]);
};
V.prototype.lock = function() {
  if (this.isLocked)
    throw new Error("The stream '" + this + "' has already been used.");
  this.isLocked = !0, this.previous && this.previous.lock();
};
V.prototype.toString = function() {
  var t = "Worker " + this.name;
  return this.previous ? this.previous + " -> " + t : t;
};
var Ao = function(e) {
  for (var t = new Array(256), n = 0; n < 256; n++)
    t[n] = n >= 252 ? 6 : n >= 248 ? 5 : n >= 240 ? 4 : n >= 224 ? 3 : n >= 192 ? 2 : 1;
  return t[254] = t[254] = 1, Ao = function(r) {
    return t[r];
  }, t[e];
}, Qf = function(e) {
  var t, n, r, o, i, a = e.length, s = 0;
  for (o = 0; o < a; o++)
    n = e.charCodeAt(o), (n & 64512) === 55296 && o + 1 < a && (r = e.charCodeAt(o + 1), (r & 64512) === 56320 && (n = 65536 + (n - 55296 << 10) + (r - 56320), o++)), s += n < 128 ? 1 : n < 2048 ? 2 : n < 65536 ? 3 : 4;
  for (me.uint8array ? t = new Uint8Array(s) : t = new Array(s), i = 0, o = 0; i < s; o++)
    n = e.charCodeAt(o), (n & 64512) === 55296 && o + 1 < a && (r = e.charCodeAt(o + 1), (r & 64512) === 56320 && (n = 65536 + (n - 55296 << 10) + (r - 56320), o++)), n < 128 ? t[i++] = n : n < 2048 ? (t[i++] = 192 | n >>> 6, t[i++] = 128 | n & 63) : n < 65536 ? (t[i++] = 224 | n >>> 12, t[i++] = 128 | n >>> 6 & 63, t[i++] = 128 | n & 63) : (t[i++] = 240 | n >>> 18, t[i++] = 128 | n >>> 12 & 63, t[i++] = 128 | n >>> 6 & 63, t[i++] = 128 | n & 63);
  return t;
}, Jf = function(e, t) {
  var n;
  for (t = t || e.length, t > e.length && (t = e.length), n = t - 1; n >= 0 && (e[n] & 192) === 128; )
    n--;
  return n < 0 || n === 0 ? t : n + Ao(e[n]) > t ? n : t;
}, ed = function(e) {
  var t, n, r, o, i = e.length, a = new Array(i * 2);
  for (n = 0, t = 0; t < i; ) {
    if (r = e[t++], r < 128) {
      a[n++] = r;
      continue;
    }
    if (o = Ao(r), o > 4) {
      a[n++] = 65533, t += o - 1;
      continue;
    }
    for (r &= o === 2 ? 31 : o === 3 ? 15 : 7; o > 1 && t < i; )
      r = r << 6 | e[t++] & 63, o--;
    if (o > 1) {
      a[n++] = 65533;
      continue;
    }
    r < 65536 ? a[n++] = r : (r -= 65536, a[n++] = 55296 | r >> 10 & 1023, a[n++] = 56320 | r & 1023);
  }
  return a.length !== n && (a.subarray ? a = a.subarray(0, n) : a.length = n), Zf(a);
}, hr = function(t) {
  return Qf(t);
}, Ft = function(t) {
  return t = he(me.uint8array ? "uint8array" : "array", t), ed(t);
}, td = /* @__PURE__ */ function(e) {
  function t() {
    e.call(this, "utf-8 decode"), this.leftOver = null;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.processChunk = function(r) {
    var o = he(me.uint8array ? "uint8array" : "array", r.data);
    if (this.leftOver && this.leftOver.length) {
      if (me.uint8array) {
        var i = o;
        o = new Uint8Array(i.length + this.leftOver.length), o.set(this.leftOver, 0), o.set(i, this.leftOver.length);
      } else
        o = this.leftOver.concat(o);
      this.leftOver = null;
    }
    var a = Jf(o), s = o;
    a !== o.length && (me.uint8array ? (s = o.subarray(0, a), this.leftOver = o.subarray(a, o.length)) : (s = o.slice(0, a), this.leftOver = o.slice(a, o.length))), this.push({
      data: Ft(s),
      meta: r.meta
    });
  }, t.prototype.flush = function() {
    this.leftOver && this.leftOver.length && (this.push({
      data: Ft(this.leftOver),
      meta: {}
    }), this.leftOver = null);
  }, t;
}(V), il = /* @__PURE__ */ function(e) {
  function t() {
    e.call(this, "utf-8 encode");
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.processChunk = function(r) {
    this.push({
      data: hr(r.data),
      meta: r.meta
    });
  }, t;
}(V), rd = /* @__PURE__ */ function(e) {
  function t(n) {
    e.call(this, "ConvertWorker to " + n), this.destType = n;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.processChunk = function(r) {
    this.push({
      data: he(this.destType, r.data),
      meta: r.meta
    });
  }, t;
}(V);
function nd(e, t, n) {
  switch (e) {
    case "blob":
      return $f(he("arraybuffer", t), n);
    case "base64":
      return Wf(t);
    default:
      return he(e, t);
  }
}
function od(e, t) {
  var n, r = 0, o = null, i = 0;
  for (n = 0; n < t.length; n++)
    i += t[n].length;
  switch (e) {
    case "string":
      return t.join("");
    case "array":
      return Array.prototype.concat.apply([], t);
    case "uint8array":
      for (o = new Uint8Array(i), n = 0; n < t.length; n++)
        o.set(t[n], r), r += t[n].length;
      return o;
    default:
      throw new Error("concat : unsupported type '" + e + "'");
  }
}
function id(e, t) {
  return new Je.Promise(function(n, r) {
    var o = [], i = e._internalType, a = e._outputType, s = e._mimeType;
    e.on("data", function(u, c) {
      o.push(u), t && t(c);
    }).on("error", function(u) {
      o = [], r(u);
    }).on("end", function() {
      try {
        var u = nd(a, od(i, o), s);
        n(u);
      } catch (c) {
        r(c);
      }
      o = [];
    }).resume();
  });
}
var Zt = function(t, n, r) {
  var o = n;
  switch (n) {
    case "blob":
    case "arraybuffer":
      o = "uint8array";
      break;
    case "base64":
      o = "string";
      break;
  }
  try {
    this._internalType = o, this._outputType = n, this._mimeType = r, br(o), this._worker = t.pipe(new rd(o)), t.lock();
  } catch (i) {
    this._worker = new V("error"), this._worker.error(i);
  }
};
Zt.prototype.accumulate = function(t) {
  return id(this, t);
};
Zt.prototype.on = function(t, n) {
  var r = this;
  return t === "data" ? this._worker.on(t, function(o) {
    n.call(r, o.data, o.meta);
  }) : this._worker.on(t, function() {
    Yr(n, arguments, r);
  }), this;
};
Zt.prototype.resume = function() {
  return Yr(this._worker.resume, [], this._worker), this;
};
Zt.prototype.pause = function() {
  return this._worker.pause(), this;
};
var ad = !1, ld = !1, sd = !1, al = !0, ud = null, cd = null, fd = null, dd = null, hd = null, pd = null, ll = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  base64: ad,
  binary: ld,
  dir: sd,
  createFolders: al,
  date: ud,
  compression: cd,
  compressionOptions: fd,
  comment: dd,
  unixPermissions: hd,
  dosPermissions: pd
}), gd = 16 * 1024, Mo = /* @__PURE__ */ function(e) {
  function t(n) {
    e.call(this, "DataWorker");
    var r = this;
    this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, n.then(function(o) {
      r.dataIsReady = !0, r.data = o, r.max = o && o.length || 0, r.type = Lt(o), r.isPaused || r._tickAndRepeat();
    }, function(o) {
      r.error(o);
    });
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.cleanUp = function() {
    e.prototype.cleanUp.call(this), this.data = null;
  }, t.prototype.resume = function() {
    return e.prototype.resume.call(this) ? (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, Yr(this._tickAndRepeat, [], this)), !0) : !1;
  }, t.prototype._tickAndRepeat = function() {
    this._tickScheduled = !1, !(this.isPaused || this.isFinished) && (this._tick(), this.isFinished || (Yr(this._tickAndRepeat, [], this), this._tickScheduled = !0));
  }, t.prototype._tick = function() {
    if (this.isPaused || this.isFinished)
      return !1;
    var r = gd, o = null, i = Math.min(this.max, this.index + r);
    if (this.index >= this.max)
      return this.end();
    switch (this.type) {
      case "string":
        o = this.data.substring(this.index, i);
        break;
      case "uint8array":
        o = this.data.subarray(this.index, i);
        break;
      case "array":
        o = this.data.slice(this.index, i);
        break;
    }
    return this.index = i, this.push({
      data: o,
      meta: {
        percent: this.max ? this.index / this.max * 100 : 0
      }
    });
  }, t;
}(V), so = /* @__PURE__ */ function(e) {
  function t(n) {
    e.call(this, "DataLengthProbe for " + n), this.propName = n, this.withStreamInfo(n, 0);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.processChunk = function(r) {
    if (r) {
      var o = this.streamInfo[this.propName] || 0;
      this.streamInfo[this.propName] = o + r.data.length;
    }
    e.prototype.processChunk.call(this, r);
  }, t;
}(V), Fo = function() {
  for (var e = [], t = 0; t < 256; t++) {
    for (var n = t, r = 0; r < 8; r++)
      n = n & 1 ? 3988292384 ^ n >>> 1 : n >>> 1;
    e[t] = n;
  }
  return Fo = function() {
    return e;
  }, e;
};
function vd(e, t, n, r) {
  var o = Fo(), i = r + n;
  e = e ^ -1;
  for (var a = r; a < i; a++)
    e = e >>> 8 ^ o[(e ^ t[a]) & 255];
  return e ^ -1;
}
function md(e, t, n, r) {
  var o = Fo(), i = r + n;
  e = e ^ -1;
  for (var a = r; a < i; a++)
    e = e >>> 8 ^ o[(e ^ t.charCodeAt(a)) & 255];
  return e ^ -1;
}
function yr(e, t) {
  if (typeof e > "u" || !e.length)
    return 0;
  var n = Lt(e) !== "string";
  return n ? vd(t | 0, e, e.length, 0) : md(t | 0, e, e.length, 0);
}
var sl = /* @__PURE__ */ function(e) {
  function t() {
    e.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.processChunk = function(r) {
    this.streamInfo.crc32 = yr(r.data, this.streamInfo.crc32 || 0), this.push(r);
  }, t;
}(V), it = function(t, n, r, o, i) {
  this.compressedSize = t, this.uncompressedSize = n, this.crc32 = r, this.compression = o, this.compressedContent = i;
};
it.prototype.getContentWorker = function() {
  var t = new Mo(Je.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new so("data_length")), n = this;
  return t.on("end", function() {
    if (this.streamInfo.data_length !== n.uncompressedSize)
      throw new Error("Bug : uncompressed data size mismatch");
  }), t;
};
it.prototype.getCompressedWorker = function() {
  return new Mo(Je.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
};
it.createWorkerFrom = function(t, n, r) {
  return t.pipe(new sl()).pipe(new so("uncompressedSize")).pipe(n.compressWorker(r)).pipe(new so("compressedSize")).withStreamInfo("compression", n);
};
var xr = function(t, n, r) {
  this.name = t, this.dir = r.dir, this.date = r.date, this.comment = r.comment, this.unixPermissions = r.unixPermissions, this.dosPermissions = r.dosPermissions, this._data = n, this._dataBinary = r.binary, this.options = {
    compression: r.compression,
    compressionOptions: r.compressionOptions
  };
};
xr.prototype.internalStream = function(t) {
  var n = null, r = "string";
  try {
    if (!t)
      throw new Error("No output type specified.");
    r = t.toLowerCase();
    var o = r === "string" || r === "text";
    (r === "binarystring" || r === "text") && (r = "string"), n = this._decompressWorker();
    var i = !this._dataBinary;
    i && !o && (n = n.pipe(new il())), !i && o && (n = n.pipe(new td()));
  } catch (a) {
    n = new V("error"), n.error(a);
  }
  return new Zt(n, r, "");
};
xr.prototype.async = function(t, n) {
  return this.internalStream(t).accumulate(n);
};
xr.prototype._compressWorker = function(t, n) {
  if (this._data instanceof it && this._data.compression.magic === t.magic)
    return this._data.getCompressedWorker();
  var r = this._decompressWorker();
  return this._dataBinary || (r = r.pipe(new il())), it.createWorkerFrom(r, t, n);
};
xr.prototype._decompressWorker = function() {
  return this._data instanceof it ? this._data.getContentWorker() : this._data instanceof V ? this._data : new Mo(this._data);
};
var ul = function() {
  var e = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Uint32Array < "u", t = e ? "uint8array" : "array";
  ul = function() {
    return t;
  };
}, ki = /* @__PURE__ */ function(e) {
  function t(n, r) {
    e.call(this, "FlateWorker/" + n), this._pako = null, this._pakoAction = n, this._pakoOptions = r, this.meta = {};
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.processChunk = function(r) {
    this.meta = r.meta, this._pako === null && this._createPako(), this._pako.push(he(ul(), r.data), !1);
  }, t.prototype.flush = function() {
    e.prototype.flush.call(this), this._pako === null && this._createPako(), this._pako.push([], !0);
  }, t.prototype.cleanUp = function() {
    e.prototype.cleanUp.call(this), this._pako = null;
  }, t.prototype._createPako = function() {
    var r = this, o = {
      raw: !0,
      level: this._pakoOptions.level || -1
      // default compression
    };
    this._pako = this._pakoAction === "Deflate" ? new Ol(o) : new Sl(o), this._pako.onData = function(i) {
      r.push({
        data: i,
        meta: r.meta
      });
    };
  }, t;
}(V), yd = {
  magic: "\b\0",
  compressWorker: function(e) {
    return new ki("Deflate", e);
  },
  uncompressWorker: function() {
    return new ki("Inflate", {});
  }
}, Cd = {
  magic: "\0\0",
  compressWorker: function() {
    return new V("STORE compression");
  },
  uncompressWorker: function() {
    return new V("STORE decompression");
  }
}, ar = {
  STORE: Cd,
  DEFLATE: yd
}, No = "PK", Lo = "PK", uo = "PK", Oi = "PK\x07", mn = "PK", bd = "PK\x07\b", te = function(e, t) {
  var n = "", r;
  for (r = 0; r < t; r++)
    n += String.fromCharCode(e & 255), e = e >>> 8;
  return n;
}, xd = function(e, t) {
  var n = e;
  return e || (n = t ? 16893 : 33204), (n & 65535) << 16;
}, wd = function(e, t) {
  return (e || 0) & 63;
}, Si = function(e, t, n, r, o, i) {
  var a = e.file, s = e.compression, u = i !== hr, c = he("string", i(a.name)), f = he("string", hr(a.name)), d = a.comment, h = he("string", i(d)), m = he("string", hr(d)), g = f.length !== a.name.length, y = m.length !== d.length, w, x, b = "", C = "", S = "", T = a.dir, _ = a.date, k = {
    crc32: 0,
    compressedSize: 0,
    uncompressedSize: 0
  };
  (!t || n) && (k.crc32 = e.crc32, k.compressedSize = e.compressedSize, k.uncompressedSize = e.uncompressedSize);
  var H = 0;
  t && (H |= 8), !u && (g || y) && (H |= 2048);
  var L = 0, B = 0;
  T && (L |= 16), o === "UNIX" ? (B = 798, L |= xd(a.unixPermissions, T)) : (B = 20, L |= wd(a.dosPermissions)), w = _.getUTCHours(), w = w << 6, w = w | _.getUTCMinutes(), w = w << 5, w = w | _.getUTCSeconds() / 2, x = _.getUTCFullYear() - 1980, x = x << 4, x = x | _.getUTCMonth() + 1, x = x << 5, x = x | _.getUTCDate(), g && (C = // Version
  te(1, 1) + // NameCRC32
  te(yr(c), 4) + // UnicodeName
  f, b += // Info-ZIP Unicode Path Extra Field
  "up" + // size
  te(C.length, 2) + // content
  C), y && (S = // Version
  te(1, 1) + // CommentCRC32
  te(yr(h), 4) + // UnicodeName
  m, b += // Info-ZIP Unicode Path Extra Field
  "uc" + // size
  te(S.length, 2) + // content
  S);
  var F = "";
  F += `
\0`, F += te(H, 2), F += s.magic, F += te(w, 2), F += te(x, 2), F += te(k.crc32, 4), F += te(k.compressedSize, 4), F += te(k.uncompressedSize, 4), F += te(c.length, 2), F += te(b.length, 2);
  var G = No + F + c + b, Z = Lo + // version made by (00: DOS)
  te(B, 2) + // file header (common to file and central directory)
  F + // file comment length
  te(h.length, 2) + // disk number start
  "\0\0\0\0" + // external file attributes
  te(L, 4) + // relative offset of local header
  te(r, 4) + // file name
  c + // extra field
  b + // file comment
  h;
  return {
    fileRecord: G,
    dirRecord: Z
  };
}, _d = function(e, t, n, r, o) {
  var i = "", a = he("string", o(r));
  return i = uo + // number of this disk
  "\0\0\0\0" + // total number of entries in the central directory on this disk
  te(e, 2) + // total number of entries in the central directory
  te(e, 2) + // size of the central directory   4 bytes
  te(t, 4) + // offset of start of central directory with respect to the starting disk number
  te(n, 4) + // .ZIP file comment length
  te(a.length, 2) + // .ZIP file comment
  a, i;
}, Ed = function(e) {
  var t = "";
  return t = bd + // crc-32                          4 bytes
  te(e.crc32, 4) + // compressed size                 4 bytes
  te(e.compressedSize, 4) + // uncompressed size               4 bytes
  te(e.uncompressedSize, 4), t;
}, Id = /* @__PURE__ */ function(e) {
  function t(n, r, o, i) {
    e.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = r, this.zipPlatform = o, this.encodeFileName = i, this.streamFiles = n, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.push = function(r) {
    var o = r.meta.percent || 0, i = this.entriesCount, a = this._sources.length;
    this.accumulate ? this.contentBuffer.push(r) : (this.bytesWritten += r.data.length, e.prototype.push.call(this, {
      data: r.data,
      meta: {
        currentFile: this.currentFile,
        percent: i ? (o + 100 * (i - a - 1)) / i : 100
      }
    }));
  }, t.prototype.openedSource = function(r) {
    this.currentSourceOffset = this.bytesWritten, this.currentFile = r.file.name;
    var o = this.streamFiles && !r.file.dir;
    if (o) {
      var i = Si(r, o, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
      this.push({
        data: i.fileRecord,
        meta: { percent: 0 }
      });
    } else
      this.accumulate = !0;
  }, t.prototype.closedSource = function(r) {
    this.accumulate = !1;
    var o = this.streamFiles && !r.file.dir, i = Si(r, o, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
    if (this.dirRecords.push(i.dirRecord), o)
      this.push({
        data: Ed(r),
        meta: { percent: 100 }
      });
    else
      for (this.push({
        data: i.fileRecord,
        meta: { percent: 0 }
      }); this.contentBuffer.length; )
        this.push(this.contentBuffer.shift());
    this.currentFile = null;
  }, t.prototype.flush = function() {
    for (var r = this.bytesWritten, o = 0; o < this.dirRecords.length; o++)
      this.push({
        data: this.dirRecords[o],
        meta: { percent: 100 }
      });
    var i = this.bytesWritten - r, a = _d(this.dirRecords.length, i, r, this.zipComment, this.encodeFileName);
    this.push({
      data: a,
      meta: { percent: 100 }
    });
  }, t.prototype.prepareNextSource = function() {
    this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
  }, t.prototype.registerPrevious = function(r) {
    this._sources.push(r);
    var o = this;
    return r.on("data", function(i) {
      o.processChunk(i);
    }), r.on("end", function() {
      o.closedSource(o.previous.streamInfo), o._sources.length ? o.prepareNextSource() : o.end();
    }), r.on("error", function(i) {
      o.error(i);
    }), this;
  }, t.prototype.resume = function() {
    if (!e.prototype.resume.call(this))
      return !1;
    if (!this.previous && this._sources.length)
      return this.prepareNextSource(), !0;
    if (!this.previous && !this._sources.length && !this.generatedError)
      return this.end(), !0;
  }, t.prototype.error = function(r) {
    var o = this._sources;
    if (!e.prototype.error.call(this, r))
      return !1;
    for (var i = 0; i < o.length; i++)
      try {
        o[i].error(r);
      } catch {
      }
    return !0;
  }, t.prototype.lock = function() {
    e.prototype.lock.call(this);
    for (var r = this._sources, o = 0; o < r.length; o++)
      r[o].lock();
  }, t;
}(V), kd = function(e, t) {
  var n = e || t, r = ar[n];
  if (!r)
    throw new Error(n + " is not a valid compression method !");
  return r;
}, Od = function(e, t, n) {
  var r = new Id(t.streamFiles, n, t.platform, t.encodeFileName), o = 0;
  try {
    e.forEach(function(i, a) {
      o++;
      var s = kd(a.options.compression, t.compression), u = a.options.compressionOptions || t.compressionOptions || {}, c = a.dir, f = a.date;
      a._compressWorker(s, u).withStreamInfo("file", {
        name: i,
        dir: c,
        date: f,
        comment: a.comment || "",
        unixPermissions: a.unixPermissions,
        dosPermissions: a.dosPermissions
      }).pipe(r);
    }), r.entriesCount = o;
  } catch (i) {
    r.error(i);
  }
  return r;
}, Me = function(t) {
  this.data = t, this.length = t.length, this.index = 0, this.zero = 0;
};
Me.prototype.checkOffset = function(t) {
  this.checkIndex(this.index + t);
};
Me.prototype.checkIndex = function(t) {
  if (this.length < this.zero + t || t < 0)
    throw new Error("End of data reached (data length = " + this.length + ", asked index = " + t + "). Corrupted zip ?");
};
Me.prototype.setIndex = function(t) {
  this.checkIndex(t), this.index = t;
};
Me.prototype.skip = function(t) {
  this.setIndex(this.index + t);
};
Me.prototype.byteAt = function(t) {
};
Me.prototype.readInt = function(t) {
  var n = 0, r;
  for (this.checkOffset(t), r = this.index + t - 1; r >= this.index; r--)
    n = (n << 8) + this.byteAt(r);
  return this.index += t, n;
};
Me.prototype.readString = function(t) {
  return he("string", this.readData(t));
};
Me.prototype.readData = function(t) {
};
Me.prototype.lastIndexOfSignature = function(t) {
};
Me.prototype.readAndCheckSignature = function(t) {
};
Me.prototype.readDate = function() {
  var t = this.readInt(4);
  return new Date(Date.UTC(
    (t >> 25 & 127) + 1980,
    // year
    (t >> 21 & 15) - 1,
    // month
    t >> 16 & 31,
    // day
    t >> 11 & 31,
    // hour
    t >> 5 & 63,
    // minute
    (t & 31) << 1
  ));
};
var cl = /* @__PURE__ */ function(e) {
  function t(n) {
    e.call(this, n);
    for (var r = 0; r < this.data.length; r++)
      n[r] = n[r] & 255;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.byteAt = function(r) {
    return this.data[this.zero + r];
  }, t.prototype.lastIndexOfSignature = function(r) {
    for (var o = r.charCodeAt(0), i = r.charCodeAt(1), a = r.charCodeAt(2), s = r.charCodeAt(3), u = this.length - 4; u >= 0; --u)
      if (this.data[u] === o && this.data[u + 1] === i && this.data[u + 2] === a && this.data[u + 3] === s)
        return u - this.zero;
    return -1;
  }, t.prototype.readAndCheckSignature = function(r) {
    var o = r.charCodeAt(0), i = r.charCodeAt(1), a = r.charCodeAt(2), s = r.charCodeAt(3), u = this.readData(4);
    return o === u[0] && i === u[1] && a === u[2] && s === u[3];
  }, t.prototype.readData = function(r) {
    if (this.checkOffset(r), r === 0)
      return [];
    var o = this.data.slice(this.zero + this.index, this.zero + this.index + r);
    return this.index += r, o;
  }, t;
}(Me), Sd = /* @__PURE__ */ function(e) {
  function t(n) {
    e.call(this, n);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.byteAt = function(r) {
    return this.data.charCodeAt(this.zero + r);
  }, t.prototype.lastIndexOfSignature = function(r) {
    return this.data.lastIndexOf(r) - this.zero;
  }, t.prototype.readAndCheckSignature = function(r) {
    var o = this.readData(4);
    return r === o;
  }, t.prototype.readData = function(r) {
    this.checkOffset(r);
    var o = this.data.slice(this.zero + this.index, this.zero + this.index + r);
    return this.index += r, o;
  }, t;
}(Me), Pd = /* @__PURE__ */ function(e) {
  function t(n) {
    e.call(this, n);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.readData = function(r) {
    if (this.checkOffset(r), r === 0)
      return new Uint8Array(0);
    var o = this.data.subarray(this.zero + this.index, this.zero + this.index + r);
    return this.index += r, o;
  }, t;
}(cl);
function an(e) {
  var t = Lt(e);
  return br(t), t === "string" && !me.uint8array ? new Sd(e) : me.uint8array ? new Pd(he("uint8array", e)) : new cl(he("array", e));
}
var Td = 0, Rd = 3, Dd = function(e) {
  for (var t in ar)
    if (ar.hasOwnProperty(t) && ar[t].magic === e)
      return ar[t];
  return null;
}, Ve = function(t, n) {
  this.options = t, this.loadOptions = n;
};
Ve.prototype.isEncrypted = function() {
  return (this.bitFlag & 1) === 1;
};
Ve.prototype.useUTF8 = function() {
  return (this.bitFlag & 2048) === 2048;
};
Ve.prototype.readLocalPart = function(t) {
  var n, r;
  if (t.skip(22), this.fileNameLength = t.readInt(2), r = t.readInt(2), this.fileName = t.readData(this.fileNameLength), t.skip(r), this.compressedSize === -1 || this.uncompressedSize === -1)
    throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
  if (n = Dd(this.compressionMethod), n === null)
    throw new Error("Corrupted zip : compression " + lo(this.compressionMethod) + " unknown (inner file : " + he("string", this.fileName) + ")");
  this.decompressed = new it(this.compressedSize, this.uncompressedSize, this.crc32, n, t.readData(this.compressedSize));
};
Ve.prototype.readCentralPart = function(t) {
  this.versionMadeBy = t.readInt(2), t.skip(2), this.bitFlag = t.readInt(2), this.compressionMethod = t.readString(2), this.date = t.readDate(), this.crc32 = t.readInt(4), this.compressedSize = t.readInt(4), this.uncompressedSize = t.readInt(4);
  var n = t.readInt(2);
  if (this.extraFieldsLength = t.readInt(2), this.fileCommentLength = t.readInt(2), this.diskNumberStart = t.readInt(2), this.internalFileAttributes = t.readInt(2), this.externalFileAttributes = t.readInt(4), this.localHeaderOffset = t.readInt(4), this.isEncrypted())
    throw new Error("Encrypted zip are not supported");
  t.skip(n), this.readExtraFields(t), this.parseZIP64ExtraField(t), this.fileComment = t.readData(this.fileCommentLength);
};
Ve.prototype.processAttributes = function() {
  this.unixPermissions = null, this.dosPermissions = null;
  var t = this.versionMadeBy >> 8;
  this.dir = !!(this.externalFileAttributes & 16), t === Td && (this.dosPermissions = this.externalFileAttributes & 63), t === Rd && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), !this.dir && this.fileNameStr.slice(-1) === "/" && (this.dir = !0);
};
Ve.prototype.parseZIP64ExtraField = function(t) {
  if (this.extraFields[1]) {
    var n = an(this.extraFields[1].value);
    this.uncompressedSize === qt && (this.uncompressedSize = n.readInt(8)), this.compressedSize === qt && (this.compressedSize = n.readInt(8)), this.localHeaderOffset === qt && (this.localHeaderOffset = n.readInt(8)), this.diskNumberStart === qt && (this.diskNumberStart = n.readInt(4));
  }
};
Ve.prototype.readExtraFields = function(t) {
  var n = t.index + this.extraFieldsLength, r, o, i;
  for (this.extraFields || (this.extraFields = {}); t.index < n; )
    r = t.readInt(2), o = t.readInt(2), i = t.readData(o), this.extraFields[r] = {
      id: r,
      length: o,
      value: i
    };
};
Ve.prototype.handleUTF8 = function() {
  var t = me.uint8array ? "uint8array" : "array";
  if (this.useUTF8())
    this.fileNameStr = Ft(this.fileName), this.fileCommentStr = Ft(this.fileComment);
  else {
    var n = this.findExtraFieldUnicodePath();
    if (n !== null)
      this.fileNameStr = n;
    else {
      var r = he(t, this.fileName);
      this.fileNameStr = this.loadOptions.decodeFileName(r);
    }
    var o = this.findExtraFieldUnicodeComment();
    if (o !== null)
      this.fileCommentStr = o;
    else {
      var i = he(t, this.fileComment);
      this.fileCommentStr = this.loadOptions.decodeFileName(i);
    }
  }
};
Ve.prototype.findExtraFieldUnicodePath = function() {
  var t = this.extraFields[28789];
  if (t) {
    var n = an(t.value);
    return n.readInt(1) !== 1 || yr(this.fileName) !== n.readInt(4) ? null : Ft(n.readData(t.length - 5));
  }
  return null;
};
Ve.prototype.findExtraFieldUnicodeComment = function() {
  var t = this.extraFields[25461];
  if (t) {
    var n = an(t.value);
    return n.readInt(1) !== 1 || yr(this.fileComment) !== n.readInt(4) ? null : Ft(n.readData(t.length - 5));
  }
  return null;
};
var qe = function(t) {
  this.files = [], this.loadOptions = t;
};
qe.prototype.checkSignature = function(t) {
  if (!this.reader.readAndCheckSignature(t)) {
    this.reader.index -= 4;
    var n = this.reader.readString(4);
    throw new Error("Corrupted zip or bug: unexpected signature (" + lo(n) + ", expected " + lo(t) + ")");
  }
};
qe.prototype.isSignature = function(t, n) {
  var r = this.reader.index;
  this.reader.setIndex(t);
  var o = this.reader.readString(4), i = o === n;
  return this.reader.setIndex(r), i;
};
qe.prototype.readBlockEndOfCentral = function() {
  this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
  var t = this.reader.readData(this.zipCommentLength), n = me.uint8array ? "uint8array" : "array", r = he(n, t);
  this.zipComment = this.loadOptions.decodeFileName(r);
};
qe.prototype.readBlockZip64EndOfCentral = function() {
  this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
  for (var t = this.zip64EndOfCentralSize - 44, n = 0, r, o, i; n < t; )
    r = this.reader.readInt(2), o = this.reader.readInt(4), i = this.reader.readData(o), this.zip64ExtensibleData[r] = {
      id: r,
      length: o,
      value: i
    };
};
qe.prototype.readBlockZip64EndOfCentralLocator = function() {
  if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), this.disksCount > 1)
    throw new Error("Multi-volumes zip are not supported");
};
qe.prototype.readLocalFiles = function() {
  var t, n;
  for (t = 0; t < this.files.length; t++)
    n = this.files[t], this.reader.setIndex(n.localHeaderOffset), this.checkSignature(No), n.readLocalPart(this.reader), n.handleUTF8(), n.processAttributes();
};
qe.prototype.readCentralDir = function() {
  var t;
  for (this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(Lo); )
    t = new Ve({
      zip64: this.zip64
    }, this.loadOptions), t.readCentralPart(this.reader), this.files.push(t);
  if (this.centralDirRecords !== this.files.length && this.centralDirRecords !== 0 && this.files.length === 0)
    throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
};
qe.prototype.readEndOfCentral = function() {
  var t = this.reader.lastIndexOfSignature(uo);
  if (t < 0) {
    var n = !this.isSignature(0, No);
    throw n ? new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html") : new Error("Corrupted zip: can't find end of central directory");
  }
  this.reader.setIndex(t);
  var r = t;
  if (this.checkSignature(uo), this.readBlockEndOfCentral(), this.diskNumber === Tr || this.diskWithCentralDirStart === Tr || this.centralDirRecordsOnThisDisk === Tr || this.centralDirRecords === Tr || this.centralDirSize === qt || this.centralDirOffset === qt) {
    if (this.zip64 = !0, t = this.reader.lastIndexOfSignature(Oi), t < 0)
      throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
    if (this.reader.setIndex(t), this.checkSignature(Oi), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, mn) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(mn), this.relativeOffsetEndOfZip64CentralDir < 0))
      throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
    this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(mn), this.readBlockZip64EndOfCentral();
  }
  var o = this.centralDirOffset + this.centralDirSize;
  this.zip64 && (o += 20, o += 12 + this.zip64EndOfCentralSize);
  var i = r - o;
  if (i > 0)
    this.isSignature(r, Lo) || (this.reader.zero = i);
  else if (i < 0)
    throw new Error("Corrupted zip: missing " + Math.abs(i) + " bytes.");
};
qe.prototype.prepareReader = function(t) {
  this.reader = an(t);
};
qe.prototype.load = function(t) {
  this.prepareReader(t), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
};
function Ad(e) {
  return new Je.Promise(function(t, n) {
    var r = e.decompressed.getContentWorker().pipe(new sl());
    r.on("error", function(o) {
      n(o);
    }).on("end", function() {
      r.streamInfo.crc32 !== e.decompressed.crc32 ? n(new Error("Corrupted zip : CRC32 mismatch")) : t();
    }).resume();
  });
}
function Md(e, t) {
  var n = this;
  return t = Do(t || {}, {
    base64: !1,
    checkCRC32: !1,
    optimizedBinaryString: !1,
    createFolders: !1,
    decodeFileName: Ft
  }), ol("the loaded zip file", e, !0, t.optimizedBinaryString, t.base64).then(function(r) {
    var o = new qe(t);
    return o.load(r), o;
  }).then(function(o) {
    var i = [Je.Promise.resolve(o)], a = o.files;
    if (t.checkCRC32)
      for (var s = 0; s < a.length; s++)
        i.push(Ad(a[s]));
    return Je.Promise.all(i);
  }).then(function(o) {
    for (var i = o.shift(), a = i.files, s = 0; s < a.length; s++) {
      var u = a[s];
      n.file(u.fileNameStr, u.decompressed, {
        binary: !0,
        optimizedBinaryString: !0,
        date: u.date,
        dir: u.dir,
        comment: u.fileCommentStr.length ? u.fileCommentStr : null,
        unixPermissions: u.unixPermissions,
        dosPermissions: u.dosPermissions,
        createFolders: t.createFolders
      });
    }
    return i.zipComment.length && (n.comment = i.zipComment), n;
  });
}
var fl = function(e, t, n) {
  var r = Lt(t), o, i = Do(n || {}, ll);
  i.date = i.date || /* @__PURE__ */ new Date(), i.compression !== null && (i.compression = i.compression.toUpperCase()), typeof i.unixPermissions == "string" && (i.unixPermissions = parseInt(i.unixPermissions, 8)), i.unixPermissions && i.unixPermissions & 16384 && (i.dir = !0), i.dosPermissions && i.dosPermissions & 16 && (i.dir = !0), i.dir && (e = dl(e)), i.createFolders && (o = Fd(e)) && hl.call(this, o, !0);
  var a = r === "string" && i.binary === !1 && i.base64 === !1;
  (!n || typeof n.binary > "u") && (i.binary = !a);
  var s = t instanceof it && t.uncompressedSize === 0;
  (s || i.dir || !t || t.length === 0) && (i.base64 = !1, i.binary = !0, t = "", i.compression = "STORE", r = "string");
  var u = null;
  t instanceof it || t instanceof V ? u = t : u = ol(e, t, i.binary, i.optimizedBinaryString, i.base64);
  var c = new xr(e, u, i);
  this.files[e] = c;
}, Fd = function(e) {
  e.slice(-1) === "/" && (e = e.substring(0, e.length - 1));
  var t = e.lastIndexOf("/");
  return t > 0 ? e.substring(0, t) : "";
}, dl = function(e) {
  return e.slice(-1) !== "/" && (e += "/"), e;
}, hl = function(e, t) {
  return t = typeof t < "u" ? t : al, e = dl(e), this.files[e] || fl.call(this, e, null, {
    dir: !0,
    createFolders: t
  }), this.files[e];
};
function pl(e) {
  return Object.prototype.toString.call(e) === "[object RegExp]";
}
var ke = function e() {
  if (arguments.length)
    throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
  this.files = /* @__PURE__ */ Object.create(null), this.comment = null, this.root = "", this.clone = function() {
    var t = new e();
    for (var n in this)
      typeof this[n] != "function" && (t[n] = this[n]);
    return t;
  };
}, wr = { support: { configurable: !0 }, defaults: { configurable: !0 }, version: { configurable: !0 }, external: { configurable: !0 } };
ke.prototype.load = function() {
  throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
};
ke.prototype.forEach = function(t) {
  var n, r, o;
  for (n in this.files)
    o = this.files[n], r = n.slice(this.root.length, n.length), r && n.slice(0, this.root.length) === this.root && t(r, o);
};
ke.prototype.filter = function(t) {
  var n = [];
  return this.forEach(function(r, o) {
    t(r, o) && n.push(o);
  }), n;
};
ke.prototype.file = function(t, n, r) {
  if (arguments.length === 1)
    if (pl(t)) {
      var o = t;
      return this.filter(function(a, s) {
        return !s.dir && o.test(a);
      });
    } else {
      var i = this.files[this.root + t];
      return i && !i.dir ? i : null;
    }
  else
    t = this.root + t, fl.call(this, t, n, r);
  return this;
};
ke.prototype.folder = function(t) {
  if (!t)
    return this;
  if (pl(t))
    return this.filter(function(i, a) {
      return a.dir && t.test(i);
    });
  var n = this.root + t, r = hl.call(this, n), o = this.clone();
  return o.root = r.name, o;
};
ke.prototype.remove = function(t) {
  t = this.root + t;
  var n = this.files[t];
  if (n || (t.slice(-1) !== "/" && (t += "/"), n = this.files[t]), n && !n.dir)
    delete this.files[t];
  else
    for (var r = this.filter(function(i, a) {
      return a.name.slice(0, t.length) === t;
    }), o = 0; o < r.length; o++)
      delete this.files[r[o].name];
  return this;
};
ke.prototype.generate = function(t) {
  throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
};
ke.prototype.generateInternalStream = function(t) {
  var n, r = {};
  try {
    if (r = Do(t || {}, {
      streamFiles: !1,
      compression: "STORE",
      compressionOptions: null,
      type: "",
      platform: "DOS",
      comment: null,
      mimeType: "application/zip",
      encodeFileName: hr
    }), r.type = r.type.toLowerCase(), r.compression = r.compression.toUpperCase(), r.type === "binarystring" && (r.type = "string"), !r.type)
      throw new Error("No output type specified.");
    br(r.type), (r.platform === "darwin" || r.platform === "freebsd" || r.platform === "linux" || r.platform === "sunos") && (r.platform = "UNIX"), r.platform === "win32" && (r.platform = "DOS");
    var o = r.comment || this.comment || "";
    n = Od(this, r, o);
  } catch (i) {
    n = new V("error"), n.error(i);
  }
  return new Zt(n, r.type || "string", r.mimeType);
};
ke.prototype.generateAsync = function(t, n) {
  return this.generateInternalStream(t).accumulate(n);
};
ke.prototype.loadAsync = function(t, n) {
  return Md.apply(this, [t, n]);
};
ke.loadAsync = function(t, n) {
  return new ke().loadAsync(t, n);
};
wr.support.get = function() {
  return me;
};
wr.defaults.get = function() {
  return ll;
};
wr.version.get = function() {
  return "3.2.2-esm";
};
wr.external.get = function() {
  return Je;
};
Object.defineProperties(ke, wr);
function Nd() {
  return new ke();
}
function gl(e, t, n) {
  return (1461 * (e + 4800 + ((t - 13) / 12 | 0)) / 4 | 0) + (367 * (t - 1 - 12 * ((t - 13) / 12 | 0)) / 12 | 0) - (3 * ((e + 4900 + ((t - 13) / 12 | 0)) / 100 | 0) / 4 | 0) + n - 32075;
}
var Ld = gl(1900, 0, -1);
function jd(e, t, n) {
  return gl(e, t, n) - Ld;
}
function zd(e, t, n, r) {
  return (e + (t + (n + r / 1e3) / 60) / 60) / 24;
}
function Hd(e) {
  var t = zd(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), n = jd(
    e.getFullYear(),
    e.getMonth(),
    e.getDate()
  );
  return n < 0 ? n - 1 + t : n + t;
}
var vl = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", Bd = "data:" + vl + ";base64,", Pi = { compression: "DEFLATE", type: "base64" }, Gd = { compression: "DEFLATE", type: "blob" }, Ud = { compression: "DEFLATE", type: "arraybuffer" };
function Ti(e) {
  return Bd + e;
}
function pr(e, t) {
  return t.indexOf(e);
}
var Ri = JSON.parse.bind(JSON);
function $(e) {
  return String(e).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\"/g, "&quot;").replace(/\'/g, "&#39;");
}
function ml(e, t) {
  for (var n = "", r = 0; r < e; ++r)
    n += t(r);
  return n;
}
function re(e, t) {
  var n = "";
  if (e != null)
    if (Array.isArray(e))
      for (var r = 0; r < e.length; ++r)
        n += t(e[r], r);
    else
      typeof e == "object" && Object.keys(e).forEach(function(o, i) {
        n += t(e[o], o, i);
      });
  return n;
}
var Fe = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r', Kd = Fe + `
            <Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">
               <Relationship Id="rId3" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties" Target="docProps/app.xml"/>
               <Relationship Id="rId2" Type="http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties" Target="docProps/core.xml"/>
               <Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/>
            </Relationships>`, Wd = function(e) {
  var t = e.creator, n = e.lastModifiedBy, r = e.created, o = e.modified;
  return Fe + `
 <cp:coreProperties xmlns:cp="http://schemas.openxmlformats.org/package/2006/metadata/core-properties"
   xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:dcterms="http://purl.org/dc/terms/"
   xmlns:dcmitype="http://purl.org/dc/dcmitype/" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">
   <dc:creator>` + $(t) + `</dc:creator>
   <cp:lastModifiedBy>` + $(n) + `</cp:lastModifiedBy>
   <dcterms:created xsi:type="dcterms:W3CDTF">` + $(r) + `</dcterms:created>
   <dcterms:modified xsi:type="dcterms:W3CDTF">` + $(o) + `</dcterms:modified>
</cp:coreProperties>`;
}, Vd = function(e) {
  var t = e.sheets;
  return Fe + `
<Properties xmlns="http://schemas.openxmlformats.org/officeDocument/2006/extended-properties" xmlns:vt="http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes">
  <Application>Microsoft Excel</Application>
  <DocSecurity>0</DocSecurity>
  <ScaleCrop>false</ScaleCrop>
  <HeadingPairs>
    <vt:vector size="2" baseType="variant">
      <vt:variant>
        <vt:lpstr>Worksheets</vt:lpstr>
      </vt:variant>
      <vt:variant>
        <vt:i4>` + t.length + `</vt:i4>
      </vt:variant>
    </vt:vector>
  </HeadingPairs>
  <TitlesOfParts>
    <vt:vector size="` + t.length + '" baseType="lpstr">' + re(
    t,
    function(n, r) {
      return n.options.title ? "<vt:lpstr>" + $(n.options.title) + "</vt:lpstr>" : "<vt:lpstr>Sheet" + (r + 1) + "</vt:lpstr>";
    }
  ) + `</vt:vector>
  </TitlesOfParts>
  <LinksUpToDate>false</LinksUpToDate>
  <SharedDoc>false</SharedDoc>
  <HyperlinksChanged>false</HyperlinksChanged>
  <AppVersion>14.0300</AppVersion>
</Properties>`;
}, qd = function(e) {
  var t = e.sheetCount, n = e.commentFiles, r = e.drawingFiles;
  return Fe + `
<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">
  <Default Extension="png" ContentType="image/png"/>
  <Default Extension="gif" ContentType="image/gif"/>
  <Default Extension="jpg" ContentType="image/jpeg"/>
  <Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml" />
  <Default Extension="xml" ContentType="application/xml" />
  <Default Extension="vml" ContentType="application/vnd.openxmlformats-officedocument.vmlDrawing"/>
  <Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml" />
  <Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"/>
  <Override PartName="/xl/sharedStrings.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml"/>
  ` + ml(t, function(o) {
    return '<Override PartName="/xl/worksheets/sheet' + (o + 1) + '.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml" />';
  }) + `
  ` + re(n, function(o) {
    return '<Override PartName="/xl/' + o + '" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml"/>';
  }) + `
  ` + re(r, function(o) {
    return '<Override PartName="/xl/drawings/' + o + '" ContentType="application/vnd.openxmlformats-officedocument.drawing+xml"/>';
  }) + `
  <Override PartName="/docProps/core.xml" ContentType="application/vnd.openxmlformats-package.core-properties+xml" />
  <Override PartName="/docProps/app.xml" ContentType="application/vnd.openxmlformats-officedocument.extended-properties+xml" />
</Types>`;
}, $d = function(e) {
  var t = e.sheets, n = e.filterNames, r = e.userNames;
  return Fe + `
<workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships">
  <fileVersion appName="xl" lastEdited="5" lowestEdited="5" rupBuild="9303" />
  <workbookPr defaultThemeVersion="124226" />
  <bookViews>
    <workbookView xWindow="240" yWindow="45" windowWidth="18195" windowHeight="7995" />
  </bookViews>
  <sheets>
  ` + re(t, function(o, i) {
    var a = o.options, s = a.name || a.title || "Sheet" + (i + 1);
    return '<sheet name="' + $(s) + '" sheetId="' + (i + 1) + '" r:id="rId' + (i + 1) + '" />';
  }) + `
  </sheets>
  ` + (n.length || r.length ? `
    <definedNames>
      ` + re(n, function(o) {
    return `
         <definedName name="_xlnm._FilterDatabase" hidden="1" localSheetId="` + o.localSheetId + '">' + $(Eh(o.name)) + "!" + $(o.from) + ":" + $(o.to) + "</definedName>";
  }) + `
      ` + re(r, function(o) {
    return `
         <definedName name="` + o.name + '" hidden="' + (o.hidden ? 1 : 0) + '" ' + (o.localSheetId != null ? 'localSheetId="' + o.localSheetId + '"' : "") + ">" + $(o.value) + "</definedName>";
  }) + `
    </definedNames>` : "") + `
  <calcPr fullCalcOnLoad="1" calcId="145621" />
</workbook>`;
}, Xd = function(e) {
  var t = e.frozenColumns, n = e.frozenRows, r = e.columns, o = e.defaults, i = e.data, a = e.index, s = e.mergeCells, u = e.autoFilter, c = e.filter, f = e.showGridLines, d = e.hyperlinks, h = e.validations, m = e.defaultCellStyleId, g = e.rtl, y = e.legacyDrawing, w = e.drawing, x = e.lastRow, b = e.lastCol;
  return Fe + `
<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac" mc:Ignorable="x14ac">
   ` + (x && b ? '<dimension ref="A1:' + Xt(x - 1, b - 1) + '" />' : "") + `

   <sheetViews>
     <sheetView ` + (g ? 'rightToLeft="1"' : "") + " " + (a === 0 ? 'tabSelected="1"' : "") + ' workbookViewId="0" ' + (f === !1 ? 'showGridLines="0"' : "") + `>
     ` + (n || t ? `
       <pane state="frozen"
         ` + (t ? 'xSplit="' + t + '"' : "") + `
         ` + (n ? 'ySplit="' + n + '"' : "") + `
         topLeftCell="` + (String.fromCharCode(65 + (t || 0)) + ((n || 0) + 1)) + `"
       />` : "") + `
     </sheetView>
   </sheetViews>

   <sheetFormatPr x14ac:dyDescent="0.25" ` + (o.skipCustomHeight ? "" : 'customHeight="1"') + ' defaultRowHeight="' + (o.rowHeight ? o.rowHeight * 0.75 : 15) + `"
     ` + (o.columnWidth ? 'defaultColWidth="' + yn(o.columnWidth) + '"' : "") + ` />

   ` + (m != null || r && r.length > 0 ? `
     <cols>
       ` + (!r || !r.length ? `
         <col min="1" max="16384" style="` + m + `"
              ` + (o.columnWidth ? 'width="' + yn(o.columnWidth) + '"' : "") + " /> " : "") + `
       ` + re(r, function(C, S) {
    var T = typeof C.index == "number" ? C.index + 1 : S + 1;
    return C.width === 0 ? "<col " + (m != null ? 'style="' + m + '"' : "") + `
                        min="` + T + '" max="' + T + '" hidden="1" customWidth="1" />' : "<col " + (m != null ? 'style="' + m + '"' : "") + `
                      min="` + T + '" max="' + T + `" customWidth="1"
                      ` + (C.autoWidth ? 'width="' + (C.width * 7 + 5) / 7 * 256 / 256 + '" bestFit="1"' : 'width="' + yn(C.width) + '"') + " />";
  }) + `
     </cols>` : "") + `

   <sheetData>
     ` + re(i, function(C, S) {
    var T = typeof C.index == "number" ? C.index + 1 : S + 1;
    return `
         <row r="` + T + `" x14ac:dyDescent="0.25"
              ` + (C.level ? 'outlineLevel="' + C.level + '"' : "") + `
              ` + (C.height === 0 ? 'hidden="1"' : C.height ? 'ht="' + ih(C.height) + '" customHeight="1"' : "") + `>
           ` + re(C.data, function(_) {
      return `
             <c r="` + _.ref + '" ' + (_.style ? 's="' + _.style + '"' : "") + " " + (_.type ? 't="' + _.type + '"' : "") + `>
               ` + (_.formula != null ? oh(_.formula) : "") + `
               ` + (_.value != null ? "<v>" + $(_.value) + "</v>" : "") + `
             </c>`;
    }) + `
         </row>
       `;
  }) + `
   </sheetData>

   ` + (u ? '<autoFilter ref="' + u.from + ":" + u.to + '"/>' : c ? Nt(c) : "") + `

   ` + (s.length ? `
     <mergeCells count="` + s.length + `">
       ` + re(s, function(C) {
    return '<mergeCell ref="' + C + '"/>';
  }) + `
     </mergeCells>` : "") + `

   ` + (h.length ? `
     <dataValidations>
       ` + re(h, function(C) {
    return `
         <dataValidation sqref="` + C.sqref.join(" ") + `"
                         showErrorMessage="` + C.showErrorMessage + `"
                         type="` + $(C.type) + `"
                         ` + (C.type !== "list" ? 'operator="' + $(C.operator) + '"' : "") + `
                         allowBlank="` + C.allowBlank + `"
                         showDropDown="` + C.showDropDown + `"
                         ` + (C.error ? 'error="' + $(C.error) + '"' : "") + `
                         ` + (C.errorTitle ? 'errorTitle="' + $(C.errorTitle) + '"' : "") + `>
           ` + (C.formula1 ? "<formula1>" + $(C.formula1) + "</formula1>" : "") + `
           ` + (C.formula2 ? "<formula2>" + $(C.formula2) + "</formula2>" : "") + `
         </dataValidation>`;
  }) + `
     </dataValidations>` : "") + `

   ` + (d.length ? `
     <hyperlinks>
       ` + re(d, function(C) {
    return `
         <hyperlink ref="` + C.ref + '" r:id="' + C.rId + '"/>';
  }) + `
     </hyperlinks>` : "") + `

   <pageMargins left="0.7" right="0.7" top="0.75" bottom="0.75" header="0.3" footer="0.3" />
   ` + (w ? '<drawing r:id="' + w + '"/>' : "") + `
   ` + (y ? '<legacyDrawing r:id="' + y + '"/>' : "") + `
</worksheet>`;
}, Yd = function(e) {
  var t = e.count;
  return Fe + `
<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">
  ` + ml(t, function(n) {
    return `
    <Relationship Id="rId` + (n + 1) + '" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet' + (n + 1) + '.xml" />';
  }) + `
  <Relationship Id="rId` + (t + 1) + `" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml" />
  <Relationship Id="rId` + (t + 2) + `" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings" Target="sharedStrings.xml" />
</Relationships>`;
}, Zd = function(e) {
  var t = e.hyperlinks, n = e.comments, r = e.sheetIndex, o = e.drawings;
  return Fe + `
<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">
  ` + re(t, function(i) {
    return `
    <Relationship Id="` + i.rId + '" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink" Target="' + $(i.target) + '" TargetMode="External" />';
  }) + `
  ` + (n.length ? `
    <Relationship Id="comment` + r + '" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments" Target="../comments' + r + `.xml"/>
    <Relationship Id="vml` + r + '" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing" Target="../drawings/vmlDrawing' + r + '.vml"/>' : "") + `
  ` + (o.length ? `
    <Relationship Id="drw` + r + '" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing" Target="../drawings/drawing' + r + '.xml"/>' : "") + `
</Relationships>`;
}, Qd = function(e) {
  var t = e.comments;
  return Fe + `
<comments xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">
  <authors>
    <author></author>
  </authors>
  <commentList>
    ` + re(t, function(n) {
    return `
      <comment ref="` + n.ref + `" authorId="0">
        <text>
          <r>
            <rPr>
              <sz val="8"/>
              <color indexed="81"/>
              <rFont val="Tahoma"/>
              <charset val="1"/>
            </rPr>
            <t>` + $(n.text) + `</t>
          </r>
        </text>
      </comment>`;
  }) + `
  </commentList>
</comments>`;
}, Jd = function(e) {
  var t = e.comments;
  return `<xml xmlns:v="urn:schemas-microsoft-com:vml"
     xmlns:o="urn:schemas-microsoft-com:office:office"
     xmlns:x="urn:schemas-microsoft-com:office:excel">
  <v:shapetype coordsize="21600,21600" id="_x0000_t202" path="m,l,21600r21600,l21600,xe">
    <v:stroke joinstyle="miter"/>
    <v:path gradientshapeok="t" o:connecttype="rect"/>
  </v:shapetype>
  ` + re(t, function(n) {
    return `
    <v:shape type="#_x0000_t202" style="visibility: hidden" fillcolor="#ffffe1" o:insetmode="auto">
      <v:shadow on="t" color="black" obscured="t"/>
      <x:ClientData ObjectType="Note">
        <x:MoveWithCells/>
        <x:SizeWithCells/>
        <x:Anchor>` + n.anchor + `</x:Anchor>
        <x:AutoFill>False</x:AutoFill>
        <x:Row>` + n.row + `</x:Row>
        <x:Column>` + n.col + `</x:Column>
      </x:ClientData>
    </v:shape>`;
  }) + `
</xml>`;
}, eh = function(e) {
  return Fe + `
<xdr:wsDr xmlns:xdr="http://schemas.openxmlformats.org/drawingml/2006/spreadsheetDrawing"
          xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main"
          xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships">
  ` + re(e, function(t, n) {
    return `
    <xdr:oneCellAnchor editAs="oneCell">
      <xdr:from>
        <xdr:col>` + t.col + `</xdr:col>
        <xdr:colOff>` + t.colOffset + `</xdr:colOff>
        <xdr:row>` + t.row + `</xdr:row>
        <xdr:rowOff>` + t.rowOffset + `</xdr:rowOff>
      </xdr:from>
      <xdr:ext cx="` + t.width + '" cy="' + t.height + `" />
      <xdr:pic>
        <xdr:nvPicPr>
          <xdr:cNvPr id="` + (n + 1) + '" name="Picture ' + (n + 1) + `"/>
          <xdr:cNvPicPr/>
        </xdr:nvPicPr>
        <xdr:blipFill>
          <a:blip r:embed="` + t.imageId + `"/>
          <a:stretch>
            <a:fillRect/>
          </a:stretch>
        </xdr:blipFill>
        <xdr:spPr>
          <a:prstGeom prst="rect">
            <a:avLst/>
          </a:prstGeom>
        </xdr:spPr>
      </xdr:pic>
      <xdr:clientData/>
    </xdr:oneCellAnchor>`;
  }) + `
</xdr:wsDr>`;
}, th = function(e) {
  return Fe + `
<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">
  ` + re(e, function(t) {
    return `
    <Relationship Id="` + t.rId + '" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/image" Target="' + t.target + '"/>';
  }) + `
</Relationships>`;
}, rh = function(e) {
  var t = e.count, n = e.uniqueCount, r = e.indexes;
  return Fe + `
<sst xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" count="` + t + '" uniqueCount="' + n + `">
  ` + re(Object.keys(r), function(o) {
    return `
    <si><t xml:space="preserve">` + $(o.substring(1)) + "</t></si>";
  }) + `
</sst>`;
}, nh = function(e) {
  var t = e.formats, n = e.fonts, r = e.fills, o = e.borders, i = e.styles;
  return Fe + `
<styleSheet
    xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main"
    xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006"
    mc:Ignorable="x14ac"
    xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac">
  <numFmts count="` + t.length + `">
  ` + re(t, function(a, s) {
    return `
    <numFmt formatCode="` + $(a.format) + '" numFmtId="' + (165 + s) + '" />';
  }) + `
  </numFmts>
  <fonts count="` + (n.length + 1) + `" x14ac:knownFonts="1">
    <font>
       <sz val="11" />
       <color theme="1" />
       <name val="Calibri" />
       <family val="2" />
       <scheme val="minor" />
    </font>
    ` + re(n, function(a) {
    return `
    <font>
      ` + (a.bold ? "<b/>" : "") + `
      ` + (a.italic ? "<i/>" : "") + `
      ` + (a.underline ? "<u/>" : "") + `
      <sz val="` + (a.fontSize || 11) + `" />
      ` + (a.color ? '<color rgb="' + $(a.color) + '" />' : '<color theme="1" />') + `
      ` + (a.fontFamily ? `
        <name val="` + $(a.fontFamily) + `" />
        <family val="2" />
      ` : `
        <name val="Calibri" />
        <family val="2" />
        <scheme val="minor" />
      `) + `
    </font>`;
  }) + `
  </fonts>
  <fills count="` + (r.length + 2) + `">
      <fill><patternFill patternType="none"/></fill>
      <fill><patternFill patternType="gray125"/></fill>
    ` + re(r, function(a) {
    return `
      ` + (a.background ? `
        <fill>
          <patternFill patternType="solid">
              <fgColor rgb="` + $(a.background) + `"/>
          </patternFill>
        </fill>
      ` : "");
  }) + `
  </fills>
  <borders count="` + (o.length + 1) + `">
    <border><left/><right/><top/><bottom/><diagonal/></border>
    ` + re(o, fh) + `
  </borders>
  <cellStyleXfs count="1">
    <xf borderId="0" fillId="0" fontId="0" />
  </cellStyleXfs>
  <cellXfs count="` + (i.length + 1) + `">
    <xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0" />
    ` + re(i, function(a) {
    return `
      <xf xfId="0"
          ` + (a.fontId ? 'fontId="' + a.fontId + '" applyFont="1"' : "") + `
          ` + (a.fillId ? 'fillId="' + a.fillId + '" applyFill="1"' : "") + `
          ` + (a.numFmtId ? 'numFmtId="' + a.numFmtId + '" applyNumberFormat="1"' : "") + `
          ` + (a.textAlign || a.verticalAlign || a.wrap ? 'applyAlignment="1"' : "") + `
          ` + (a.borderId ? 'borderId="' + a.borderId + '" applyBorder="1"' : "") + `>
        ` + (a.textAlign || a.verticalAlign || a.wrap ? `
        <alignment
          ` + (a.textAlign ? 'horizontal="' + $(a.textAlign) + '"' : "") + `
          ` + (a.verticalAlign ? 'vertical="' + $(a.verticalAlign) + '"' : "") + `
          ` + (a.indent ? 'indent="' + $(a.indent) + '"' : "") + `
          ` + (a.wrap ? 'wrapText="1"' : "") + ` />
        ` : "") + `
      </xf>
    `;
  }) + `
  </cellXfs>
  <cellStyles count="1">
    <cellStyle name="Normal" xfId="0" builtinId="0"/>
  </cellStyles>
  <dxfs count="0" />
  <tableStyles count="0" defaultTableStyle="TableStyleMedium2" defaultPivotStyle="PivotStyleMedium9" />
</styleSheet>`;
};
function oh(e) {
  return typeof e == "string" ? "<f>" + $(e) + "</f>" : '<f t="array" ref="' + e.ref + '">' + $(e.src) + "</f>";
}
function jo(e) {
  var t = Math.floor(e / 26) - 1;
  return (t >= 0 ? jo(t) : "") + String.fromCharCode(65 + e % 26);
}
function Xt(e, t) {
  return jo(t) + (e + 1);
}
function Rr(e, t) {
  return "$" + jo(t) + "$" + (e + 1);
}
function Zr(e) {
  var t = e.frozenRows || (e.freezePane || {}).rowSplit || 1;
  return t - 1;
}
function yn(e) {
  var t = 7;
  return e / t - Math.floor(128 / t) / 256;
}
function ih(e) {
  return e * 0.75;
}
function ah(e) {
  return String(e).replace(/[\x00-\x09\x0B\x0C\x0E-\x1F]/g, "").replace(/\r?\n/g, `\r
`);
}
var Oe = function(t, n, r, o) {
  this.options = t, this._strings = n, this._styles = r, this._borders = o, this._validations = {}, this._comments = [], this._drawings = t.drawings || [], this._hyperlinks = (this.options.hyperlinks || []).map(
    function(i, a) {
      return Object.assign({}, i, { rId: "link" + a });
    }
  );
};
Oe.prototype.relsToXML = function() {
  var t = this._hyperlinks, n = this._comments, r = this._drawings;
  if (t.length || n.length || r.length)
    return Zd({
      hyperlinks: t,
      comments: n,
      sheetIndex: this.options.sheetIndex,
      drawings: r
    });
};
Oe.prototype.toXML = function(t) {
  var n = this, r = this.options.mergedCells || [], o = this.options.rows || [], i = dh(o, r);
  this._readCells(i);
  var a = this.options.filter, s;
  a && typeof a.from == "number" && typeof a.to == "number" ? a = {
    from: Xt(Zr(this.options), a.from),
    to: Xt(Zr(this.options), a.to)
  } : a && a.ref && a.columns && (s = a, a = null);
  var u = [];
  for (var c in n._validations)
    Object.prototype.hasOwnProperty.call(n._validations, c) && u.push(n._validations[c]);
  var f = null;
  this.options.defaultCellStyle && (f = this._lookupStyle(this.options.defaultCellStyle));
  var d = this.options.freezePane || {}, h = this.options.defaults || {}, m = this.options.rows ? this._getLastRow() : 1, g = this.options.rows ? this._getLastCol() : 1;
  return Xd({
    frozenColumns: this.options.frozenColumns || d.colSplit,
    frozenRows: this.options.frozenRows || d.rowSplit,
    columns: this.options.columns,
    defaults: h,
    data: i,
    index: t,
    mergeCells: r,
    autoFilter: a,
    filter: s,
    showGridLines: this.options.showGridLines,
    hyperlinks: this._hyperlinks,
    validations: u,
    defaultCellStyleId: f,
    rtl: this.options.rtl !== void 0 ? this.options.rtl : h.rtl,
    legacyDrawing: this._comments.length ? "vml" + this.options.sheetIndex : null,
    drawing: this._drawings.length ? "drw" + this.options.sheetIndex : null,
    lastRow: m,
    lastCol: g
  });
};
Oe.prototype.commentsXML = function() {
  if (this._comments.length)
    return Qd({ comments: this._comments });
};
Oe.prototype.drawingsXML = function(t) {
  if (this._drawings.length) {
    var n = {}, r = this._drawings.map(function(o) {
      var i = Cr(o.topLeftCell), a = n[o.image];
      return a || (a = n[o.image] = {
        rId: "img" + o.image,
        target: t[o.image].target
      }), {
        col: i.col,
        colOffset: Dr(o.offsetX),
        row: i.row,
        rowOffset: Dr(o.offsetY),
        width: Dr(o.width),
        height: Dr(o.height),
        imageId: a.rId
      };
    });
    return {
      main: eh(r),
      rels: th(n)
    };
  }
};
Oe.prototype.legacyDrawing = function() {
  if (this._comments.length)
    return Jd({ comments: this._comments });
};
Oe.prototype._lookupString = function(t) {
  var n = "$" + t, r = this._strings.indexes[n], o;
  return r !== void 0 ? o = r : (o = this._strings.indexes[n] = this._strings.uniqueCount, this._strings.uniqueCount++), this._strings.count++, o;
};
Oe.prototype._lookupStyle = function(t) {
  var n = JSON.stringify(t);
  if (n === "{}")
    return 0;
  var r = pr(n, this._styles);
  return r < 0 && (r = this._styles.push(n) - 1), r + 1;
};
Oe.prototype._lookupBorder = function(t) {
  var n = JSON.stringify(t);
  if (n !== "{}") {
    var r = pr(n, this._borders);
    return r < 0 && (r = this._borders.push(n) - 1), r + 1;
  }
};
Oe.prototype._readCells = function(t) {
  for (var n = this, r = 0; r < t.length; r++) {
    var o = t[r], i = o.cells;
    o.data = [];
    for (var a = 0; a < i.length; a++) {
      var s = n._cell(i[a], o.index, a);
      s && o.data.push(s);
    }
  }
};
Oe.prototype._cell = function(t, n, r) {
  if (!t || t === Cl)
    return null;
  var o = t.value, i = {};
  t.borderLeft && (i.left = t.borderLeft), t.borderRight && (i.right = t.borderRight), t.borderTop && (i.top = t.borderTop), t.borderBottom && (i.bottom = t.borderBottom), t.dBorders && (i.diagonal = t.dBorders), i = this._lookupBorder(i);
  var a = this.options.defaultCellStyle || {}, s = { borderId: i };
  (function(g) {
    g("color"), g("background"), g("bold"), g("italic"), g("underline"), g("fontFamily") || g("fontName", "fontFamily"), g("fontSize"), g("format"), g("textAlign") || g("hAlign", "textAlign"), g("verticalAlign") || g("vAlign", "verticalAlign"), g("wrap"), g("indent");
  })(
    function(g, y) {
      var w = t[g];
      if (w === void 0 && (w = a[g]), w !== void 0)
        return s[y || g] = w, !0;
    }
  );
  var u = this.options.columns || [], c = u[r], f = typeof o;
  if (c && c.autoWidth && (!t.colSpan || t.colSpan === 1)) {
    var d = o;
    f === "number" && (d = Kf.toString(o, t.format)), c.width = Math.max(c.width || 0, String(d).length);
  }
  f === "string" ? (o = ah(o), o = this._lookupString(o), f = "s") : f === "number" ? f = "n" : f === "boolean" ? (f = "b", o = Number(o)) : o && o.getTime ? (f = null, o = Hd(o), s.format || (s.format = "mm-dd-yy")) : (f = null, o = null), s = this._lookupStyle(s);
  var h = Xt(n, r);
  if (t.validation && this._addValidation(t.validation, h), t.comment) {
    var m = [
      r + 1,
      // start column
      15,
      // start column offset
      n,
      // start row
      10,
      // start row offset
      r + 3,
      // end column
      15,
      // end column offset
      n + 3,
      // end row
      4
      // end row offset
    ];
    this._comments.push({
      ref: h,
      text: t.comment,
      row: n,
      col: r,
      anchor: m.join(", ")
    });
  }
  return {
    value: o,
    formula: t.formula,
    type: f,
    style: s,
    ref: h
  };
};
Oe.prototype._addValidation = function(t, n) {
  var r = {
    showErrorMessage: t.type === "reject" ? 1 : 0,
    formula1: t.from,
    formula2: t.to,
    type: sh[t.dataType] || t.dataType,
    operator: lh[t.comparerType] || t.comparerType,
    allowBlank: t.allowNulls ? 1 : 0,
    showDropDown: t.showButton ? 0 : 1,
    // LOL, Excel!
    error: t.messageTemplate,
    errorTitle: t.titleTemplate
  }, o = JSON.stringify(r);
  this._validations[o] || (this._validations[o] = r, r.sqref = []), this._validations[o].sqref.push(n);
};
Oe.prototype._getLastRow = function() {
  return yl(this.options.rows);
};
Oe.prototype._getLastCol = function() {
  var t = 0;
  return this.options.rows.forEach(function(n) {
    n.cells && (t = Math.max(t, yl(n.cells)));
  }), t;
};
function yl(e) {
  var t = e.length;
  return e.forEach(function(n) {
    n.index && n.index >= t && (t = n.index + 1);
  }), t;
}
var lh = {
  // includes only what differs; key is our operator, value is Excel
  // operator.
  greaterThanOrEqualTo: "greaterThanOrEqual",
  lessThanOrEqualTo: "lessThanOrEqual"
}, sh = {
  // eslint-disable-next-line id-denylist
  number: "decimal"
}, Cn = {
  General: 0,
  0: 1,
  "0.00": 2,
  "#,##0": 3,
  "#,##0.00": 4,
  "0%": 9,
  "0.00%": 10,
  "0.00E+00": 11,
  "# ?/?": 12,
  "# ??/??": 13,
  "mm-dd-yy": 14,
  "d-mmm-yy": 15,
  "d-mmm": 16,
  "mmm-yy": 17,
  "h:mm AM/PM": 18,
  "h:mm:ss AM/PM": 19,
  "h:mm": 20,
  "h:mm:ss": 21,
  "m/d/yy h:mm": 22,
  "#,##0 ;(#,##0)": 37,
  "#,##0 ;[Red](#,##0)": 38,
  "#,##0.00;(#,##0.00)": 39,
  "#,##0.00;[Red](#,##0.00)": 40,
  "mm:ss": 45,
  "[h]:mm:ss": 46,
  "mmss.0": 47,
  "##0.0E+0": 48,
  "@": 49,
  "[$-404]e/m/d": 27,
  "m/d/yy": 30,
  t0: 59,
  "t0.00": 60,
  "t#,##0": 61,
  "t#,##0.00": 62,
  "t0%": 67,
  "t0.00%": 68,
  "t# ?/?": 69,
  "t# ??/??": 70
};
function uh(e) {
  function t(o) {
    var i = parseInt(o, 10).toString(16);
    return i.length < 2 ? "0" + i : i;
  }
  var n = /^rgba?\((\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*([0-9.]+)\s*)?\)/i.exec(e.trim());
  if (n) {
    var r = (n[4] ? parseFloat(n[4]) : 1) * 255 | 0;
    return "#" + t(r) + t(n[1]) + t(n[2]) + t(n[3]);
  }
  return e;
}
function co(e) {
  var t = uh(e);
  return t.length < 6 && (t = t.replace(/(\w)/g, function(n, r) {
    return r + r;
  })), t = t.substring(1).toUpperCase(), t.length < 8 && (t = "FF" + t), t;
}
var _r = function(t) {
  var n = this;
  this.options = t || {}, this._strings = {
    indexes: {},
    count: 0,
    uniqueCount: 0
  }, this._styles = [], this._borders = [], this._images = this.options.images, this._imgId = 0, this._sheets = Ze(this.options.sheets || [], function(r, o) {
    return r.defaults = n.options, r.sheetIndex = o + 1, new Oe(r, n._strings, n._styles, n._borders);
  });
};
_r.prototype.imageFilename = function(t) {
  var n = ++this._imgId;
  switch (t) {
    case "image/jpg":
    case "image/jpeg":
      return "image" + n + ".jpg";
    case "image/png":
      return "image" + n + ".png";
    case "image/gif":
      return "image" + n + ".gif";
    default:
      return "image" + n + ".bin";
  }
};
_r.prototype.toZIP = function() {
  var t = this, n = Nd(), r = n.folder("docProps");
  r.file("core.xml", Wd({
    creator: this.options.creator || "Kendo UI",
    lastModifiedBy: this.options.creator || "Kendo UI",
    created: this.options.date || (/* @__PURE__ */ new Date()).toJSON(),
    modified: this.options.date || (/* @__PURE__ */ new Date()).toJSON()
  }));
  var o = this._sheets.length;
  r.file("app.xml", Vd({ sheets: this._sheets }));
  var i = n.folder("_rels");
  i.file(".rels", Kd);
  var a = n.folder("xl"), s = a.folder("_rels");
  if (s.file("workbook.xml.rels", Yd({ count: o })), this._images) {
    var u = a.folder("media");
    Object.keys(this._images).forEach(function(E) {
      var j = t._images[E], X = t.imageFilename(j.type);
      u.file(X, j.data), j.target = "../media/" + X;
    });
  }
  var c = {};
  a.file("workbook.xml", $d({
    sheets: this._sheets,
    filterNames: Ze(this._sheets, function(E, j) {
      var X = E.options, se = X.name || X.title || "Sheet" + (j + 1);
      c[se.toLowerCase()] = j;
      var ie = X.filter;
      if (ie) {
        if (ie.ref) {
          var ce = ie.ref.split(":"), pe = Cr(ce[0]), ae = Cr(ce[1]);
          return {
            localSheetId: j,
            name: se,
            from: Rr(pe.row, pe.col),
            to: Rr(ae.row, ae.col)
          };
        } else if (typeof ie.from < "u" && typeof ie.to < "u")
          return {
            localSheetId: j,
            name: se,
            from: Rr(Zr(X), ie.from),
            to: Rr(Zr(X), ie.to)
          };
      }
    }),
    userNames: Ze(this.options.names || [], function(E) {
      return {
        name: E.localName,
        localSheetId: E.sheet ? c[E.sheet.toLowerCase()] : null,
        value: E.value,
        hidden: E.hidden
      };
    })
  }));
  for (var f = a.folder("worksheets"), d = a.folder("drawings"), h = d.folder("_rels"), m = f.folder("_rels"), g = [], y = [], w = 0; w < o; w++) {
    var x = t._sheets[w], b = "sheet" + (w + 1) + ".xml", C = x.toXML(w), S = x.relsToXML(), T = x.commentsXML(), _ = x.legacyDrawing(), k = x.drawingsXML(t._images);
    if (S && m.file(b + ".rels", S), T) {
      var H = "comments" + x.options.sheetIndex + ".xml";
      a.file(H, T), g.push(H);
    }
    if (_ && d.file("vmlDrawing" + x.options.sheetIndex + ".vml", _), k) {
      var L = "drawing" + x.options.sheetIndex + ".xml";
      d.file(L, k.main), h.file(L + ".rels", k.rels), y.push(L);
    }
    f.file(b, C);
  }
  var B = Ze(this._borders, Ri), F = Ze(this._styles, Ri), G = function(E) {
    return E.underline || E.bold || E.italic || E.color || E.fontFamily || E.fontSize;
  }, Z = function(E) {
    var j = Number(E), X;
    return j && (X = j * 3 / 4), X;
  }, ee = Ze(F, function(E) {
    if (E.fontSize && (E.fontSize = Z(E.fontSize)), E.color && (E.color = co(E.color)), G(E))
      return E;
  }), D = Ze(F, function(E) {
    if (E.format && Cn[E.format] === void 0)
      return E;
  }), N = Ze(F, function(E) {
    if (E.background)
      return E.background = co(E.background), E;
  });
  return a.file("styles.xml", nh({
    fonts: ee,
    fills: N,
    formats: D,
    borders: B,
    styles: Ze(F, function(E) {
      var j = {};
      return G(E) && (j.fontId = pr(E, ee) + 1), E.background && (j.fillId = pr(E, N) + 2), j.textAlign = E.textAlign, j.indent = E.indent, j.verticalAlign = E.verticalAlign, j.wrap = E.wrap, j.borderId = E.borderId, E.format && (Cn[E.format] !== void 0 ? j.numFmtId = Cn[E.format] : j.numFmtId = 165 + pr(E, D)), j;
    })
  })), a.file("sharedStrings.xml", rh(this._strings)), n.file("[Content_Types].xml", qd({
    sheetCount: o,
    commentFiles: g,
    drawingFiles: y
  })), n;
};
_r.prototype.toDataURL = function() {
  var t = this.toZIP();
  return t.generateAsync ? t.generateAsync(Pi).then(Ti) : Ti(t.generate(Pi));
};
_r.prototype.toBlob = function() {
  var t = this.toZIP();
  return t.generateAsync ? t.generateAsync(Gd) : new Blob([t.generate(Ud)], { type: vl });
};
function ch(e) {
  var t = "thin";
  return e === 2 ? t = "medium" : e === 3 && (t = "thick"), t;
}
function er(e, t) {
  var n = "";
  return t && (n += "<" + e + ' style="' + ch(t.size) + '">', t.color && (n += '<color rgb="' + co(t.color) + '"/>'), n += "</" + e + ">"), n;
}
function fh(e) {
  var t = e.diagonal ? e.diagonal.type : 0;
  return "<border " + (t & 2 ? 'diagonalUp="true"' : "") + " " + (t & 1 ? 'diagonalDown="true"' : "") + `>
      ` + er("left", e.left) + `
      ` + er("right", e.right) + `
      ` + er("top", e.top) + `
      ` + er("bottom", e.bottom) + `
      ` + er("diagonal", e.diagonal) + `
    </border>`;
}
var Cl = {};
function dh(e, t) {
  var n = [], r = [];
  hh(e, function(s, u) {
    var c = {
      _source: s,
      index: u,
      height: s.height,
      level: s.level,
      cells: []
    };
    n.push(c), r[u] = c;
  });
  for (var o = Di(n).slice(0), i = {
    rowData: n,
    rowsByIndex: r,
    mergedCells: t
  }, a = 0; a < o.length; a++)
    vh(o[a], i), delete o[a]._source;
  return Di(n);
}
function hh(e, t) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    if (r) {
      var o = r.index;
      typeof o != "number" && (o = n), t(r, o);
    }
  }
}
function Di(e) {
  return e.sort(function(t, n) {
    return t.index - n.index;
  });
}
function ph(e, t) {
  e.indexOf(t) < 0 && e.push(t);
}
function gh(e, t) {
  for (var n = 0; n < e.length; ++n) {
    var r = e[n], o = r.split(":"), i = o[0];
    if (i === t) {
      var a = o[1];
      return i = Cr(i), a = Cr(a), {
        rowSpan: a.row - i.row + 1,
        colSpan: a.col - i.col + 1
      };
    }
  }
}
function Cr(e) {
  function t(o) {
    for (var i = o.toUpperCase(), a = 0, s = 0; s < i.length; ++s)
      a = a * 26 + i.charCodeAt(s) - 64;
    return a - 1;
  }
  function n(o) {
    return parseInt(o, 10) - 1;
  }
  var r = /^([a-z]+)(\d+)$/i.exec(e);
  return {
    row: n(r[2]),
    col: t(r[1])
  };
}
function Dr(e) {
  return Math.round(e * 9525);
}
function vh(e, t) {
  var n = e._source, r = e.index, o = n.cells, i = e.cells;
  if (o)
    for (var a = 0; a < o.length; a++) {
      var s = o[a] || Cl, u = s.rowSpan || 1, c = s.colSpan || 1, f = mh(i, s), d = Xt(r, f);
      if (u === 1 && c === 1) {
        var h = gh(t.mergedCells, d);
        h && (c = h.colSpan, u = h.rowSpan);
      }
      if (Ai(s, i, f, c), (u > 1 || c > 1) && ph(
        t.mergedCells,
        d + ":" + Xt(
          r + u - 1,
          f + c - 1
        )
      ), u > 1)
        for (var m = r + 1; m < r + u; m++) {
          var g = t.rowsByIndex[m];
          g || (g = t.rowsByIndex[m] = { index: m, cells: [] }, t.rowData.push(g)), Ai(s, g.cells, f - 1, c + 1);
        }
    }
}
function mh(e, t) {
  var n;
  return typeof t.index == "number" ? (n = t.index, bl(e, t, t.index)) : n = yh(e, t), n;
}
function bl(e, t, n) {
  e[n] = t;
}
function yh(e, t) {
  for (var n = e.length, r = 0; r < e.length + 1; r++)
    if (!e[r]) {
      e[r] = t, n = r;
      break;
    }
  return n;
}
function Ai(e, t, n, r) {
  for (var o = 1; o < r; o++) {
    var i = {
      borderTop: e.borderTop,
      borderRight: e.borderRight,
      borderBottom: e.borderBottom,
      borderLeft: e.borderLeft
    };
    bl(t, i, n + o);
  }
}
var Ch = function(e) {
  var t = e.ref, n = e.columns, r = e.generators;
  return `
<autoFilter ref="` + t + `">
  ` + re(n, function(o) {
    return `
    <filterColumn colId="` + o.index + `">
      ` + r[o.filter](o) + `
    </filterColumn>
  `;
  }) + `
</autoFilter>`;
}, bh = function(e) {
  var t = e.logic, n = e.criteria;
  return `
<customFilters ` + (t === "and" ? 'and="1"' : "") + `>
` + re(n, function(r) {
    var o = Nt.customOperator(r), i = Nt.customValue(r);
    return "<customFilter " + (o ? 'operator="' + o + '"' : "") + ' val="' + i + '"/>';
  }) + `
</customFilters>`;
}, xh = function(e) {
  var t = e.type;
  return '<dynamicFilter type="' + Nt.dynamicFilterType(t) + '" />';
}, wh = function(e) {
  var t = e.type, n = e.value;
  return '<top10 percent="' + (/percent$/i.test(t) ? 1 : 0) + `"
       top="` + (/^top/i.test(t) ? 1 : 0) + `"
       val="` + n + '" />';
}, _h = function(e) {
  var t = e.blanks, n = e.values;
  return "<filters " + (t ? 'blank="1"' : "") + `>
    ` + re(n, function(r) {
    return `
      <filter val="` + r + '" />';
  }) + `
  </filters>`;
};
function Nt(e) {
  return Ch({
    ref: e.ref,
    columns: e.columns,
    generators: {
      custom: bh,
      dynamic: xh,
      top: wh,
      value: _h
    }
  });
}
Nt.customOperator = function(e) {
  return {
    eq: "equal",
    gt: "greaterThan",
    gte: "greaterThanOrEqual",
    lt: "lessThan",
    lte: "lessThanOrEqual",
    ne: "notEqual",
    // These are not in the spec, but seems to be how Excel does
    // it (see customValue below).  For the non-negated versions,
    // the operator attribute is missing completely.
    doesnotstartwith: "notEqual",
    doesnotendwith: "notEqual",
    doesnotcontain: "notEqual",
    doesnotmatch: "notEqual"
  }[e.operator.toLowerCase()];
};
function Eh(e) {
  return /^\'/.test(e) || /^[a-z_][a-z0-9_]*$/i.test(e) ? e : "'" + e.replace(/\x27/g, "\\'") + "'";
}
Nt.customValue = function(e) {
  function t(n) {
    return n.replace(/([*?])/g, "~$1");
  }
  switch (e.operator.toLowerCase()) {
    case "startswith":
    case "doesnotstartwith":
      return t(e.value) + "*";
    case "endswith":
    case "doesnotendwith":
      return "*" + t(e.value);
    case "contains":
    case "doesnotcontain":
      return "*" + t(e.value) + "*";
    default:
      return e.value;
  }
};
Nt.dynamicFilterType = function(e) {
  return {
    quarter1: "Q1",
    quarter2: "Q2",
    quarter3: "Q3",
    quarter4: "Q4",
    january: "M1",
    february: "M2",
    march: "M3",
    april: "M4",
    may: "M5",
    june: "M6",
    july: "M7",
    august: "M8",
    september: "M9",
    october: "M10",
    november: "M11",
    december: "M12"
  }[e.toLowerCase()] || e;
};
var fo = globalThis && globalThis.__assign || function() {
  return fo = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, fo.apply(this, arguments);
}, bn = function(e, t, n) {
  var r = function(o) {
    n(t, o);
    var i = Pl(l.createElement(e, fo({}, t))), a = Number(i);
    return isNaN(a) ? i : a;
  };
  return r;
}, Ih = function(e, t) {
  e.$implicit = e.group = t, e.field = t.field, e.value = t.value, e.aggregates = t.aggregates;
}, kh = function(e, t) {
  e.group = t.group, e.$implicit = e.aggregates = t;
}, Oh = function(e, t) {
}, Sh = function(e) {
  var t = [], n = 0, r = function(o, i, a) {
    o.forEach(function(s) {
      if (s.level === a) {
        var u = new Ph(s, n);
        if (i.push(u), s.children && s.children.length > 1) {
          var c = u.columns = [];
          r(s.children, c, a + 1);
        } else
          n++;
      }
    });
  };
  return r(e, t, 0), t;
}, Ph = (
  /** @class */
  function() {
    function e(t, n) {
      this.columns = null, this.title = t.title, this.field = t.field, this.hidden = t.hidden, this.locked = t.locked, this.width = t.width, this.headerCellOptions = t.headerCellOptions, this.cellOptions = t.cellOptions, this.groupHeaderCellOptions = t.groupHeaderCellOptions, this.groupFooterCellOptions = t.groupFooterCellOptions, this.footerCellOptions = t.footerCellOptions, t.footer && (this.footerTemplate = bn(t.footer, {
        $implicit: t,
        column: t,
        columnIndex: n
      }, Oh)), t.groupFooter && (this.groupFooterTemplate = bn(t.groupFooter, {
        column: t,
        field: t.field
      }, kh)), t.groupHeader && (this.groupHeaderTemplate = bn(t.groupHeader, {}, Ih));
    }
    return e;
  }()
), Th = function(e) {
  return Math.max.apply(Math, e.map(function(t) {
    return t.level;
  })) + 1;
}, Rh = function(e) {
  var t = Sh(e.columns), n = new Uf({
    columns: t,
    data: e.data,
    filterable: e.filterable,
    groups: e.group,
    paddingCellOptions: e.paddingCellOptions,
    headerPaddingCellOptions: e.headerPaddingCellOptions,
    hierarchy: e.hierarchy ? { depth: Th(e.data), itemLevel: function(o) {
      return o.level;
    } } : null,
    collapsible: e.collapsible
  }), r = n.workbook();
  return r.creator = e.creator, r.date = e.date, r.rtl = e.dir === "rtl", r;
}, Dh = function(e) {
  var t = new _r(e);
  return t.toDataURL();
}, Ah = function(e) {
  return e && e.sheets;
}, xn = {
  name: "@progress/kendo-react-excel-export",
  productName: "KendoReact",
  productCodes: ["KENDOUIREACT", "KENDOUICOMPLETE"],
  publishDate: 1697039893,
  version: "",
  licensingDocsUrl: "https://www.telerik.com/kendo-react-ui/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-warning"
}, Mh = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), $t = globalThis && globalThis.__assign || function() {
  return $t = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, $t.apply(this, arguments);
}, Fh = (
  /** @class */
  function(e) {
    Mh(t, e);
    function t(n) {
      var r = e.call(this, n) || this;
      if (r.saveFile = function(i) {
        kl(i, r.props.fileName, {
          forceProxy: r.props.forceProxy,
          proxyURL: r.props.proxyURL
        });
      }, r.extractColumns = function(i, a) {
        return a === void 0 && (a = 0), Array.isArray(i) ? i.map(function(s) {
          return r.extractChild(s, a);
        }) : [i, r.extractChild(i, a)];
      }, r.extractChild = function(i, a) {
        return a === void 0 && (a = 0), l.isValidElement(i) ? $t($t({}, i.props), { width: i.props.width && parseInt("".concat(i.props.width), 10), level: a, children: i.props.children && r.extractColumns(i.props.children, a + 1) }) : $t($t({}, i), { level: a, children: i.children && r.extractColumns(i.children, a + 1) });
      }, r.getExportData = function(i) {
        var a;
        return i ? Array.isArray(i) ? a = {
          data: i
        } : a = i : a = {
          data: r.props.data,
          group: r.props.group
        }, a;
      }, typeof Fr < "u")
        ho(xn);
      else {
        var o = "License activation failed for ".concat(xn.name, `
`);
        o += `The @progress/kendo-licensing script is not loaded.
`, o += "See ".concat(xn.licensingDocsUrl, ` for more information.
`), console.warn(o);
      }
      return r.save = r.save.bind(r), r.toDataURL = r.toDataURL.bind(r), r.workbookOptions = r.workbookOptions.bind(r), r;
    }
    return t.prototype.save = function(n, r) {
      var o = this;
      this.toDataURL(n, r).then(function() {
        for (var i = [], a = 0; a < arguments.length; a++)
          i[a] = arguments[a];
        o.props.onExportComplete && o.props.onExportComplete.call(void 0, { target: o }), o.saveFile.apply(o, i);
      });
    }, t.prototype.toDataURL = function(n, r) {
      var o = Ah(n) ? n : this.workbookOptions(n, r);
      return Dh(o);
    }, t.prototype.workbookOptions = function(n, r) {
      var o = this.getExportData(n), i = this.props.children, a = i && i.type && i.type.displayName === "KendoReactGrid" && i.props && l.Children.toArray(i.props.children), s = this.extractColumns(a || r || this.props.columns || l.Children.toArray(i)), u = Rh({
        columns: s,
        data: o.data,
        group: o.group,
        filterable: this.props.filterable,
        creator: this.props.creator,
        date: this.props.date,
        dir: this.props.dir,
        hierarchy: this.props.hierarchy,
        paddingCellOptions: this.props.paddingCellOptions,
        headerPaddingCellOptions: this.props.headerPaddingCellOptions,
        collapsible: this.props.collapsible
      });
      return u;
    }, t.prototype.render = function() {
      return this.props.children || null;
    }, t.propTypes = {
      children: p.any,
      columns: p.arrayOf(p.any),
      creator: p.string,
      data: p.any,
      date: p.any,
      filterable: p.bool,
      fileName: p.string,
      forceProxy: p.bool,
      group: p.any,
      headerPaddingCellOptions: p.any,
      paddingCellOptions: p.any,
      proxyURL: p.string,
      dir: p.string,
      hierarchy: p.bool,
      collapsible: p.bool
    }, t.defaultProps = {
      fileName: "Export.xlsx",
      forceProxy: !1,
      collapsible: !1
    }, t;
  }(l.Component)
), Mr = {};
(function(e) {
  var t;
  Object.defineProperty(e, "__esModule", { value: !0 }), e.pagerMessagesMap = e.messages = e.detailCollapse = e.detailExpand = e.groupCollapse = e.groupExpand = e.groupPanelAriaLabel = e.filterAriaLabel = e.sortAriaLabel = e.filterSelectedItems = e.filterChooseOperator = e.filterCheckAll = e.searchPlaceholder = e.sortDescending = e.sortAscending = e.filterTitle = e.filterSubmitButton = e.filterClearButton = e.columnMenu = e.ungroupColumn = e.groupColumn = e.groupPanelEmpty = e.pagerTotalPages = e.pagerOf = e.pagerPage = e.pagerItemPerPage = e.pagerLastPage = e.pagerNextPage = e.pagerPreviousPage = e.pagerFirstPage = e.pagerInfo = e.noRecords = void 0, e.noRecords = "grid.noRecords", e.pagerInfo = "grid.pagerInfo", e.pagerFirstPage = "grid.pagerFirstPage", e.pagerPreviousPage = "grid.pagerPreviousPage", e.pagerNextPage = "grid.pagerNextPage", e.pagerLastPage = "grid.pagerLastPage", e.pagerItemPerPage = "grid.pagerItemsPerPage", e.pagerPage = "grid.pagerPage", e.pagerOf = "grid.pagerOf", e.pagerTotalPages = "grid.pagerTotalPages", e.groupPanelEmpty = "grid.groupPanelEmpty", e.groupColumn = "grid.groupColumn", e.ungroupColumn = "grid.ungroupColumn", e.columnMenu = "grid.columnMenu", e.filterClearButton = "grid.filterClearButton", e.filterSubmitButton = "grid.filterSubmitButton", e.filterTitle = "grid.filterTitle", e.sortAscending = "grid.sortAscending", e.sortDescending = "grid.sortDescending", e.searchPlaceholder = "grid.searchPlaceholder", e.filterCheckAll = "grid.filterCheckAll", e.filterChooseOperator = "grid.filterChooseOperator", e.filterSelectedItems = "grid.filterSelectedItems", e.sortAriaLabel = "grid.sortAriaLabel", e.filterAriaLabel = "grid.filterAriaLabel", e.groupPanelAriaLabel = "grid.groupPanelAriaLabel", e.groupExpand = "grid.groupExpand", e.groupCollapse = "grid.groupCollapse", e.detailExpand = "grid.detailExpand", e.detailCollapse = "grid.detailCollapse", e.messages = (t = {}, t[e.detailExpand] = "Expand detail row", t[e.detailCollapse] = "Collapse detail row", t[e.groupExpand] = "Expand group", t[e.groupCollapse] = "Collapse Group", t[e.noRecords] = "No records available", t[e.groupPanelEmpty] = "Drag a column header and drop it here to group by that column", t[e.filterClearButton] = "Clear", t[e.filterSubmitButton] = "Filter", t[e.filterTitle] = "Filter", t[e.sortAscending] = "Sort Ascending", t[e.sortDescending] = "Sort Descending", t[e.sortAriaLabel] = "Sortable", t[e.groupColumn] = "Group Column", t[e.ungroupColumn] = "Ungroup Column", t[e.columnMenu] = "Column menu", t[e.pagerItemPerPage] = "items per page", t[e.pagerInfo] = "{0} - {1} of {2} items", t[e.pagerFirstPage] = "Go to the first page", t[e.pagerPreviousPage] = "Go to the previous page", t[e.pagerNextPage] = "Go to the next page", t[e.pagerLastPage] = "Go to the last page", t[e.pagerPage] = "Page", t[e.pagerOf] = "of", t[e.pagerTotalPages] = "{0}", t[e.searchPlaceholder] = "Search", t[e.filterCheckAll] = "Check All", t[e.filterChooseOperator] = "Choose Operator", t[e.filterSelectedItems] = "selected items", t[e.filterAriaLabel] = "Filter", t[e.groupPanelAriaLabel] = "Group panel", t["grid.filterEqOperator"] = "Is equal to", t["grid.filterNotEqOperator"] = "Is not equal to", t["grid.filterIsNullOperator"] = "Is null", t["grid.filterIsNotNullOperator"] = "Is not null", t["grid.filterIsEmptyOperator"] = "Is empty", t["grid.filterIsNotEmptyOperator"] = "Is not empty", t["grid.filterStartsWithOperator"] = "Starts with", t["grid.filterContainsOperator"] = "Contains", t["grid.filterNotContainsOperator"] = "Does not contain", t["grid.filterEndsWithOperator"] = "Ends with", t["grid.filterGteOperator"] = "Is greater than or equal to", t["grid.filterGtOperator"] = "Is greater than", t["grid.filterLteOperator"] = "Is less than or equal to", t["grid.filterLtOperator"] = "Is less than", t["grid.filterIsTrue"] = "Is true", t["grid.filterIsFalse"] = "Is false", t["grid.filterBooleanAll"] = "(All)", t["grid.filterAfterOrEqualOperator"] = "Is after or equal to", t["grid.filterAfterOperator"] = "Is after", t["grid.filterBeforeOperator"] = "Is before", t["grid.filterBeforeOrEqualOperator"] = "Is before or equal to", t["grid.filterAndLogic"] = "And", t["grid.filterOrLogic"] = "Or", t);
  function n(r) {
    var o = r.replace(/^pager\.([a-z])/, function(i, a) {
      return "grid.pager" + a.toUpperCase();
    });
    return { messageKey: o, defaultMessage: e.messages[o] };
  }
  e.pagerMessagesMap = n;
})(Mr);
class Nh extends l.Component {
  constructor() {
    super(...arguments);
    /** @hidden */
    Te(this, "state", {
      show: !1
    });
    /** @hidden */
    Te(this, "_anchor", null);
    /** @hidden */
    Te(this, "_content", null);
    /** @hidden */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Te(this, "blurTimeout");
    /** @hidden */
    Te(this, "willBlur", !1);
    /** @hidden */
    Te(this, "blur", () => {
      if (this.willBlur) {
        this.willBlur = !1;
        return;
      }
      clearTimeout(this.blurTimeout), this.blurTimeout = window.setTimeout(() => {
        this.closeMenu();
      });
    });
    /** @hidden */
    Te(this, "focus", () => {
      clearTimeout(this.blurTimeout);
    });
    /** @hidden */
    Te(this, "anchorClick", (n) => {
      n.preventDefault(), this.setState(
        {
          show: !this.state.show
        },
        () => this.state.show && this._content && this._content.focus()
      );
    });
    /** @hidden */
    Te(this, "closeMenu", () => {
      this.setState({ show: !1 });
    });
    /** @hidden */
    Te(this, "onAnchorMouseDown", (n) => {
      this.willBlur = this.state.show && n.currentTarget === this._anchor;
    });
  }
  render() {
    const { columnMenu: n, ...r } = this.props, { column: o } = this.props, i = We(this), a = o.field ? `${o.field} ` : "";
    return /* @__PURE__ */ O.jsxs(O.Fragment, { children: [
      /* @__PURE__ */ O.jsx(
        "a",
        {
          className: "k-grid-header-menu k-grid-column-menu",
          ref: (s) => this._anchor = s,
          onClick: this.anchorClick,
          onMouseDown: this.onAnchorMouseDown,
          href: "#",
          title: `${a}${i.toLanguageString(Mr.columnMenu, Mr.messages[Mr.columnMenu])}`,
          children: /* @__PURE__ */ O.jsx(Tl, { name: "filter", icon: Qr })
        }
      ),
      /* @__PURE__ */ O.jsx(Li, { anchor: this._anchor, show: this.state.show, children: /* @__PURE__ */ O.jsx(
        "div",
        {
          ref: (s) => this._content = s,
          className: "k-grid-columnmenu-popup",
          tabIndex: 0,
          onBlur: this.blur,
          onFocus: this.focus,
          style: { outline: "none" },
          children: n && /* @__PURE__ */ O.jsx(n, { ...r, onCloseMenu: this.closeMenu })
        }
      ) })
    ] });
  }
}
class Lh extends l.Component {
  /**
   * @hidden
   */
  render() {
    const { columnMenuWrapperProps: t } = this.props, n = this.props.onClick ? {
      onClick: this.props.onClick
    } : {}, r = /* @__PURE__ */ O.jsxs("span", { className: "k-cell-inner", children: [
      /* @__PURE__ */ O.jsxs(
        "span",
        {
          className: Nr("k-link", {
            "!k-cursor-default": !this.props.columnMenuWrapperProps.sortable
          }),
          ...n,
          children: [
            /* @__PURE__ */ O.jsx("span", { className: "k-column-title", children: this.props.title || this.props.field || " " }),
            this.props.children
          ]
        }
      ),
      t.columnMenu && /* @__PURE__ */ O.jsx(Nh, { ...t })
    ] });
    return this.props.render ? this.props.render.call(void 0, r, this.props) : r;
  }
}
const jh = (e) => {
  var a, s, u;
  const t = l.useRef(null), [n, r] = l.useState(!1), [o, i] = l.useState(e.columns);
  return l.useEffect(() => {
    const c = (f) => {
      const d = document.querySelector(".configurator-wrap-element");
      d && !d.contains(f.target) && r(!1);
      const h = document.querySelector(".configurator-wrap-button");
      h && !h.contains(f.target) && r(!n);
    };
    return window.addEventListener("mousedown", c), () => window.removeEventListener("mousedown", c);
  }, [n]), /* @__PURE__ */ O.jsxs("div", { children: [
    /* @__PURE__ */ O.jsx("span", { ref: t, className: "configurator-wrap-element-button", children: /* @__PURE__ */ O.jsx(
      lr,
      {
        ...e.buttonProps,
        title: ((a = e.buttonProps) == null ? void 0 : a.title) ?? "Columns",
        fillMode: ((s = e.buttonProps) == null ? void 0 : s.fillMode) ?? "outline",
        onClick: () => r(!n),
        children: ((u = e.buttonProps) == null ? void 0 : u.title) ?? "Columns"
      }
    ) }),
    /* @__PURE__ */ O.jsxs(
      Kl,
      {
        style: { marginTop: "1rem" },
        show: n,
        anchor: t.current,
        title: "Show/Hide Columns",
        position: "bottom",
        callout: !1,
        children: [
          /* @__PURE__ */ O.jsx("div", { className: "configurator-wrap-element", style: { width: 220, display: "flex", flexDirection: "column" }, children: o == null ? void 0 : o.map((c, f) => /* @__PURE__ */ O.jsx(
            Wl,
            {
              checked: (c == null ? void 0 : c.visible) !== !1,
              label: c == null ? void 0 : c.title,
              disabled: (o == null ? void 0 : o.filter((d) => d.visible === !0).length) === 1 && c.visible === !0,
              onChange: () => {
                var h;
                const d = [...e.columns];
                d[f].visible = !((h = e.columns[f]) != null && h.visible), i(d);
              }
            },
            f
          )) }),
          /* @__PURE__ */ O.jsxs("div", { style: { display: "flex", justifyContent: "flex-end" }, children: [
            /* @__PURE__ */ O.jsx(lr, { onClick: () => e.setColumns(o), children: "Save" }),
            /* @__PURE__ */ O.jsx(lr, { themeColor: "secondary", onClick: () => r(!1), children: "Cancel" })
          ] })
        ]
      }
    )
  ] });
}, zh = (e) => /* @__PURE__ */ O.jsx(Bh, { ...e }), Hh = (e, t) => {
  const n = {};
  t.dataItem.locked && (n.style = {
    top: t.getTop(t.dataItem),
    bottom: t.getBottom(t.dataItem),
    ...t.style
  }, n.className = t.className + " k-grid-row-sticky");
  const r = e;
  return r ? (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    l.cloneElement(r, { ...r.props, ...n }, r.props.children)
  ) : /* @__PURE__ */ O.jsx(O.Fragment, {});
}, Bh = (e) => {
  const t = e.style;
  let n = e.className;
  return e.dataItem.locked && (t && (t.top = e.getTop(e.dataItem)), t && (t.bottom = e.getBottom(e.dataItem)), n += " k-grid-row-sticky"), /* @__PURE__ */ O.jsx("td", { style: { textAlign: "center", ...t }, className: n, onClick: () => e.onClick(e.dataItem), children: e.dataItem.locked ? /* @__PURE__ */ O.jsx("span", { className: "k-icon k-i-pin" }) : /* @__PURE__ */ O.jsx("span", { className: "k-icon k-i-unpin" }) });
}, Mi = "...";
class Gh extends l.Component {
  constructor() {
    super(...arguments);
    Te(this, "handlePageChange", (n, r) => {
      n.preventDefault(), this.props.pageChange(r, n);
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Te(this, "handleSelectPageChange", (n) => {
      n.preventDefault(), this.props.pageChange(n.target.value, n);
    });
  }
  render() {
    const n = this.start > 1 && this.renderDots(this.start - 1, "pagerMoreButtonAriaLabel"), r = this.end < this.props.totalPages && this.renderDots(this.end + 1, "pagerMoreButtonAriaLabel"), o = this.start > 1 && this.renderOptionDots(this.start - 1), i = this.end < this.props.totalPages && this.renderOptionDots(this.end + 1), a = [];
    for (let c = this.start; c <= this.end; c++)
      a.push(c);
    const s = a.map((c) => /* @__PURE__ */ O.jsx(
      nt,
      {
        className: Nr({ "k-selected": this.props.currentPage === c }),
        fillMode: "flat",
        themeColor: "primary",
        size: this.props.size,
        rounded: null,
        role: "button",
        "aria-label": "localizationService.toLanguageString(pageNumberLabelMessage.messageKey,pageNumberLabelMessage.defaultMessage,)" + c,
        "aria-current": this.props.currentPage === c ? !0 : void 0,
        onClick: (f) => this.handlePageChange(f, c),
        children: c
      },
      c
    )), u = a.map((c) => /* @__PURE__ */ O.jsx("option", { children: c }, c));
    return /* @__PURE__ */ O.jsxs(O.Fragment, { children: [
      /* @__PURE__ */ O.jsxs(
        "select",
        {
          className: Nr("k-picker k-dropdown-list k-dropdown k-rounded-md", {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            [`k-picker-${Rl.sizeMap[this.props.size] || this.props.size}`]: this.props.size
          }),
          "aria-label": "localizationService.toLanguageString(mobileSelectMessage.messageKey,mobileSelectMessage.defaultMessage,)",
          value: this.props.currentPage,
          onChange: (c) => this.handleSelectPageChange(c),
          children: [
            o,
            u,
            i
          ]
        }
      ),
      /* @__PURE__ */ O.jsxs("div", { className: "k-pager-numbers", children: [
        n,
        s,
        r
      ] })
    ] });
  }
  get end() {
    return Math.min(this.start + this.props.buttonCount - 1, this.props.totalPages);
  }
  get start() {
    const n = this.props.currentPage, r = this.props.buttonCount;
    if (n > r) {
      const o = n % r;
      return o === 0 ? n - r + 1 : n - o + 1;
    }
    return 1;
  }
  renderDots(n, r) {
    return /* @__PURE__ */ O.jsx(
      nt,
      {
        fillMode: "flat",
        themeColor: "primary",
        size: this.props.size,
        rounded: null,
        role: "button",
        "aria-label": r,
        onClick: (o) => this.handlePageChange(o, n),
        children: Mi
      }
    );
  }
  renderOptionDots(n) {
    return /* @__PURE__ */ O.jsx("option", { value: n, children: Mi });
  }
}
const Uh = (e) => /* @__PURE__ */ O.jsx(O.Fragment, { children: e.buttonCount ? /* @__PURE__ */ O.jsx(
  "div",
  {
    className: "k-pager k-pager-md k-grid-pager",
    style: { display: "flex", justifyContent: "center", width: "100%", overflowX: "auto" },
    children: /* @__PURE__ */ O.jsx(Fi, { ...e })
  }
) : /* @__PURE__ */ O.jsx("div", { children: /* @__PURE__ */ O.jsx(Fi, { ...e }) }) }), Fi = (e) => {
  const t = Math.floor(e.skip / e.take) + 1, n = Math.ceil((e.total || 0) / e.take), r = e.dir === "rtl", o = (f, d) => {
    e.onPageChange && f > 0 && f <= n && e.onPageChange({
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      target: void 0,
      skip: (f - 1) * e.take,
      take: e.take,
      syntheticEvent: d,
      nativeEvent: d.nativeEvent,
      targetEvent: d
    });
  }, i = (f, d, h, m, g, y) => /* @__PURE__ */ O.jsx(
    nt,
    {
      fillMode: "flat",
      themeColor: "base",
      size: e.size,
      rounded: null,
      className: d,
      icon: m,
      svgIcon: g,
      title: h,
      role: "button",
      "aria-disabled": y,
      onClick: (w) => {
        w.preventDefault(), o(f, w);
      }
    }
  );
  let a, s, u, c;
  return e.previousNext && (a = i(
    1,
    "k-pager-nav k-pager-first" + (t === 1 ? " k-disabled" : ""),
    "",
    r ? "caret-alt-to-right" : "caret-alt-to-left",
    r ? Ho : Bo,
    t === 1 ? !0 : void 0
  ), s = i(
    t - 1,
    "k-pager-nav" + (t === 1 ? " k-disabled" : ""),
    "",
    r ? "caret-alt-right" : "caret-alt-left",
    r ? jr : Lr,
    t === 1 ? !0 : void 0
  ), u = i(
    t + 1,
    "k-pager-nav" + (t >= n ? " k-disabled" : ""),
    "",
    r ? "caret-alt-left" : "caret-alt-right",
    r ? Lr : jr,
    t >= n ? !0 : void 0
  ), c = i(
    n,
    "k-pager-nav k-pager-last" + (t >= n ? " k-disabled" : ""),
    "",
    r ? "caret-alt-to-left" : "caret-alt-to-right",
    r ? Bo : Ho,
    t >= n ? !0 : void 0
  )), /* @__PURE__ */ O.jsxs("div", { className: "r-grid-pager-inner-root", children: [
    /* @__PURE__ */ O.jsx(
      "div",
      {
        className: "r-grid-pager-inner-side",
        style: {
          display: !e.isToolbar || e.pageSizes ? "flex" : "none",
          flex: e.isToolbar ? void 0 : "1 1 0px",
          justifyContent: "flex-start"
        },
        children: e.pageSizes && /* @__PURE__ */ O.jsxs("div", { className: "r-grid-pager-inner-pageSizes", children: [
          /* @__PURE__ */ O.jsx("span", { id: "page-sizes", style: { paddingRight: "0.5rem" }, children: "Rows per page:" }),
          /* @__PURE__ */ O.jsx(
            Vl,
            {
              ariaLabelledBy: "page-sizes",
              style: { width: "auto" },
              data: e.pageSizes,
              value: e.take,
              onChange: (f) => {
                e.onPageChange && e.onPageChange({
                  skip: 0,
                  take: parseInt(f.target.value, 10)
                });
              }
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ O.jsx(
      "div",
      {
        style: {
          display: !e.isToolbar || e.showPager ? "flex" : "none",
          flex: e.isToolbar ? void 0 : "1 1 0px",
          justifyContent: "center"
        },
        children: e.showPager && /* @__PURE__ */ O.jsxs("div", { className: Nr("k-pager-numbers-wrap", ""), children: [
          a,
          s,
          /* @__PURE__ */ O.jsx(
            Gh,
            {
              buttonCount: e.buttonCount || 0,
              totalPages: n,
              currentPage: t,
              pageChange: o,
              messagesMap: e.messagesMap,
              size: e.size
            }
          ),
          u,
          c
        ] })
      }
    ),
    /* @__PURE__ */ O.jsx(
      "div",
      {
        className: "r-grid-pager-inner-side",
        style: {
          display: !e.isToolbar || e.info !== !1 ? "flex" : "none",
          flex: e.isToolbar ? void 0 : "1 1 0px",
          justifyContent: "flex-end"
        },
        children: e.info !== !1 && /* @__PURE__ */ O.jsxs("div", { className: "r-grid-pager-inner-info", style: { display: "flex", alignItems: "center" }, children: [
          (e.skip ?? 0) + 1,
          " - ",
          (e.skip ?? 0) + ((e == null ? void 0 : e.take) ?? 0),
          " of ",
          e.total,
          " items"
        ] })
      }
    )
  ] });
};
function Ni(e, t) {
  return wn(e, t);
}
function Gp(e, t) {
  return El(e, t);
}
function xl(e, t) {
  return Il(e, t);
}
const Kh = Ya, Wh = Za, tr = (e, t) => {
  const n = xl(e, t);
  return oc({
    data: n.data,
    group: t.group
  }), n;
}, Up = l.forwardRef(function({ data: t, rowHeight: n = 50, pageable: r, initialDataState: o, ...i }, a) {
  var se, ie, ce, pe, ae, ye, Se;
  const [s, u] = l.useState(
    i.columns.map((P) => P.visible === void 0 ? { ...P, visible: !0 } : P)
  ), [c, f] = l.useState(
    o ?? {
      take: (r == null ? void 0 : r.pageSizeValue) ?? t.length,
      skip: 0,
      group: []
    }
  ), [d, h] = l.useState(tr(t, c)), [m, g] = l.useState(
    Ni(t, { logic: "and", filters: [{ field: "locked", operator: "eq", value: !0 }] })
  ), [y, w] = l.useState([]), [x, b] = l.useState({}), [C, S] = l.useState(!1), T = l.useRef({
    left: 0,
    top: 0
  });
  l.useEffect(() => {
    u(i.columns.map((P) => P.visible === void 0 ? { ...P, visible: !0 } : P));
  }, [i.columns]);
  const _ = l.useRef(null), k = () => {
    _.current !== null && _.current.save(
      xl(t, { filter: c.filter, sort: c.sort }),
      s
    );
  }, H = () => {
    var P, M, U, W, ge, Ne, He;
    return /* @__PURE__ */ O.jsx(
      lr,
      {
        ...(P = i == null ? void 0 : i.toolbarSettings) == null ? void 0 : P.exportExcelButtonProps,
        title: ((U = (M = i == null ? void 0 : i.toolbarSettings) == null ? void 0 : M.exportExcelButtonProps) == null ? void 0 : U.title) ?? "Export Excel",
        fillMode: ((ge = (W = i == null ? void 0 : i.toolbarSettings) == null ? void 0 : W.exportExcelButtonProps) == null ? void 0 : ge.fillMode) ?? "outline",
        onClick: k,
        children: ((He = (Ne = i == null ? void 0 : i.toolbarSettings) == null ? void 0 : Ne.exportExcelButtonProps) == null ? void 0 : He.title) ?? "Export Excel"
      }
    );
  }, L = l.useCallback(
    (P) => {
      const M = tr(t, P.dataState);
      h(M), f(P.dataState);
    },
    [t]
  ), B = l.useCallback(
    (P) => {
      const M = i.detail ? t.map((W) => (W === P.dataItem && (W.expanded = !P.dataItem.expanded), W)) : t, U = P.dataItem;
      if (U.groupId) {
        const W = P.value ? y.filter((ge) => ge !== U.groupId) : [...y, U.groupId];
        w(W);
      }
      h(tr(M, c));
    },
    [y, t, c, i.detail]
  ), F = (P) => m.findIndex((U) => P === U) * n, G = (P) => {
    const M = m.findIndex((W) => P === W);
    return (m.length - M - 1) * n;
  }, Z = (P) => {
    const M = t.findIndex((W) => W === P), U = [...t];
    U[M].locked = !U[M].locked, h(tr(U, c)), g(Ni(U, { logic: "and", filters: [{ field: "locked", operator: "eq", value: !0 }] }));
  }, ee = (P) => {
    const M = P.columns, U = M.findIndex((W) => W.id === "lockColumn");
    U !== -1 && M.splice(U, 1), u(M.sort((W, ge) => (W.orderIndex ?? 0) - (ge.orderIndex ?? 1)));
  }, D = l.useCallback(
    (P) => {
      if (i.selectable) {
        const M = pc({
          event: P,
          selectedState: x,
          dataItemKey: i.selectable.dataItemKey
        }), U = Dl(i.selectable.dataItemKey), W = t.map((ge) => {
          const Ne = ge;
          return { ...Ne, selected: M[U(Ne)] };
        });
        b(M), h(tr(W, c));
      }
    },
    [t, c, i.selectable, x]
  ), N = l.useCallback(
    (P) => {
      var M;
      E(P.syntheticEvent), (M = i.contextMenuProps) != null && M.handleContextMenu && i.contextMenuProps.handleContextMenu(P);
    },
    [i.contextMenuProps]
  ), E = (P) => {
    P.preventDefault(), T.current = {
      left: P.pageX,
      top: P.pageY
    }, S(!0);
  }, j = () => {
    S(!1);
  }, X = ic({
    data: d.data,
    collapsedIds: y
  });
  return /* @__PURE__ */ O.jsxs(Fh, { ref: _, children: [
    /* @__PURE__ */ O.jsxs(
      Sf,
      {
        style: i.style,
        size: i.size,
        pageable: r,
        groupable: i.groupable,
        group: c.group,
        selectable: i.selectable,
        selectedField: "selected",
        lockGroups: i.lockGroups,
        resizable: i.resizable,
        reorderable: i.reorderable,
        onColumnReorder: i.reorderable ? ee : void 0,
        data: i.groupable ? X : d,
        sortable: i.sortable,
        total: d.total,
        detail: i.groupable ? void 0 : i.detail,
        expandField: "expanded",
        cellRender: (P, M) => Hh(P, { ...M, onClick: Z, getTop: F, getBottom: G }),
        cells: i.cells,
        onExpandChange: B,
        onDataStateChange: L,
        onSelectionChange: D,
        onContextMenu: N,
        ref: a,
        ...c,
        children: [
          ((i == null ? void 0 : i.toolbarSettings) || (r == null ? void 0 : r.pageSizes) || (r == null ? void 0 : r.info)) && /* @__PURE__ */ O.jsx(zf, { children: /* @__PURE__ */ O.jsxs("div", { className: "r-grid-toolbar-wrapper", children: [
            (se = i == null ? void 0 : i.toolbarSettings) == null ? void 0 : se.toolbarChildren,
            /* @__PURE__ */ O.jsxs("div", { className: "r-grid-toolbar-buttons", children: [
              (ce = (ie = i == null ? void 0 : i.toolbarSettings) == null ? void 0 : ie.additionalButtons) == null ? void 0 : ce.map((P, M) => /* @__PURE__ */ cn(lr, { ...P, key: M }, P.title)),
              ((pe = i == null ? void 0 : i.toolbarSettings) == null ? void 0 : pe.showExportExcel) && /* @__PURE__ */ O.jsx(H, {}),
              ((ae = i == null ? void 0 : i.toolbarSettings) == null ? void 0 : ae.showColumnsConfigurator) && /* @__PURE__ */ O.jsx(
                jh,
                {
                  columns: s,
                  setColumns: u,
                  buttonProps: (ye = i == null ? void 0 : i.toolbarSettings) == null ? void 0 : ye.columnsConfiguratorButtonProps
                }
              )
            ] }),
            r ? /* @__PURE__ */ O.jsx(
              Uh,
              {
                skip: c.skip ?? 0,
                isToolbar: !0,
                size: i.size,
                showPager: !1,
                take: (c == null ? void 0 : c.take) ?? 0,
                total: d.total,
                info: r.info,
                pageSizes: r == null ? void 0 : r.pageSizes,
                onPageChange: (P) => {
                  L({
                    dataState: { ...c, skip: 0, take: P.take }
                  });
                }
              }
            ) : /* @__PURE__ */ O.jsx(O.Fragment, { children: " " })
          ] }) }),
          (i == null ? void 0 : i.pinnableRows) && !(i != null && i.groupable) && /* @__PURE__ */ O.jsx(
            At,
            {
              field: "locked",
              cell: (P) => /* @__PURE__ */ O.jsx(zh, { ...P, onClick: Z, getTop: F, getBottom: G }),
              title: " ",
              id: "lockColumn",
              width: "65px",
              locked: !0
            }
          ),
          s == null ? void 0 : s.map(
            (P, M) => P.visible !== !1 && /* @__PURE__ */ cn(
              At,
              {
                ...P,
                key: M,
                headerCell: (U) => /* @__PURE__ */ O.jsx(Lh, { ...U })
              }
            )
          )
        ]
      }
    ),
    i.contextMenuProps ? /* @__PURE__ */ O.jsx(
      oa,
      {
        ...i.contextMenuProps,
        show: C,
        offset: T.current,
        onClose: j,
        children: (Se = i.contextMenuProps.items) == null ? void 0 : Se.map((P, M) => /* @__PURE__ */ cn(ta, { ...P, key: M }))
      }
    ) : /* @__PURE__ */ O.jsx(O.Fragment, { children: " " })
  ] });
}), Kp = (e) => /* @__PURE__ */ O.jsx(Kh, { ...e, expanded: !0 }), Wp = (e) => /* @__PURE__ */ O.jsx(Wh, { ...e, data: e == null ? void 0 : e.data, expanded: !0 });
export {
  Kp as ColumnMenu,
  Wp as ColumnMenuCheckBoxFilter,
  Up as Grid,
  Wh as GridColumnMenuCheckboxFilter,
  Kh as GridColumnMenuFilter,
  Ni as filterBy,
  Gp as orderBy,
  xl as process
};
